import {
  Beverage_default
} from "./chunk-H4U3BJSA.jsx";
import {
  Activities_default
} from "./chunk-EC5WL2KK.jsx";
import {
  FoodDrinkDescriptor_default
} from "./chunk-3DUPMNU6.jsx";
import {
  NavigationButtons
} from "./chunk-G74BAM7P.jsx";
import {
  Minus_default
} from "./chunk-7GGVYPHN.jsx";
import {
  GuidedTour_default,
  Skip_default
} from "./chunk-7MP2DW7D.jsx";
import {
  Plus_default
} from "./chunk-XP5DPC6L.jsx";
import {
  isSubsetArray
} from "./chunk-SCT6V7QK.jsx";
import {
  TailedArrow_default
} from "./chunk-DXVDNX64.jsx";
import {
  useSwiperArrows
} from "./chunk-UITBQHRN.jsx";
import {
  formatDurationToString,
  getDurationInHmNotation,
  getIntlTime
} from "./chunk-A5R42X5Q.jsx";
import {
  useCompatibleRouter
} from "./chunk-3M74IZZX.jsx";
import {
  useOnScreen
} from "./chunk-6KGEKMGP.jsx";
import {
  LeftArrow_default,
  RightArrow_default
} from "./chunk-53MMDR7L.jsx";
import {
  ChevronRight_default
} from "./chunk-IWMEQTK2.jsx";
import {
  Image
} from "./chunk-UVV746MP.jsx";
import {
  Conditional
} from "./chunk-AAE3RIHT.jsx";
import {
  __name,
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-DVUTYNGK.jsx";

// src/components/Itinerary/components/TimelineView/components/StopCard/components/Descriptors/components/Descriptor/Descriptor.tsx
import { Text as Text15 } from "@headout/eevee";
import { css as css7 } from "@headout/pixie/css";
import { token as token4 } from "@headout/pixie/tokens";

// src/components/Itinerary/components/TimelineView/components/StopCard/components/Descriptors/components/Descriptor/styles.tsx
import { sva as sva16 } from "@headout/pixie/css";

// src/components/Itinerary/components/TimelineView/components/StopCard/components/Descriptors/styles.tsx
import { cva } from "@headout/pixie/css";

// src/components/Itinerary/components/TimelineView/types.ts
var ETimelineViewComponentVariant = /* @__PURE__ */ ((ETimelineViewComponentVariant2) => {
  ETimelineViewComponentVariant2["Default"] = "DEFAULT";
  ETimelineViewComponentVariant2["ReducedWidth"] = "REDUCED_WIDTH";
  return ETimelineViewComponentVariant2;
})(ETimelineViewComponentVariant || {});

// src/components/Itinerary/components/TimelineView/components/StopCard/components/Descriptors/styles.tsx
var containerStylesRecipe = cva({
  base: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "[1.75rem]"
  },
  variants: {
    variant: {
      ["REDUCED_WIDTH" /* ReducedWidth */]: {
        flexWrap: "wrap",
        gap: "[token(spacing.space.8) token(spacing.space.20)]"
      },
      ["DEFAULT" /* Default */]: {}
    }
  }
});
var descriptorItemOverrideStylesRecipe = cva({
  base: {
    position: "relative",
    "&:not(:last-child)": {
      _after: {
        content: '""',
        height: "[0.25rem]",
        width: "[0.25rem]",
        background: "core.grey.300",
        position: "absolute",
        right: "[-0.875rem]",
        transform: "[translate(50%, 50%)]",
        borderRadius: "[50px]"
      }
    }
  },
  variants: {
    variant: {
      ["REDUCED_WIDTH" /* ReducedWidth */]: {
        "&:not(:last-child)": {
          _after: {
            right: "[-0.65rem]"
          }
        }
      },
      ["DEFAULT" /* Default */]: {}
    }
  }
});

// src/components/Itinerary/components/TimelineView/components/StopCard/components/Descriptors/types.ts
var EDescriptorSize = /* @__PURE__ */ ((EDescriptorSize2) => {
  EDescriptorSize2["Small"] = "small";
  EDescriptorSize2["Large"] = "large";
  return EDescriptorSize2;
})(EDescriptorSize || {});
var EDescriptorType = /* @__PURE__ */ ((EDescriptorType2) => {
  EDescriptorType2["Inclusion"] = "inclusion";
  EDescriptorType2["Location"] = "location";
  EDescriptorType2["Duration"] = "duration";
  EDescriptorType2["Attractions"] = "attractions";
  EDescriptorType2["Activities"] = "activities";
  EDescriptorType2["FoodAndDrinks"] = "foodAndDrinks";
  return EDescriptorType2;
})(EDescriptorType || {});

// src/components/Itinerary/components/TimelineView/components/StopCard/components/Descriptors/Descriptors.tsx
import { css as css6 } from "@headout/pixie/css";

// src/components/Itinerary/components/TimelineView/TimelineView.tsx
import { useEffect as useEffect5, useMemo as useMemo5, useRef as useRef5, useState as useState7 } from "react";

// src/components/Itinerary/Itinerary.tsx
import { useEffect as useEffect2 } from "react";
import dynamic3 from "next/dynamic.js";

// src/components/Itinerary/context.tsx
import { createContext, useContext, useState } from "react";
var itineraryContext = createContext({});
var useItinerary = /* @__PURE__ */ __name(() => useContext(itineraryContext), "useItinerary");
var ItineraryProvider = /* @__PURE__ */ __name(({
  children
}) => {
  const [activeItineraryStopId, setActiveItineraryStopId] = useState(null);
  const [activeStopIndex, setActiveStopIndex] = useState(null);
  const [selectedSubStopId, setSelectedSubStopId] = useState(
    null
  );
  const [
    itinerarySwipeSheetDetailsConfig,
    setItinerarySwipeSheetDetailsConfig
  ] = useState({
    open: false,
    type: "stop"
  });
  const [itineraryViewMode, setItineraryViewMode] = useState("timeline" /* Timeline */);
  const [additionalTrackingProperties, setAdditionalTrackingProperties] = useState(null);
  const { Provider: ItineraryContextProvider } = itineraryContext;
  return <ItineraryContextProvider
    value={{
      activeItineraryStopId,
      setActiveItineraryStopId,
      activeStopIndex,
      setActiveStopIndex,
      selectedSubStopId,
      setSelectedSubStopId,
      itinerarySwipeSheetDetailsConfig,
      setItinerarySwipeSheetDetailsConfig,
      itineraryViewMode,
      setItineraryViewMode,
      additionalTrackingProperties,
      setAdditionalTrackingProperties
    }}
  >
			{children}
		</ItineraryContextProvider>;
}, "ItineraryProvider");

// src/components/Itinerary/components/ItineraryMapViewBanner/styles.tsx
import { sva } from "@headout/pixie/css";
var itineraryMapViewBannerStylesRecipe = sva({
  slots: [
    "root",
    "imageContainer",
    "content",
    "cta",
    "icon",
    "bgImageContainer"
  ],
  base: {
    root: {
      display: "flex",
      alignItems: "center",
      borderRadius: "radius.12",
      backgroundColor: "[#fff8ef]",
      gap: "[1rem]",
      height: "[4.75rem]",
      padding: "[0.25rem 1rem]",
      position: "relative",
      overflow: "hidden"
    },
    imageContainer: {
      overflow: "hidden",
      width: "[3.25rem]",
      height: "[3.25rem]",
      borderRadius: "radius.4",
      boxShadow: "[0 2px 15px 0 rgba(255, 159, 36, 0.3)]",
      zIndex: 1
    },
    content: {
      display: "flex",
      flexDirection: "column",
      gap: "[0.375rem]",
      flex: 1,
      zIndex: 1
    },
    cta: {
      display: "flex",
      gap: "[0.25rem]",
      alignItems: "center",
      background: "transparent",
      border: "none",
      padding: "0"
    },
    icon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginTop: "[0.0625rem]"
    },
    bgImageContainer: {
      position: "absolute",
      top: 0,
      right: 0,
      height: "[100%]",
      zIndex: 0,
      "& img": {
        height: "[100%]",
        width: "[100%]",
        objectFit: "cover"
      }
    }
  }
});

// src/components/Itinerary/components/ItineraryDescriptors/styles.tsx
import { sva as sva2 } from "@headout/pixie/css";
var itineraryDescriptorsContainerStylesRecipe = sva2({
  slots: [
    "root",
    "descriptorIconContainer",
    "descriptorContentContainer",
    "descriptorLabel",
    "descriptorSubtext",
    "descriptorCta"
  ],
  base: {
    root: {
      display: "flex",
      flexDirection: "column"
    },
    descriptorIconContainer: {
      height: "[1.5rem]",
      width: "[1.5rem]",
      borderRadius: "radius.6",
      marginBottom: "space.8",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "core.grey.100",
      "& .icon": {
        height: "[0.75rem]",
        width: "[0.75rem]",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      "@media only screen and (min-width: 768px), print": {
        "& .icon": {
          height: "[1rem]",
          width: "[1rem]"
        }
      }
    },
    descriptorContentContainer: {
      display: "flex",
      flexDirection: "column"
    },
    descriptorLabel: {
      textStyle: "ui.label.extraSmall",
      letterSpacing: "[0.8px]",
      marginBottom: "space.2",
      textTransform: "uppercase",
      "@media only screen and (min-width: 768px), print": {
        textStyle: "ui.label.small",
        letterSpacing: "[0.6px]"
      }
    },
    descriptorSubtext: {
      textStyle: "ui.label.regular",
      whiteSpace: "pre-wrap",
      "@media only screen and (min-width: 768px), print": {
        textStyle: "ui.label.regular"
      }
    },
    descriptorCta: {
      textStyle: "ui.label.underline.medium",
      border: "none",
      background: "transparent",
      padding: 0
    }
  },
  variants: {
    componentType: {
      horizontal: {
        root: {
          "@media only screen and (min-width: 768px), print": {
            flexDirection: "row",
            alignItems: "start"
          }
        },
        descriptorIconContainer: {
          "@media only screen and (min-width: 768px), print": {
            height: "[2.125rem]",
            width: "[2.125rem]",
            margin: "[0 token(spacing.space.8) 0 0]"
          }
        }
      },
      vertical: {
        descriptorIconContainer: {
          "@media only screen and (min-width: 768px), print": {
            height: "[2rem]",
            width: "[2rem]"
          }
        }
      }
    }
  }
});

// src/components/Itinerary/components/ItineraryDescriptors/ItineraryDescriptors.tsx
import { Button, Text } from "@headout/eevee";
var ItineraryDescriptors = /* @__PURE__ */ __name(({
  type,
  itinerary,
  componentType = "vertical",
  lang,
  strings
}) => {
  const additionalMeta = {
    lang,
    strings
  };
  const {
    icon: DescriptorIcon,
    fieldIdentifier,
    fieldTransformer = /* @__PURE__ */ __name((value) => Object.values(value).join(", "), "fieldTransformer"),
    ctaLabel,
    useCTA,
    onCTAClick,
    getIcon,
    getLabel,
    qaMarker
  } = ITINERARY_DESCRIPTORS_DATA[type];
  const getValueObject = /* @__PURE__ */ __name(() => {
    return fieldIdentifier.reduce(
      (prev, curr) => {
        prev[curr] = itinerary.details[curr];
        return prev;
      },
      {
        strings
      }
    );
  }, "getValueObject");
  const valueObject = getValueObject();
  const descriptorLabel = getLabel(valueObject);
  const subtext = fieldTransformer(valueObject, additionalMeta);
  const Icon = getIcon ? getIcon(valueObject) : DescriptorIcon;
  const handleCTAClick = /* @__PURE__ */ __name(() => {
    onCTAClick == null ? void 0 : onCTAClick(valueObject);
  }, "handleCTAClick");
  const itineraryDescriptorsContainerStyles = itineraryDescriptorsContainerStylesRecipe({
    componentType
  });
  return <div
    className={itineraryDescriptorsContainerStyles.root}
    data-qa-marker={qaMarker}
  >
			{Icon && <div
    className={itineraryDescriptorsContainerStyles.descriptorIconContainer}
  >
					<div className='icon'>
						<Icon />
					</div>
				</div>}
			<div
    className={itineraryDescriptorsContainerStyles.descriptorContentContainer}
  >
				<Text
    as='span'
    className={itineraryDescriptorsContainerStyles.descriptorLabel}
    color='core.grey.700'
  >
					{descriptorLabel}
				</Text>
				<Conditional if={!!useCTA && !!ctaLabel}>
					<Button
    as='button'
    btnType='white'
    iconPosition='leading'
    onClick={handleCTAClick}
    primaryText={ctaLabel}
    size='small'
    state='default'
    variant='secondary'
    color='core.grey.800'
    width='fit-content'
    className={itineraryDescriptorsContainerStyles.descriptorCta}
  />
				</Conditional>
				<Conditional if={!useCTA}>
					<Text
    as='span'
    className={itineraryDescriptorsContainerStyles.descriptorSubtext}
    color='core.grey.800'
  >
						{subtext}
					</Text>
				</Conditional>
			</div>
		</div>;
}, "ItineraryDescriptors");

// src/components/Itinerary/constants.ts
import dynamic from "next/dynamic.js";

// src/assets/svgIcons/TransferDescriptor.tsx
var TransferDescriptorSvg = /* @__PURE__ */ __name(() => {
  return <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
			<path
    d='M10.5777 11.4072H5.42183'
    stroke='#444444'
    strokeMiterlimit='10'
  />
			<path
    d='M2.30518 11.4066H2C1.44772 11.4066 1 10.9589 1 10.4066V4.40658C1 3.7034 1.56955 3.13385 2.27273 3.13385H12.9904C13.6936 3.13385 14.2632 3.7034 14.2632 4.40658L14.8837 10.3019C14.9459 10.8923 14.4829 11.4066 13.8892 11.4066H13.6948'
    stroke='#444444'
    strokeMiterlimit='10'
  />
			<path
    d='M3.86373 13.3154C4.74236 13.3154 5.45464 12.6031 5.45464 11.7245C5.45464 10.8459 4.74236 10.1336 3.86373 10.1336C2.98509 10.1336 2.27282 10.8459 2.27282 11.7245C2.27282 12.6031 2.98509 13.3154 3.86373 13.3154Z'
    stroke='#444444'
    strokeMiterlimit='10'
    strokeLinecap='square'
  />
			<path
    d='M12.136 13.3157C13.0147 13.3157 13.7269 12.6034 13.7269 11.7248C13.7269 10.8461 13.0147 10.1339 12.136 10.1339C11.2574 10.1339 10.5451 10.8461 10.5451 11.7248C10.5451 12.6034 11.2574 13.3157 12.136 13.3157Z'
    stroke='#444444'
    strokeMiterlimit='10'
    strokeLinecap='square'
  />
			<path d='M1 7.58871H15' stroke='#444444' strokeMiterlimit='10' />
			<path
    d='M9.84211 3L10.4451 7.58839'
    stroke='#444444'
    strokeMiterlimit='10'
  />
		</svg>;
}, "TransferDescriptorSvg");
var TransferDescriptor_default = TransferDescriptorSvg;

// src/assets/svgIcons/CancelDescriptor.tsx
var CancelDescriptorSvg = /* @__PURE__ */ __name(() => {
  return <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    fill='none'
    viewBox='0 0 16 16'
  >
			<g
    stroke='#444'
    strokeLinecap='round'
    strokeLinejoin='round'
    clipPath='url(#clip0_524_2039)'
  >
				<path d='M7.835 15.588s5.835-2.918 5.835-7.294V3.188L7.835 1 2 3.188v5.106c0 4.376 5.835 7.293 5.835 7.293z' />
				<path d='M11.5 5.5l-4.313 5.556L5 8.758' />
			</g>
			<defs>
				<clipPath id='clip0_524_2039'>
					<path fill='#fff' d='M0 0H16V16H0z' />
				</clipPath>
			</defs>
		</svg>;
}, "CancelDescriptorSvg");
var CancelDescriptor_default = CancelDescriptorSvg;

// src/assets/svgIcons/ClockDescriptor.tsx
var ClockDescriptorSvg = /* @__PURE__ */ __name(() => {
  return <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    fill='none'
    viewBox='0 0 16 16'
  >
			<path
    stroke='#444'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M8 14.667A6.667 6.667 0 108 1.334a6.667 6.667 0 000 13.333z'
  />
			<path
    stroke='#444'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M7.5 4v4l4 2'
  />
		</svg>;
}, "ClockDescriptorSvg");
var ClockDescriptor_default = ClockDescriptorSvg;

// src/assets/svgIcons/QuickDescriptor.tsx
var QuickDescriptorSvg = /* @__PURE__ */ __name(() => {
  return <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    fill='none'
    viewBox='0 0 16 16'
  >
			<path
    stroke='#444'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M8.667 1.333L2 9.334h6l-.667 5.334 6.667-8H8l.667-5.333z'
  />
		</svg>;
}, "QuickDescriptorSvg");
var QuickDescriptor_default = QuickDescriptorSvg;

// src/assets/svgIcons/PhoneDescriptor.tsx
var PhoneDescriptorSvg = /* @__PURE__ */ __name(() => {
  return <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    fill='none'
    viewBox='0 0 16 16'
  >
			<path
    stroke='#444'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M11.334 1.333H4.667c-.737 0-1.333.597-1.333 1.334v10.666c0 .737.596 1.334 1.333 1.334h6.667c.736 0 1.333-.597 1.333-1.333V2.667c0-.737-.597-1.333-1.333-1.333zM8 12h.007'
  />
		</svg>;
}, "PhoneDescriptorSvg");
var PhoneDescriptor_default = PhoneDescriptorSvg;

// src/assets/svgIcons/HotelDescriptor.tsx
var HotelDescriptorSvg = /* @__PURE__ */ __name(() => {
  return <svg
    xmlns='http://www.w3.org/2000/svg'
    width='14'
    height='16'
    fill='none'
    viewBox='0 0 14 16'
  >
			<path
    stroke='#444'
    d='M2.698 6.784A1.667 1.667 0 014.32 5.5h5.36c.774 0 1.446.532 1.623 1.286l.363 1.547H2.333l.365-1.549z'
  />
			<path
    fill='#444'
    d='M3.5 8.834h7v-1h-7v1zm9 2v2h1v-2h-1zm.333 1.666H1.167v1h11.666v-1zM1.5 12.834v-2h-1v2h1zm-.333-.334c.184 0 .333.15.333.334h-1c0 .368.298.666.667.666v-1zm11.333.334c0-.185.15-.334.333-.334v1a.667.667 0 00.667-.666h-1zm-2-4a2 2 0 012 2h1a3 3 0 00-3-3v1zm-7-1a3 3 0 00-3 3h1a2 2 0 012-2v-1z'
  />
			<path
    stroke='#444'
    d='M3.832 10.667a.5.5 0 11-1 0 .5.5 0 011 0zM4.5 2a1 1 0 11-2 0 1 1 0 012 0z'
  />
			<circle cx='10.666' cy='10.666' r='0.5' stroke='#444' />
			<path
    fill='#444'
    d='M5 5.083c0-.322.26-.583.583-.583h2.833c.322 0 .584.261.584.583V5.5H5v-.417z'
  />
			<path
    stroke='#444'
    strokeLinecap='round'
    d='M5.001 11.666h4'
  />
			<path
    stroke='#444'
    d='M9.666 13h2v1a1 1 0 01-1 1v0a1 1 0 01-1-1v-1zM2.333 13h2v1a1 1 0 01-1 1v0a1 1 0 01-1-1v-1z'
  />
		</svg>;
}, "HotelDescriptorSvg");
var HotelDescriptor_default = HotelDescriptorSvg;

// src/assets/svgIcons/FoodDescriptor.tsx
var FoodDescriptorSvg = /* @__PURE__ */ __name(() => {
  return <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    fill='none'
    viewBox='0 0 16 16'
  >
			<path
    stroke='#444'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M5 3v2.25M8.048 3v2.25M11.095 3v2.25'
  />
			<path
    stroke='#444'
    d='M14.493 7.5c-.043 1.46-.292 2.87-1.082 3.947C12.556 12.614 10.984 13.5 8 13.5c-2.893 0-4.47-.883-5.35-2.057-.808-1.08-1.092-2.491-1.142-3.943h12.985z'
  />
		</svg>;
}, "FoodDescriptorSvg");
var FoodDescriptor_default = FoodDescriptorSvg;

// src/assets/svgIcons/HeadphonesDescriptor.tsx
var HeadphonesDescriptorSvg = /* @__PURE__ */ __name(() => {
  return <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    fill='none'
    viewBox='0 0 16 16'
  >
			<path
    stroke='#444'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M2 12V8a6 6 0 1112 0v4'
  />
			<path
    stroke='#444'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M14 12.667A1.333 1.333 0 0112.667 14H12a1.333 1.333 0 01-1.333-1.333v-2A1.333 1.333 0 0112 9.334h2v3.333zm-12 0A1.333 1.333 0 003.333 14H4a1.333 1.333 0 001.333-1.333v-2A1.333 1.333 0 004 9.334H2v3.333z'
  />
		</svg>;
}, "HeadphonesDescriptorSvg");
var HeadphonesDescriptor_default = HeadphonesDescriptorSvg;

// src/assets/svgIcons/ValidityDescriptor.tsx
var ValidityDescriptorSvg = /* @__PURE__ */ __name(() => {
  return <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    fill='none'
    viewBox='0 0 16 16'
  >
			<path
    stroke='#444'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M12.667 2.667H3.333C2.597 2.667 2 3.264 2 4v9.334c0 .736.597 1.333 1.333 1.333h9.334c.736 0 1.333-.597 1.333-1.333V4c0-.736-.597-1.333-1.333-1.333zM10.666 1.333V4M5.333 1.333V4M2 6.667h12'
  />
		</svg>;
}, "ValidityDescriptorSvg");
var ValidityDescriptor_default = ValidityDescriptorSvg;

// src/assets/svgIcons/UserDescriptor.tsx
var UserDescriptorSvg = /* @__PURE__ */ __name(() => {
  return <svg
    width='16'
    height='16'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
			<g clipPath='url(#clip0_4785_110723)'>
				<path
    d='M16.6673 17.5V15.8333C16.6673 14.9493 16.3161 14.1014 15.691 13.4763C15.0659 12.8512 14.218 12.5 13.334 12.5L6.66732 12.5C5.78326 12.5 4.93542 12.8512 4.31029 13.4763C3.68517 14.1014 3.33398 14.9493 3.33398 15.8333L3.33398 17.5'
    stroke='#444444'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
				<path
    d='M9.99935 9.16667C11.8403 9.16667 13.3327 7.67428 13.3327 5.83333C13.3327 3.99238 11.8403 2.5 9.99935 2.5C8.1584 2.5 6.66602 3.99238 6.66602 5.83333C6.66602 7.67428 8.1584 9.16667 9.99935 9.16667Z'
    stroke='#444444'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
			</g>
			<defs>
				<clipPath id='clip0_4785_110723'>
					<rect width='20' height='20' fill='white' />
				</clipPath>
			</defs>
		</svg>;
}, "UserDescriptorSvg");
var UserDescriptor_default = UserDescriptorSvg;

// src/assets/svgIcons/TimerDescriptor.tsx
var TimerDescriptorSvg = /* @__PURE__ */ __name(() => {
  return <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
			<path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M2.40002 2.5C2.40002 5.59279 4.90723 8.1 8.00002 8.1C11.0928 8.1 13.6 5.59279 13.6 2.5L12.6 2.5C12.6 5.04051 10.5405 7.1 8.00002 7.1C5.45951 7.1 3.40002 5.04051 3.40002 2.5L2.40002 2.5Z'
    fill='#444444'
  />
			<path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M1 2C1 1.72386 1.22386 1.5 1.5 1.5L14.5 1.5C14.7761 1.5 15 1.72386 15 2C15 2.27614 14.7761 2.5 14.5 2.5L1.5 2.5C1.22386 2.5 1 2.27614 1 2Z'
    fill='#444444'
  />
			<path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M2.40002 13.6997C2.40002 13.6996 2.40002 13.6998 2.40002 13.6997C2.40002 10.6069 4.90723 8.1 8.00002 8.1C11.0928 8.1 13.6 10.6066 13.6 13.6994C13.6 13.6993 13.6 13.6995 13.6 13.6994L12.6 13.6997C12.6 13.6996 12.6 13.6998 12.6 13.6997C12.6 11.1592 10.5405 9.09941 8.00002 9.09941C5.45951 9.09941 3.40002 11.1589 3.40002 13.6994C3.40002 13.6993 3.40002 13.6995 3.40002 13.6994L2.40002 13.6997Z'
    fill='#444444'
  />
			<path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M1 14.1997C1 14.4758 1.22386 14.6997 1.5 14.6997L14.5 14.6997C14.7761 14.6997 15 14.4758 15 14.1997C15 13.9236 14.7761 13.6997 14.5 13.6997L1.5 13.6997C1.22386 13.6997 1 13.9236 1 14.1997Z'
    fill='#444444'
  />
		</svg>;
}, "TimerDescriptorSvg");
var TimerDescriptor_default = TimerDescriptorSvg;

// src/assets/svgIcons/BusTimeDescriptor.tsx
var BusTimeDescriptorSvg = /* @__PURE__ */ __name(() => {
  return <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
			<circle cx='11.75' cy='3.75' r='2.75' stroke='#444444' />
			<path
    d='M12 2.5V4H11'
    stroke='#444444'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
			<path
    d='M11.5 1L4.5 1C3.39543 1 2.5 1.89543 2.5 3L2.5 13C2.5 13.5523 2.94771 14 3.5 14L12.5 14C13.0523 14 13.5 13.5523 13.5 13L13.5 6'
    stroke='#444444'
    strokeLinecap='round'
  />
			<path d='M3 9L13.5 9' stroke='#444444' strokeLinecap='round' />
			<path d='M3 4.5L9 4.5' stroke='#444444' strokeLinecap='round' />
			<path d='M10 11.5H11.5' stroke='#444444' strokeLinecap='round' />
			<path d='M4.5 11.5H6' stroke='#444444' strokeLinecap='round' />
			<path
    d='M3.34998 13.5H4.84998V14.75C4.84998 15.1642 4.51419 15.5 4.09998 15.5C3.68576 15.5 3.34998 15.1642 3.34998 14.75V13.5Z'
    fill='#444444'
  />
			<path
    d='M11.5 13.5H13V14.75C13 15.1642 12.6642 15.5 12.25 15.5C11.8358 15.5 11.5 15.1642 11.5 14.75V13.5Z'
    fill='#444444'
  />
		</svg>;
}, "BusTimeDescriptorSvg");
var BusTimeDescriptor_default = BusTimeDescriptorSvg;

// src/assets/svgIcons/CalendarDescriptor.tsx
var CalendarDescriptorSvg = /* @__PURE__ */ __name(() => {
  return <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
			<path
    d='M14 9.5V3.91634C14 3.17996 13.403 2.58301 12.6667 2.58301L3.33333 2.58301C2.59695 2.58301 2 3.17996 2 3.91634L2 13.2497C2 13.9861 2.59695 14.583 3.33333 14.583L10.5 14.583'
    stroke='#444444'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
			<path
    d='M10.6667 1.25V3.91667'
    stroke='#444444'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
			<path
    d='M5.33334 1.25V3.91667'
    stroke='#444444'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
			<path
    d='M2 6.58301L14 6.58301'
    stroke='#444444'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
			<circle cx='11.75' cy='11.8506' r='3' stroke='#444444' />
			<path
    d='M11.4773 10.4863V12.1227H13.1137'
    stroke='#444444'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
		</svg>;
}, "CalendarDescriptorSvg");
var CalendarDescriptor_default = CalendarDescriptorSvg;

// src/assets/svgIcons/CarDescriptor.tsx
var CarDescriptorSvg = /* @__PURE__ */ __name(() => {
  return <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
			<path
    d='M2.87847 4.40782C3.06544 3.47297 3.88627 2.80005 4.83963 2.80005L11.1604 2.80005C12.1138 2.80005 12.9346 3.47297 13.1216 4.40782L13.6 6.80005L2.40002 6.80005L2.87847 4.40782Z'
    stroke='#444444'
  />
			<path
    d='M0.800049 8.80005C0.800049 7.69548 1.69548 6.80005 2.80005 6.80005L13.2 6.80005C14.3046 6.80005 15.2 7.69548 15.2 8.80005V12.2C15.2 12.3105 15.1105 12.4 15 12.4L1.00005 12.4C0.889592 12.4 0.800049 12.3105 0.800049 12.2L0.800049 8.80005Z'
    stroke='#444444'
  />
			<path d='M6.5 9.5L9.5 9.5' stroke='#444444' strokeLinecap='round' />
			<path
    d='M1 12.5L1 13.535C1 14.1066 1.46337 14.57 2.03496 14.57V14.57C2.60655 14.57 3.06992 14.1066 3.06992 13.535V12.5'
    stroke='#444444'
  />
			<path
    d='M13 12.5V13.535C13 14.1066 13.4634 14.57 14.035 14.57V14.57C14.6065 14.57 15.0699 14.1066 15.0699 13.535V12.5'
    stroke='#444444'
  />
			<path
    d='M2.5 6H1'
    stroke='#444444'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
			<path
    d='M15 6H13.5'
    stroke='#444444'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
			<path
    d='M2.75 8.825C2.51528 8.825 2.325 9.01528 2.325 9.25V10.1C2.325 10.3347 2.51528 10.525 2.75 10.525H4.025C4.49444 10.525 4.875 10.1444 4.875 9.675C4.875 9.20556 4.49444 8.825 4.025 8.825H2.75Z'
    stroke='#444444'
    strokeWidth='0.85'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
			<path
    d='M13.25 8.825C13.4847 8.825 13.675 9.01528 13.675 9.25V10.1C13.675 10.3347 13.4847 10.525 13.25 10.525H11.975C11.5056 10.525 11.125 10.1444 11.125 9.675C11.125 9.20556 11.5056 8.825 11.975 8.825H13.25Z'
    stroke='#444444'
    strokeWidth='0.85'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
		</svg>;
}, "CarDescriptorSvg");
var CarDescriptor_default = CarDescriptorSvg;

// src/assets/svgIcons/AttractionDescriptor.tsx
var AttractionDescriptorSvg = /* @__PURE__ */ __name(() => {
  return <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
			<path
    d='M7.87033 1.58343C7.94938 1.53261 8.05083 1.53261 8.12989 1.58343L14.3126 5.55812C14.5141 5.68765 14.4224 6 14.1829 6H1.81717C1.57763 6 1.48589 5.68764 1.68739 5.55812L7.87033 1.58343Z'
    stroke='#444444'
  />
			<path d='M1.5 14.5H14.5' stroke='#444444' strokeLinecap='round' />
			<path d='M12.5 12.5V8' stroke='#444444' strokeLinecap='round' />
			<path d='M6.5 12.5V8' stroke='#444444' strokeLinecap='round' />
			<path d='M9.5 12.5V8' stroke='#444444' strokeLinecap='round' />
			<path d='M3.5 12.5V8' stroke='#444444' strokeLinecap='round' />
		</svg>;
}, "AttractionDescriptorSvg");
var AttractionDescriptor_default = AttractionDescriptorSvg;

// src/assets/svgIcons/LocationDescriptor.tsx
var LocationDescriptorSvg = /* @__PURE__ */ __name(() => {
  return <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
			<path
    d='M14 6.6665C14 11.3332 8 15.3332 8 15.3332C8 15.3332 2 11.3332 2 6.6665C2 5.0752 2.63214 3.54908 3.75736 2.42386C4.88258 1.29864 6.4087 0.666504 8 0.666504C9.5913 0.666504 11.1174 1.29864 12.2426 2.42386C13.3679 3.54908 14 5.0752 14 6.6665Z'
    stroke='#444444'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
			<path
    d='M8 8.6665C9.10457 8.6665 10 7.77107 10 6.6665C10 5.56193 9.10457 4.6665 8 4.6665C6.89543 4.6665 6 5.56193 6 6.6665C6 7.77107 6.89543 8.6665 8 8.6665Z'
    stroke='#444444'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
		</svg>;
}, "LocationDescriptorSvg");
var LocationDescriptor_default = LocationDescriptorSvg;

// src/components/Itinerary/constants.ts
var ANALYTICS_PROPERTIES = {
  ITINERARY_ID: "Itinerary ID",
  ITINERARY_NAME: "Itinerary Name",
  ITINERARY_VIEW: "Itinerary View",
  RANKING: "Ranking",
  ACTION: "Action",
  STOP_NAME: "Stop Name",
  STOP_NUMBER: "Stop Number",
  CURRENCY: "Currency",
  CITY: "City",
  COUNTRY: "Country",
  TGID: "Tour Group ID",
  COLLECTION_ID: "Collection Id",
  COLLECTION_NAME: "Collection Name",
  CATEGORY_ID: "Category Id",
  CATEGORY_NAME: "Category Name",
  SUB_CATEGORY_ID: "Sub-Category Id",
  SUB_CATEGORY_NAME: "Sub-Category Name",
  EXPERIENCE_NAME: "Experience Name",
  PAGE_TYPE: "Page Type",
  PLATFORM_NAME: "Platform Name",
  LANGUAGE: "Language",
  SECTION: "Section",
  BOARDING_POINT_ID: "Boarding Point Id"
};
var ANALYTICS_EVENTS = {
  ITINERARY: {
    TIMELINE_VIEWED: "Timeline Viewed",
    STOP_CLICKED: "Stop Clicked",
    SUB_STOP_CLICKED: "Sub Stop Clicked",
    ITINERARY_VARIANT_CLICKED: "Itinerary Variant Clicked",
    ITINERARY_TOGGLE_CLICKED: "Itinerary Toggle Clicked",
    MAP_VIEWED: "Map Viewed",
    VIEW_ITINERARY_CLICKED: "View Itinerary Clicked",
    ITINERARY_DRAWER_CTA_CLICKED: "Itinerary Drawer CTA Clicked",
    GET_DIRECTIONS_CLICKED: "Get Directions Clicked",
    ITINERARY_CARD_DEADCLICK: "Itinerary Card Deadclick",
    ITINERARY_CARD_EXPANDED: "Itinerary Card Expanded",
    ITINERARY_CARD_COLLAPSED: "Itinerary Card Collapsed"
  }
};
var motIcons = {
  ["BOAT" /* Boat */]: () => import("./Boat-EHSO5SXM.jsx"),
  ["BUS_COACH" /* BusCoach */]: () => import("./Coach-6XESVL3O.jsx"),
  ["CAR" /* Car */]: () => import("./Car-JYYRQVKU.jsx"),
  ["FERRY" /* Ferry */]: () => import("./Ferry-R5BZ4B2X.jsx"),
  ["MINIBUS" /* Minibus */]: () => import("./Minibus-2DVQ4K4T.jsx"),
  ["MINIVAN" /* Minivan */]: () => import("./Minivan-O7Y6Z4OG.jsx"),
  ["SHIP" /* Ship */]: () => import("./Ship-CBE3BENG.jsx"),
  ["SPEEDBOAT" /* Speedboat */]: () => import("./Speedboat-MGOVSCDH.jsx"),
  ["SUV" /* Suv */]: () => import("./Suv-W7IS4TBR.jsx"),
  ["TRAIN" /* Train */]: () => import("./Train-TQ6N7TC4.jsx"),
  ["YACHT" /* Yacht */]: () => import("./Yacht-HL2YUVE3.jsx"),
  ["WALK" /* Walk */]: () => import("./WalkingTours-3ZEDPKDI.jsx")
};
var descriptorIcons = {
  TRANSFERS: TransferDescriptor_default,
  FREE_CANCELLATION: CancelDescriptor_default,
  DURATION: ClockDescriptor_default,
  INSTANT_CONFIRMATION: QuickDescriptor_default,
  MOBILE_TICKET: PhoneDescriptor_default,
  SKIP_THE_LINE: /* @__PURE__ */ __name(() => Skip_default({ strokeColor: "colors.semantic.icon.grey.2" }), "SKIP_THE_LINE"),
  HOTEL_PICKUP: HotelDescriptor_default,
  MEALS_INCLUDED: FoodDescriptor_default,
  AUDIO_GUIDE: HeadphonesDescriptor_default,
  GUIDED_TOUR: /* @__PURE__ */ __name(() => GuidedTour_default({ strokeColor: "colors.semantic.icon.grey.2" }), "GUIDED_TOUR"),
  EXTENDED_VALIDITY: ValidityDescriptor_default,
  USER: UserDescriptor_default,
  TOTAL_DURATION: TimerDescriptor_default,
  FREQUENCY: BusTimeDescriptor_default,
  FIRST_DEPARTURE: CalendarDescriptor_default,
  LAST_DEPARTURE: CalendarDescriptor_default,
  FOOD_AND_DRINKS: FoodDrinkDescriptor_default,
  MODE_OF_TRANSPORT: CarDescriptor_default,
  ATTRACTIONS: AttractionDescriptor_default,
  STARTING_STOP: LocationDescriptor_default
};
var ITINERARY_DESCRIPTORS_DATA = {
  ["TOTAL_DURATION" /* TotalDuration */]: {
    icon: descriptorIcons.TOTAL_DURATION,
    fieldIdentifier: ["duration"],
    fieldTransformer: /* @__PURE__ */ __name((args, { lang }) => {
      const { duration } = args;
      const { minHours, minMinutes, maxHours, maxMinutes } = duration;
      const minTimeInMinutes = minHours * 60 + minMinutes;
      const minDurationString = getDurationInHmNotation({
        durationInMinutes: minTimeInMinutes,
        lang
      });
      let maxDurationString = "";
      if (typeof maxHours === "number" && typeof maxMinutes === "number") {
        const maxTimeInMinutes = maxHours * 60 + maxMinutes;
        maxDurationString = getDurationInHmNotation({
          durationInMinutes: maxTimeInMinutes,
          lang
        });
      }
      return maxDurationString ? `${minDurationString} - ${maxDurationString}` : minDurationString;
    }, "fieldTransformer"),
    getLabel: /* @__PURE__ */ __name(({ strings }) => strings.ITINERARY.DESCRIPTORS.TOTAL_DURATION, "getLabel"),
    qaMarker: "itinerary-total-duration"
  },
  ["FREQUENCY" /* Frequency */]: {
    icon: descriptorIcons.FREQUENCY,
    fieldIdentifier: ["frequency"],
    getLabel: /* @__PURE__ */ __name(({ strings }) => strings.ITINERARY.DESCRIPTORS.FREQUENCY, "getLabel"),
    fieldTransformer: /* @__PURE__ */ __name(({ frequency }) => {
      return frequency;
    }, "fieldTransformer"),
    qaMarker: "itinerary-frequency"
  },
  ["FIRST_DEPARTURE_TIME" /* FirstDepartureTime */]: {
    icon: descriptorIcons.FIRST_DEPARTURE,
    fieldIdentifier: ["firstDepartureTime"],
    hideIfFieldsPresent: ["firstDepartureStop"],
    fieldTransformer: /* @__PURE__ */ __name(({ firstDepartureTime }, { lang }) => {
      return getIntlTime({
        time: firstDepartureTime,
        lang
      });
    }, "fieldTransformer"),
    getLabel: /* @__PURE__ */ __name(({ strings }) => strings.ITINERARY.DESCRIPTORS.FIRST_DEPARTURE_TIME, "getLabel"),
    qaMarker: "itinerary-first-departure-time"
  },
  ["LAST_DEPARTURE_TIME" /* LastDepartureTime */]: {
    icon: descriptorIcons.LAST_DEPARTURE,
    fieldIdentifier: ["lastDepartureTime"],
    hideIfFieldsPresent: ["lastDepartureStop"],
    fieldTransformer: /* @__PURE__ */ __name(({ lastDepartureTime }, { lang }) => {
      return getIntlTime({
        time: lastDepartureTime,
        lang
      });
    }, "fieldTransformer"),
    getLabel: /* @__PURE__ */ __name(({ strings }) => strings.ITINERARY.DESCRIPTORS.LAST_DEPARTURE_TIME, "getLabel"),
    qaMarker: "itinerary-last-departure-time"
  },
  ["FOOD_AND_DRINKS" /* FoodAndDrinks */]: {
    icon: descriptorIcons.FOOD_AND_DRINKS,
    fieldIdentifier: ["menuImageLink"],
    useCTA: true,
    ctaLabel: "View Menu",
    onCTAClick: /* @__PURE__ */ __name((url) => {
      window.open(url);
    }, "onCTAClick"),
    getLabel: /* @__PURE__ */ __name(({ strings }) => strings.ITINERARY.DESCRIPTORS.FOOD_AND_DRINKS, "getLabel"),
    qaMarker: "itinerary-food-and-drinks"
  },
  ["MODE_OF_TRANSPORT" /* ModeOfTransport */]: {
    icon: descriptorIcons.MODE_OF_TRANSPORT,
    fieldIdentifier: ["modeOfTravel"],
    getIcon: /* @__PURE__ */ __name(({ modeOfTravel }) => {
      return dynamic(
        motIcons[modeOfTravel.label]
      );
    }, "getIcon"),
    fieldTransformer: /* @__PURE__ */ __name(({ modeOfTravel }) => {
      return modeOfTravel.localisedLabel;
    }, "fieldTransformer"),
    getLabel: /* @__PURE__ */ __name(({ strings }) => strings.ITINERARY.DESCRIPTORS.MODE_OF_TRANSPORT, "getLabel"),
    qaMarker: "itinerary-mode-of-transport"
  },
  ["FIRST_DEPARTURE" /* FirstDeparture */]: {
    icon: descriptorIcons.FIRST_DEPARTURE,
    fieldIdentifier: ["firstDepartureStop", "firstDepartureTime"],
    fieldTransformer: /* @__PURE__ */ __name(({ firstDepartureStop, firstDepartureTime }, { lang }) => {
      return `${firstDepartureStop}
at ${getIntlTime({
        time: firstDepartureTime,
        lang
      })}`;
    }, "fieldTransformer"),
    getLabel: /* @__PURE__ */ __name(({ strings }) => strings.ITINERARY.DESCRIPTORS.FIRST_DEPARTURE, "getLabel"),
    qaMarker: "itinerary-first-departure"
  },
  ["LAST_DEPARTURE" /* LastDeparture */]: {
    icon: descriptorIcons.LAST_DEPARTURE,
    fieldIdentifier: ["lastDepartureStop", "lastDepartureTime"],
    fieldTransformer: /* @__PURE__ */ __name(({ lastDepartureStop, lastDepartureTime }, { lang }) => {
      return `${lastDepartureStop}
at ${getIntlTime({
        time: lastDepartureTime,
        lang
      })}`;
    }, "fieldTransformer"),
    getLabel: /* @__PURE__ */ __name(({ strings }) => strings.ITINERARY.DESCRIPTORS.LAST_DEPARTURE, "getLabel"),
    qaMarker: "itinerary-last-departure"
  }
};
var nearbyThingsIcon = {
  ["POI" /* Poi */]: () => import("./CityTours-DWAPVYXM.jsx"),
  ["LANDMARK" /* Landmark */]: () => import("./Landmarks-57H7ZTZ4.jsx"),
  ["SHOPPING_CENTER" /* ShoppingCenter */]: () => import("./Shopping-MG3F3VGN.jsx"),
  ["SUBSECTION_OF_POI" /* SubsectionOfPoi */]: () => import("./CityTours-DWAPVYXM.jsx"),
  ["NEIGHBOURHOOD_AREA" /* NeighbourhoodArea */]: () => import("./Neighbourhood-UVTCLF6G.jsx"),
  ["HOHO_BUS_STOP" /* HohoBusStop */]: () => import("./Stop-BOPZGQDN.jsx"),
  ["OTHERS" /* Others */]: () => import("./LocationPin-MX5NTYWK.jsx"),
  ["BREAKFAST" /* Breakfast */]: () => import("./FoodDrinkDescriptor-EM77Y57K.jsx"),
  ["LUNCH" /* Lunch */]: () => import("./FoodDrinkDescriptor-EM77Y57K.jsx"),
  ["SNACKS" /* Snacks */]: () => import("./FoodDrinkDescriptor-EM77Y57K.jsx"),
  ["DINNER" /* Dinner */]: () => import("./FoodDrinkDescriptor-EM77Y57K.jsx"),
  ["DRINKS" /* Drinks */]: () => import("./Beverage-3HBS3IK3.jsx"),
  ["ACTIVITY" /* Activity */]: () => import("./Activities-X2BEHUJA.jsx"),
  ["ATTRACTION" /* Attraction */]: () => import("./Attractions-QTMJFUT6.jsx"),
  ["FOOD_DRINKS" /* FoodAndDrinks */]: () => import("./FoodDrinkDescriptor-EM77Y57K.jsx")
};
var ITINERARY_MAP_BANNER_ICON_IMAGE = "https://cdn-imgix.headout.com/assets/images/itinerary/itinerary-map-banner-icon.svg";
var ITINERARY_MAP_BANNER_BG_IMAGE = "https://cdn-imgix.headout.com/assets/images/itinerary/itinerary-map-banner-bg.png";
var MEDIA_CAROUSEL_IMAGE_LIMIT = 10;
var ITINERARY_STOP_SWIPESHEET_URL_IDENTIFIER = "#itineraryStopSwipeSheet";
var ITINERARY_MAP_VIEW_SWIPESHEET_URL_IDENTIFIER = "#itineraryMapViewSwipeSheet";

// src/components/Itinerary/components/ItineraryMapViewBanner/ItineraryMapViewBanner.tsx
import { Text as Text2 } from "@headout/eevee";
var ItineraryMapViewBanner = /* @__PURE__ */ __name(({
  onClick,
  strings
}) => {
  const handleClick = /* @__PURE__ */ __name(() => {
    onClick == null ? void 0 : onClick();
  }, "handleClick");
  const itineraryMapViewBannerStyles = itineraryMapViewBannerStylesRecipe({});
  return <div
    role={"button"}
    tabIndex={0}
    className={itineraryMapViewBannerStyles.root}
    onClick={handleClick}
    onKeyDown={() => {
    }}
    data-qa-marker='qaid-itinerary-map-view-banner'
  >
			<div className={itineraryMapViewBannerStyles.content}>
				<Text2 textStyle='ui.label.regular' color='core.grey.900'>
					{strings.ITINERARY.VIEW_EXPERIENCE_MAPPED_OUT}
				</Text2>
				<div className={itineraryMapViewBannerStyles.cta}>
					<Text2
    textStyle='ui.label.regular.heavy'
    color='core.grey.900'
  >
						{strings.ITINERARY.OPEN_MAP_VIEW}
					</Text2>
					<div className={itineraryMapViewBannerStyles.icon}>
						<ChevronRight_default
    height={"0.75rem"}
    width={"0.75rem"}
    strokeColor={"core.primary.black"}
  />
					</div>
				</div>
			</div>
			<div className={itineraryMapViewBannerStyles.imageContainer}>
				<Image
    height={52}
    width={52}
    fill
    url={ITINERARY_MAP_BANNER_ICON_IMAGE}
    alt={"map"}
  />
			</div>
			<div className={itineraryMapViewBannerStyles.bgImageContainer}>
				<Image
    height={76}
    width={123}
    url={ITINERARY_MAP_BANNER_BG_IMAGE}
    alt={"map"}
  />
			</div>
		</div>;
}, "ItineraryMapViewBanner");

// src/components/Itinerary/components/ItineraryViewSwitch/ItineraryViewSwitch.tsx
import { useEffect, useState as useState2 } from "react";

// src/components/Itinerary/components/ItineraryViewSwitch/styles.tsx
import { sva as sva3 } from "@headout/pixie/css";
var toggleSwitchContainerStylesRecipe = sva3({
  slots: [
    "root",
    "inputElement",
    "slider",
    "iconContainer",
    "icon",
    "switchContainer"
  ],
  base: {
    root: {
      position: "relative",
      width: "[2.625rem]",
      height: "[1.5rem]",
      borderRadius: "[66.67px]",
      backgroundColor: "core.grey.800"
    },
    inputElement: {
      position: "absolute",
      opacity: 0,
      width: "[100%]",
      height: "[100%]",
      zIndex: 2,
      cursor: "pointer"
    },
    slider: {
      position: "absolute",
      width: "[1.25rem]",
      height: "[1.25rem]",
      backgroundColor: "core.primary.white",
      borderRadius: "radius.50p",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      transition: "transform 0.6s cubic-bezier(0.7, 0, 0.3, 1)",
      top: "[2px]",
      left: "[2px]",
      bottom: "[2px]"
    },
    iconContainer: {
      height: "[100%]",
      width: "[100%]",
      position: "relative"
    },
    icon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "absolute",
      top: "[50%]",
      left: "[50%]",
      transform: "[translate(-50%, -50%)]",
      "& svg": {
        height: "[0.75rem]",
        width: "[0.75rem]"
      }
    },
    switchContainer: {
      display: "flex",
      alignItems: "center",
      gap: "space.10"
    }
  },
  variants: {
    isChecked: {
      true: {
        root: {
          backgroundColor: "core.primary.purps"
        },
        slider: {
          transform: "[translateX(calc(100% - 2px))]"
        }
      },
      false: {
        slider: {
          transform: "[translateX(0)]"
        }
      }
    }
  }
});

// src/assets/svgIcons/ListToMap.tsx
var ListToMap = /* @__PURE__ */ __name(() => {
  return <svg
    xmlns='http://www.w3.org/2000/svg'
    xlinkHref='http://www.w3.org/1999/xlink'
    preserveAspectRatio='xMidYMid meet'
    width='14'
    height='14'
    viewBox='0 0 14 14'
  >
			<defs>
				<animate
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_2_G_D_0_P_0'
    fill='freeze'
    attributeName='d'
    attributeType='XML'
    from='M239.75 237 C239.75,237 239.75,245 239.75,245 C239.75,245 239.75,243 239.75,243 C239.75,243 239.75,245.65 239.75,245.65 C239.75,245.65 239.75,243 239.75,243 C239.75,243 239.75,235 239.75,235 C239.75,235 239.75,237.65 239.75,237.65 C239.75,237.65 239.75,235 239.75,235 C239.75,235 239.75,237 239.75,237z '
    to='M234.5 237 C234.5,237 234.5,245 234.5,245 C234.5,245 238,243 238,243 C238,243 242,245 242,245 C242,245 245.5,243 245.5,243 C245.5,243 245.5,235 245.5,235 C245.5,235 242,237 242,237 C242,237 238,235 238,235 C238,235 234.5,237 234.5,237z '
    keyTimes='0;0.4545455;0.7272727;0.9545455;1'
    values='M239.75 237 C239.75,237 239.75,245 239.75,245 C239.75,245 239.75,243 239.75,243 C239.75,243 239.75,245.65 239.75,245.65 C239.75,245.65 239.75,243 239.75,243 C239.75,243 239.75,235 239.75,235 C239.75,235 239.75,237.65 239.75,237.65 C239.75,237.65 239.75,235 239.75,235 C239.75,235 239.75,237 239.75,237z ;M239.75 237 C239.75,237 239.75,245 239.75,245 C239.75,245 239.75,243 239.75,243 C239.75,243 239.75,245.65 239.75,245.65 C239.75,245.65 239.75,243 239.75,243 C239.75,243 239.75,235 239.75,235 C239.75,235 239.75,237.65 239.75,237.65 C239.75,237.65 239.75,235 239.75,235 C239.75,235 239.75,237 239.75,237z ;M234 236.6 C234,236.6 234,244.6 234,244.6 C234,244.6 237.75,243 237.75,243 C237.75,243 242.25,244.8 242.25,244.8 C242.25,244.8 246.2,243 246.2,243 C246.2,243 246.2,235 246.2,235 C246.2,235 242.25,236.8 242.25,236.8 C242.25,236.8 237.75,235 237.75,235 C237.75,235 234,236.6 234,236.6z ;M234.5 237 C234.5,237 234.5,245 234.5,245 C234.5,245 238,243 238,243 C238,243 242,245 242,245 C242,245 245.5,243 245.5,243 C245.5,243 245.5,235 245.5,235 C245.5,235 242,237 242,237 C242,237 238,235 238,235 C238,235 234.5,237 234.5,237z ;M234.5 237 C234.5,237 234.5,245 234.5,245 C234.5,245 238,243 238,243 C238,243 242,245 242,245 C242,245 245.5,243 245.5,243 C245.5,243 245.5,235 245.5,235 C245.5,235 242,237 242,237 C242,237 238,235 238,235 C238,235 234.5,237 234.5,237z '
    keySplines='0.333 0 0 0.992;0.333 0 0 0.992;0.167 0 0 0.992;0 0 0 0'
    calcMode='spline'
  />
				<animate
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_2_G_D_1_P_0'
    fill='freeze'
    attributeName='d'
    attributeType='XML'
    from='M239.75 235 C239.75,235 239.75,243 239.75,243 '
    to='M238 235 C238,235 238,243 238,243 '
    keyTimes='0;0.4545455;0.7272727;0.9545455;1'
    values='M239.75 235 C239.75,235 239.75,243 239.75,243 ;M239.75 235 C239.75,235 239.75,243 239.75,243 ;M237.75 235 C237.75,235 237.75,243 237.75,243 ;M238 235 C238,235 238,243 238,243 ;M238 235 C238,235 238,243 238,243 '
    keySplines='0.333 0 0 0.992;0.333 0 0 0.992;0.167 0 0 0.992;0 0 0 0'
    calcMode='spline'
  />
				<animate
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_2_G_D_2_P_0'
    fill='freeze'
    attributeName='d'
    attributeType='XML'
    from='M239.75 237 C239.75,237 239.75,245.63 239.75,245.63 '
    to='M242 237 C242,237 242,245 242,245 '
    keyTimes='0;0.4545455;0.7272727;0.9545455;1'
    values='M239.75 237 C239.75,237 239.75,245.63 239.75,245.63 ;M239.75 237 C239.75,237 239.75,245.63 239.75,245.63 ;M242.25 236.8 C242.25,236.8 242.25,244.8 242.25,244.8 ;M242 237 C242,237 242,245 242,245 ;M242 237 C242,237 242,245 242,245 '
    keySplines='0.333 0 0 0.992;0.333 0 0 0.992;0.167 0 0 0.992;0 0 0 0'
    calcMode='spline'
  />
				<animate
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_2_G_N_1_T_0_M'
    fill='freeze'
    attributeName='opacity'
    from='0'
    to='1'
    keyTimes='0;0.4545455;0.45455;1'
    values='0;0;1;1'
    keySplines='0 0 0 0;0 0 0 0;0 0 0 0'
    calcMode='spline'
  />
				<animateMotion
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_1_G_D_0_P_0_G_0_T_0'
    fill='freeze'
    keyTimes='0;0.0909091;0.4545455;1'
    path='M239.72 243.5 C239.72,243.5 239.72,243.5 239.72,243.5 C239.72,243.5 239.72,240 239.72,240 C239.72,240 239.72,240 239.72,240 '
    keyPoints='0;0;1;1'
    keySplines='0.333 0 0.145 0.981;0.333 0 0.145 0.981;0 0 0 0'
    calcMode='spline'
  />
				<animateTransform
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_1_G_D_0_P_0_G_0_T_0'
    fill='freeze'
    attributeName='transform'
    from='-239.723 -243.5'
    to='-239.723 -243.5'
    type='translate'
    additive='sum'
    keyTimes='0;1'
    values='-239.723 -243.5;-239.723 -243.5'
    keySplines='0 0 1 1'
    calcMode='spline'
  />
				<animate
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_1_G_D_0_P_0'
    fill='freeze'
    attributeName='d'
    attributeType='XML'
    from='M-3.79 0 C-3.79,0 3.79,0 3.79,0 '
    to='M-6.72 0 C-6.72,0 3.79,0 3.79,0 '
    keyTimes='0;0.3636364;1'
    values='M-3.79 0 C-3.79,0 3.79,0 3.79,0 ;M-6.72 0 C-6.72,0 3.79,0 3.79,0 ;M-6.72 0 C-6.72,0 3.79,0 3.79,0 '
    keySplines='0.333 0 0.145 0.753;0 0 0 0'
    calcMode='spline'
  />
				<animateMotion
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_1_G_D_1_P_0_G_0_T_0'
    fill='freeze'
    keyTimes='0;0.0909091;0.4545455;1'
    path='M239.72 243.5 C239.72,243.5 239.72,243.5 239.72,243.5 C239.72,243.5 239.72,240 239.72,240 C239.72,240 239.72,240 239.72,240 '
    keyPoints='0;0;1;1'
    keySplines='0.333 0 0.145 0.981;0.333 0 0.145 0.981;0 0 0 0'
    calcMode='spline'
  />
				<animateTransform
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_1_G_D_1_P_0_G_0_T_0'
    fill='freeze'
    attributeName='transform'
    from='-239.723 -243.5'
    to='-239.723 -243.5'
    type='translate'
    additive='sum'
    keyTimes='0;1'
    values='-239.723 -243.5;-239.723 -243.5'
    keySplines='0 0 1 1'
    calcMode='spline'
  />
				<animate
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_1_G_D_2_P_0'
    fill='freeze'
    attributeName='d'
    attributeType='XML'
    from='M237.67 240 C237.67,240 245.25,240 245.25,240 '
    to='M234.77 240 C234.77,240 245.25,240 245.25,240 '
    keyTimes='0;0.3636364;1'
    values='M237.67 240 C237.67,240 245.25,240 245.25,240 ;M234.77 240 C234.77,240 245.25,240 245.25,240 ;M234.77 240 C234.77,240 245.25,240 245.25,240 '
    keySplines='0.333 0 0.145 0.753;0 0 0 0'
    calcMode='spline'
  />
				<animateMotion
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_1_G_D_4_P_0_G_0_T_0'
    fill='freeze'
    keyTimes='0;0.0909091;0.4545455;1'
    path='M239.72 236.5 C239.72,236.5 239.72,236.5 239.72,236.5 C239.72,236.5 239.72,240 239.72,240 C239.72,240 239.72,240 239.72,240 '
    keyPoints='0;0;1;1'
    keySplines='0.333 0 0.145 0.981;0.333 0 0.145 0.981;0 0 0 0'
    calcMode='spline'
  />
				<animateTransform
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_1_G_D_4_P_0_G_0_T_0'
    fill='freeze'
    attributeName='transform'
    from='-239.723 -236.5'
    to='-239.723 -236.5'
    type='translate'
    additive='sum'
    keyTimes='0;1'
    values='-239.723 -236.5;-239.723 -236.5'
    keySplines='0 0 1 1'
    calcMode='spline'
  />
				<animate
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_1_G_D_4_P_0'
    fill='freeze'
    attributeName='d'
    attributeType='XML'
    from='M-3.79 0 C-3.79,0 3.79,0 3.79,0 '
    to='M-6.69 0 C-6.69,0 3.79,0 3.79,0 '
    keyTimes='0;0.3636364;1'
    values='M-3.79 0 C-3.79,0 3.79,0 3.79,0 ;M-6.69 0 C-6.69,0 3.79,0 3.79,0 ;M-6.69 0 C-6.69,0 3.79,0 3.79,0 '
    keySplines='0.333 0 0.145 0.753;0 0 0 0'
    calcMode='spline'
  />
				<animateMotion
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_1_G_D_5_P_0_G_0_T_0'
    fill='freeze'
    keyTimes='0;0.0909091;0.4545455;1'
    path='M239.72 236.5 C239.72,236.5 239.72,236.5 239.72,236.5 C239.72,236.5 239.72,240 239.72,240 C239.72,240 239.72,240 239.72,240 '
    keyPoints='0;0;1;1'
    keySplines='0.333 0 0.145 0.981;0.333 0 0.145 0.981;0 0 0 0'
    calcMode='spline'
  />
				<animateTransform
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_1_G_D_5_P_0_G_0_T_0'
    fill='freeze'
    attributeName='transform'
    from='-239.723 -236.5'
    to='-239.723 -236.5'
    type='translate'
    additive='sum'
    keyTimes='0;1'
    values='-239.723 -236.5;-239.723 -236.5'
    keySplines='0 0 1 1'
    calcMode='spline'
  />
				<animateTransform
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_1_G'
    fill='freeze'
    attributeName='transform'
    from='0'
    to='90'
    type='rotate'
    additive='sum'
    keyTimes='0;0.6363636;1'
    values='0;90;90'
    keySplines='0.333 0 0.153 0.979;0 0 0 0'
    calcMode='spline'
  />
				<animateTransform
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_1_G'
    fill='freeze'
    attributeName='transform'
    from='-239.723 -240'
    to='-239.723 -240'
    type='translate'
    additive='sum'
    keyTimes='0;1'
    values='-239.723 -240;-239.723 -240'
    keySplines='0 0 1 1'
    calcMode='spline'
  />
				<animate
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_1_G_N_1_T_0_M'
    fill='freeze'
    attributeName='opacity'
    from='1'
    to='0'
    keyTimes='0;0.5454545;0.5454546;1'
    values='1;1;0;0'
    keySplines='0 0 0 0;0 0 0 0;0 0 0 0'
    calcMode='spline'
  />
				<animate
    attributeType='XML'
    attributeName='opacity'
    dur='1s'
    from='0'
    to='1'
    xlinkHref='#time_group'
  />
			</defs>
			<g id='_R_G'>
				<g id='_R_G_L_2_G_N_1_T_0_M'>
					<g
    id='_R_G_L_2_G_N_1_T_0'
    transform=' translate(7, 7) translate(0, 0)'
  >
						<g
    id='_R_G_L_2_G'
    transform=' translate(0, 0) translate(-240, -240)'
  >
							<path
    id='_R_G_L_2_G_D_0_P_0'
    stroke='#8000ff'
    strokeLinecap='round'
    strokeLinejoin='round'
    fill='none'
    strokeWidth='0.889'
    strokeOpacity='1'
    d=' M239.75 237 C239.75,237 239.75,245 239.75,245 C239.75,245 239.75,243 239.75,243 C239.75,243 239.75,245.65 239.75,245.65 C239.75,245.65 239.75,243 239.75,243 C239.75,243 239.75,235 239.75,235 C239.75,235 239.75,237.65 239.75,237.65 C239.75,237.65 239.75,235 239.75,235 C239.75,235 239.75,237 239.75,237z '
  />
							<path
    id='_R_G_L_2_G_D_1_P_0'
    stroke='#8000ff'
    strokeLinecap='round'
    strokeLinejoin='round'
    fill='none'
    strokeWidth='0.889'
    strokeOpacity='1'
    d=' M239.75 235 C239.75,235 239.75,243 239.75,243 '
  />
							<path
    id='_R_G_L_2_G_D_2_P_0'
    stroke='#8000ff'
    strokeLinecap='round'
    strokeLinejoin='round'
    fill='none'
    strokeWidth='0.889'
    strokeOpacity='1'
    d=' M239.75 237 C239.75,237 239.75,245.63 239.75,245.63 '
  />
						</g>
					</g>
				</g>
				<g id='_R_G_L_1_G_N_1_T_0_M'>
					<g
    id='_R_G_L_1_G_N_1_T_0'
    transform=' translate(7, 7) translate(0, 0)'
  >
						<g id='_R_G_L_1_G' transform=' translate(-0.277, 0)'>
							<g id='_R_G_L_1_G_D_0_P_0_G_0_T_0'>
								<g
    id='_R_G_L_1_G_D_0_P_0_G_1_T_0'
    transform=' translate(241.458, 243.5) translate(0, 0)'
  >
									<path
    id='_R_G_L_1_G_D_0_P_0'
    stroke='#444444'
    strokeLinecap='round'
    strokeLinejoin='round'
    fill='none'
    strokeWidth='1.111'
    strokeOpacity='1'
    d=' M-3.79 0 C-3.79,0 3.79,0 3.79,0 '
  />
								</g>
							</g>
							<g id='_R_G_L_1_G_D_1_P_0_G_0_T_0'>
								<g
    id='_R_G_L_1_G_D_1_P_0_G_1_T_0'
    transform=' translate(234.754, 243.5) translate(0, 0)'
  >
									<path
    id='_R_G_L_1_G_D_1_P_0'
    fill='#444444'
    fillOpacity='1'
    fillRule='nonzero'
    d=' M0 0.56 C-0.31,0.56 -0.56,0.31 -0.56,0 C-0.56,-0.31 -0.31,-0.56 0,-0.56 C0,-0.56 0,-0.56 0,-0.56 C0.31,-0.56 0.56,-0.31 0.56,0 C0.56,0.31 0.31,0.56 0,0.56z '
  />
								</g>
							</g>
							<path
    id='_R_G_L_1_G_D_2_P_0'
    stroke='#444444'
    strokeLinecap='round'
    strokeLinejoin='round'
    fill='none'
    strokeWidth='1.111'
    strokeOpacity='1'
    d=' M237.67 240 C237.67,240 245.25,240 245.25,240 '
  />
							<path
    id='_R_G_L_1_G_D_3_P_0'
    fill='#444444'
    fillOpacity='1'
    fillRule='nonzero'
    d=' M234.76 240.56 C234.45,240.56 234.2,240.31 234.2,240 C234.2,239.69 234.44,239.44 234.75,239.44 C234.75,239.44 234.76,239.44 234.76,239.44 C235.06,239.44 235.31,239.69 235.31,240 C235.31,240.31 235.06,240.56 234.76,240.56z '
  />
							<g id='_R_G_L_1_G_D_4_P_0_G_0_T_0'>
								<g
    id='_R_G_L_1_G_D_4_P_0_G_1_T_0'
    transform=' translate(241.458, 236.5) translate(0, 0)'
  >
									<path
    id='_R_G_L_1_G_D_4_P_0'
    stroke='#444444'
    strokeLinecap='round'
    strokeLinejoin='round'
    fill='none'
    strokeWidth='1.111'
    strokeOpacity='1'
    d=' M-3.79 0 C-3.79,0 3.79,0 3.79,0 '
  />
								</g>
							</g>
							<g id='_R_G_L_1_G_D_5_P_0_G_0_T_0'>
								<g
    id='_R_G_L_1_G_D_5_P_0_G_1_T_0'
    transform=' translate(234.754, 236.5) translate(0, 0)'
  >
									<path
    id='_R_G_L_1_G_D_5_P_0'
    fill='#444444'
    fillOpacity='1'
    fillRule='nonzero'
    d=' M0 0.56 C-0.31,0.56 -0.56,0.31 -0.56,0 C-0.56,-0.31 -0.31,-0.56 0,-0.56 C0,-0.56 0,-0.56 0,-0.56 C0.31,-0.56 0.56,-0.31 0.56,0 C0.56,0.31 0.31,0.56 0,0.56z '
  />
								</g>
							</g>
						</g>
					</g>
				</g>
				<g
    id='_R_G_L_0_G'
    transform=' translate(7, 7) translate(0, 0)'
  />
			</g>
			<g id='time_group' />
		</svg>;
}, "ListToMap");
var ListToMap_default = ListToMap;

// src/assets/svgIcons/MapToList.tsx
var MapToList = /* @__PURE__ */ __name(() => {
  return <svg
    xmlns='http://www.w3.org/2000/svg'
    xlinkHref='http://www.w3.org/1999/xlink'
    preserveAspectRatio='xMidYMid meet'
    width='14'
    height='14'
    viewBox='0 0 14 14'
  >
			<defs>
				<animate
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_2_G_D_0_P_0'
    fill='freeze'
    attributeName='d'
    attributeType='XML'
    from='M234.5 237 C234.5,237 234.5,245 234.5,245 C234.5,245 238,243 238,243 C238,243 242,245 242,245 C242,245 245.5,243 245.5,243 C245.5,243 245.5,235 245.5,235 C245.5,235 242,237 242,237 C242,237 238,235 238,235 C238,235 234.5,237 234.5,237z '
    to='M239.75 237 C239.75,237 239.75,245 239.75,245 C239.75,245 239.75,243 239.75,243 C239.75,243 239.75,245.65 239.75,245.65 C239.75,245.65 239.75,243 239.75,243 C239.75,243 239.75,235 239.75,235 C239.75,235 239.75,237.65 239.75,237.65 C239.75,237.65 239.75,235 239.75,235 C239.75,235 239.75,237 239.75,237z '
    keyTimes='0;0.3181818;1'
    values='M234.5 237 C234.5,237 234.5,245 234.5,245 C234.5,245 238,243 238,243 C238,243 242,245 242,245 C242,245 245.5,243 245.5,243 C245.5,243 245.5,235 245.5,235 C245.5,235 242,237 242,237 C242,237 238,235 238,235 C238,235 234.5,237 234.5,237z ;M239.75 237 C239.75,237 239.75,245 239.75,245 C239.75,245 239.75,243 239.75,243 C239.75,243 239.75,245.65 239.75,245.65 C239.75,245.65 239.75,243 239.75,243 C239.75,243 239.75,235 239.75,235 C239.75,235 239.75,237.65 239.75,237.65 C239.75,237.65 239.75,235 239.75,235 C239.75,235 239.75,237 239.75,237z ;M239.75 237 C239.75,237 239.75,245 239.75,245 C239.75,245 239.75,243 239.75,243 C239.75,243 239.75,245.65 239.75,245.65 C239.75,245.65 239.75,243 239.75,243 C239.75,243 239.75,235 239.75,235 C239.75,235 239.75,237.65 239.75,237.65 C239.75,237.65 239.75,235 239.75,235 C239.75,235 239.75,237 239.75,237z '
    keySplines='1 0 0.667 1;0 0 0 0'
    calcMode='spline'
  />
				<animate
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_2_G_D_1_P_0'
    fill='freeze'
    attributeName='d'
    attributeType='XML'
    from='M238 235 C238,235 238,243 238,243 '
    to='M239.75 235 C239.75,235 239.75,243 239.75,243 '
    keyTimes='0;0.3181818;1'
    values='M238 235 C238,235 238,243 238,243 ;M239.75 235 C239.75,235 239.75,243 239.75,243 ;M239.75 235 C239.75,235 239.75,243 239.75,243 '
    keySplines='1 0 0.667 1;0 0 0 0'
    calcMode='spline'
  />
				<animate
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_2_G_D_2_P_0'
    fill='freeze'
    attributeName='d'
    attributeType='XML'
    from='M242 237 C242,237 242,245 242,245 '
    to='M239.75 237 C239.75,237 239.75,245.63 239.75,245.63 '
    keyTimes='0;0.3181818;1'
    values='M242 237 C242,237 242,245 242,245 ;M239.75 237 C239.75,237 239.75,245.63 239.75,245.63 ;M239.75 237 C239.75,237 239.75,245.63 239.75,245.63 '
    keySplines='1 0 0.667 1;0 0 0 0'
    calcMode='spline'
  />
				<animateTransform
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_2_G'
    fill='freeze'
    attributeName='transform'
    from='0'
    to='-90'
    type='rotate'
    additive='sum'
    keyTimes='0;0.5;1'
    values='0;-90;-90'
    keySplines='0.782 0 0.667 1;0 0 0 0'
    calcMode='spline'
  />
				<animateTransform
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_2_G'
    fill='freeze'
    attributeName='transform'
    from='-240 -240'
    to='-240 -240'
    type='translate'
    additive='sum'
    keyTimes='0;1'
    values='-240 -240;-240 -240'
    keySplines='0 0 1 1'
    calcMode='spline'
  />
				<animate
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_2_G_N_1_T_0_M'
    fill='freeze'
    attributeName='opacity'
    from='1'
    to='0'
    keyTimes='0;0.4545455;0.4545455;1'
    values='1;1;0;0'
    keySplines='0 0 0 0;0 0 0 0;0 0 0 0'
    calcMode='spline'
  />
				<animateMotion
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_1_G_D_0_P_0_G_0_T_0'
    fill='freeze'
    keyTimes='0;0.4545455;0.6363636;0.9090909;1'
    path='M239.72 240 C239.72,240 239.72,240 239.72,240 C239.72,240 239.72,243.8 239.72,243.8 C239.72,243.8 239.72,243.5 239.72,243.5 C239.72,243.5 239.72,243.5 239.72,243.5 '
    keyPoints='0;0;0.93;1;1'
    keySplines='0.484 0 0.187 0.815;0.484 0 0.187 0.815;0.231 1 0.566 1;0 0 0 0'
    calcMode='spline'
  />
				<animateTransform
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_1_G_D_0_P_0_G_0_T_0'
    fill='freeze'
    attributeName='transform'
    from='-239.723 -243.5'
    to='-239.723 -243.5'
    type='translate'
    additive='sum'
    keyTimes='0;1'
    values='-239.723 -243.5;-239.723 -243.5'
    keySplines='0 0 1 1'
    calcMode='spline'
  />
				<animate
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_1_G_D_0_P_0'
    fill='freeze'
    attributeName='d'
    attributeType='XML'
    from='M-6.72 0 C-6.72,0 3.79,0 3.79,0 '
    to='M-3.79 0 C-3.79,0 3.79,0 3.79,0 '
    keyTimes='0;0.4545455;0.6363636;0.9090909;1'
    values='M-6.72 0 C-6.72,0 3.79,0 3.79,0 ;M-6.72 0 C-6.72,0 3.79,0 3.79,0 ;M-3.45 0 C-3.45,0 3.79,0 3.79,0 ;M-3.79 0 C-3.79,0 3.79,0 3.79,0 ;M-3.79 0 C-3.79,0 3.79,0 3.79,0 '
    keySplines='0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0 0 0 0'
    calcMode='spline'
  />
				<animateMotion
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_1_G_D_1_P_0_G_0_T_0'
    fill='freeze'
    keyTimes='0;0.4545455;0.6363636;0.9090909;1'
    path='M239.72 240 C239.72,240 239.72,240 239.72,240 C239.72,240 239.72,243.8 239.72,243.8 C239.72,243.8 239.72,243.5 239.72,243.5 C239.72,243.5 239.72,243.5 239.72,243.5 '
    keyPoints='0;0;0.93;1;1'
    keySplines='0.484 0 0.187 0.815;0.484 0 0.187 0.815;0.231 1 0.566 1;0 0 0 0'
    calcMode='spline'
  />
				<animateTransform
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_1_G_D_1_P_0_G_0_T_0'
    fill='freeze'
    attributeName='transform'
    from='-239.723 -243.5'
    to='-239.723 -243.5'
    type='translate'
    additive='sum'
    keyTimes='0;1'
    values='-239.723 -243.5;-239.723 -243.5'
    keySplines='0 0 1 1'
    calcMode='spline'
  />
				<animate
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_1_G_D_2_P_0'
    fill='freeze'
    attributeName='d'
    attributeType='XML'
    from='M234.77 240 C234.77,240 245.25,240 245.25,240 '
    to='M237.67 240 C237.67,240 245.25,240 245.25,240 '
    keyTimes='0;0.4545455;0.6363636;0.9090909;1'
    values='M234.77 240 C234.77,240 245.25,240 245.25,240 ;M234.77 240 C234.77,240 245.25,240 245.25,240 ;M238.01 240 C238.01,240 245.25,240 245.25,240 ;M237.67 240 C237.67,240 245.25,240 245.25,240 ;M237.67 240 C237.67,240 245.25,240 245.25,240 '
    keySplines='0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0 0 0 0'
    calcMode='spline'
  />
				<animateMotion
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_1_G_D_4_P_0_G_0_T_0'
    fill='freeze'
    keyTimes='0;0.4545455;0.6363636;0.9090909;1'
    path='M239.72 240 C239.72,240 239.72,240 239.72,240 C239.72,240 239.72,236.2 239.72,236.2 C239.72,236.2 239.72,236.5 239.72,236.5 C239.72,236.5 239.72,236.5 239.72,236.5 '
    keyPoints='0;0;0.93;1;1'
    keySplines='0.484 0 0.187 0.815;0.484 0 0.187 0.815;0.231 1 0.566 1;0 0 0 0'
    calcMode='spline'
  />
				<animateTransform
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_1_G_D_4_P_0_G_0_T_0'
    fill='freeze'
    attributeName='transform'
    from='-239.723 -236.5'
    to='-239.723 -236.5'
    type='translate'
    additive='sum'
    keyTimes='0;1'
    values='-239.723 -236.5;-239.723 -236.5'
    keySplines='0 0 1 1'
    calcMode='spline'
  />
				<animate
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_1_G_D_4_P_0'
    fill='freeze'
    attributeName='d'
    attributeType='XML'
    from='M-6.69 0 C-6.69,0 3.79,0 3.79,0 '
    to='M-3.79 0 C-3.79,0 3.79,0 3.79,0 '
    keyTimes='0;0.4545455;0.6363636;0.9090909;1'
    values='M-6.69 0 C-6.69,0 3.79,0 3.79,0 ;M-6.69 0 C-6.69,0 3.79,0 3.79,0 ;M-3.45 0 C-3.45,0 3.79,0 3.79,0 ;M-3.79 0 C-3.79,0 3.79,0 3.79,0 ;M-3.79 0 C-3.79,0 3.79,0 3.79,0 '
    keySplines='0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0 0 0 0'
    calcMode='spline'
  />
				<animateMotion
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_1_G_D_5_P_0_G_0_T_0'
    fill='freeze'
    keyTimes='0;0.4545455;0.6363636;0.9090909;1'
    path='M239.72 240 C239.72,240 239.72,240 239.72,240 C239.72,240 239.72,236.2 239.72,236.2 C239.72,236.2 239.72,236.5 239.72,236.5 C239.72,236.5 239.72,236.5 239.72,236.5 '
    keyPoints='0;0;0.93;1;1'
    keySplines='0.484 0 0.187 0.815;0.484 0 0.187 0.815;0.231 1 0.566 1;0 0 0 0'
    calcMode='spline'
  />
				<animateTransform
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_1_G_D_5_P_0_G_0_T_0'
    fill='freeze'
    attributeName='transform'
    from='-239.723 -236.5'
    to='-239.723 -236.5'
    type='translate'
    additive='sum'
    keyTimes='0;1'
    values='-239.723 -236.5;-239.723 -236.5'
    keySplines='0 0 1 1'
    calcMode='spline'
  />
				<animate
    repeatCount='1'
    dur='0.7333333s'
    begin='0s'
    xlinkHref='#_R_G_L_1_G_N_1_T_0_M'
    fill='freeze'
    attributeName='opacity'
    from='0'
    to='1'
    keyTimes='0;0.4545455;0.45455;1'
    values='0;0;1;1'
    keySplines='0 0 0 0;0 0 0 0;0 0 0 0'
    calcMode='spline'
  />
				<animate
    attributeType='XML'
    attributeName='opacity'
    dur='1s'
    from='0'
    to='1'
    xlinkHref='#time_group'
  />
			</defs>
			<g id='_R_G'>
				<g id='_R_G_L_2_G_N_1_T_0_M'>
					<g
    id='_R_G_L_2_G_N_1_T_0'
    transform=' translate(7, 7) translate(0, 0)'
  >
						<g id='_R_G_L_2_G' transform=' translate(0, 0)'>
							<path
    id='_R_G_L_2_G_D_0_P_0'
    stroke='#8000ff'
    strokeLinecap='round'
    strokeLinejoin='round'
    fill='none'
    strokeWidth='0.889'
    strokeOpacity='1'
    d=' M234.5 237 C234.5,237 234.5,245 234.5,245 C234.5,245 238,243 238,243 C238,243 242,245 242,245 C242,245 245.5,243 245.5,243 C245.5,243 245.5,235 245.5,235 C245.5,235 242,237 242,237 C242,237 238,235 238,235 C238,235 234.5,237 234.5,237z '
  />
							<path
    id='_R_G_L_2_G_D_1_P_0'
    stroke='#8000ff'
    strokeLinecap='round'
    strokeLinejoin='round'
    fill='none'
    strokeWidth='0.889'
    strokeOpacity='1'
    d=' M238 235 C238,235 238,243 238,243 '
  />
							<path
    id='_R_G_L_2_G_D_2_P_0'
    stroke='#8000ff'
    strokeLinecap='round'
    strokeLinejoin='round'
    fill='none'
    strokeWidth='0.889'
    strokeOpacity='1'
    d=' M242 237 C242,237 242,245 242,245 '
  />
						</g>
					</g>
				</g>
				<g id='_R_G_L_1_G_N_1_T_0_M'>
					<g
    id='_R_G_L_1_G_N_1_T_0'
    transform=' translate(7, 7) translate(0, 0)'
  >
						<g
    id='_R_G_L_1_G'
    transform=' translate(-0.277, 0) translate(-239.723, -240)'
  >
							<g id='_R_G_L_1_G_D_0_P_0_G_0_T_0'>
								<g
    id='_R_G_L_1_G_D_0_P_0_G_1_T_0'
    transform=' translate(241.458, 243.5) translate(0, 0)'
  >
									<path
    id='_R_G_L_1_G_D_0_P_0'
    stroke='#444444'
    strokeLinecap='round'
    strokeLinejoin='round'
    fill='none'
    strokeWidth='1.111'
    strokeOpacity='1'
    d=' M-6.72 0 C-6.72,0 3.79,0 3.79,0 '
  />
								</g>
							</g>
							<g id='_R_G_L_1_G_D_1_P_0_G_0_T_0'>
								<g
    id='_R_G_L_1_G_D_1_P_0_G_1_T_0'
    transform=' translate(234.754, 243.5) translate(0, 0)'
  >
									<path
    id='_R_G_L_1_G_D_1_P_0'
    fill='#444444'
    fillOpacity='1'
    fillRule='nonzero'
    d=' M0 0.56 C-0.31,0.56 -0.56,0.31 -0.56,0 C-0.56,-0.31 -0.31,-0.56 0,-0.56 C0,-0.56 0,-0.56 0,-0.56 C0.31,-0.56 0.56,-0.31 0.56,0 C0.56,0.31 0.31,0.56 0,0.56z '
  />
								</g>
							</g>
							<path
    id='_R_G_L_1_G_D_2_P_0'
    stroke='#444444'
    strokeLinecap='round'
    strokeLinejoin='round'
    fill='none'
    strokeWidth='1.111'
    strokeOpacity='1'
    d=' M234.77 240 C234.77,240 245.25,240 245.25,240 '
  />
							<path
    id='_R_G_L_1_G_D_3_P_0'
    fill='#444444'
    fillOpacity='1'
    fillRule='nonzero'
    d=' M234.76 240.56 C234.45,240.56 234.2,240.31 234.2,240 C234.2,239.69 234.44,239.44 234.75,239.44 C234.75,239.44 234.76,239.44 234.76,239.44 C235.06,239.44 235.31,239.69 235.31,240 C235.31,240.31 235.06,240.56 234.76,240.56z '
  />
							<g id='_R_G_L_1_G_D_4_P_0_G_0_T_0'>
								<g
    id='_R_G_L_1_G_D_4_P_0_G_1_T_0'
    transform=' translate(241.458, 236.5) translate(0, 0)'
  >
									<path
    id='_R_G_L_1_G_D_4_P_0'
    stroke='#444444'
    strokeLinecap='round'
    strokeLinejoin='round'
    fill='none'
    strokeWidth='1.111'
    strokeOpacity='1'
    d=' M-6.69 0 C-6.69,0 3.79,0 3.79,0 '
  />
								</g>
							</g>
							<g id='_R_G_L_1_G_D_5_P_0_G_0_T_0'>
								<g
    id='_R_G_L_1_G_D_5_P_0_G_1_T_0'
    transform=' translate(234.754, 236.5) translate(0, 0)'
  >
									<path
    id='_R_G_L_1_G_D_5_P_0'
    fill='#444444'
    fillOpacity='1'
    fillRule='nonzero'
    d=' M0 0.56 C-0.31,0.56 -0.56,0.31 -0.56,0 C-0.56,-0.31 -0.31,-0.56 0,-0.56 C0,-0.56 0,-0.56 0,-0.56 C0.31,-0.56 0.56,-0.31 0.56,0 C0.56,0.31 0.31,0.56 0,0.56z '
  />
								</g>
							</g>
						</g>
					</g>
				</g>
				<g
    id='_R_G_L_0_G'
    transform=' translate(7, 7) translate(0, 0)'
  />
			</g>
			<g id='time_group' />
		</svg>;
}, "MapToList");
var MapToList_default = MapToList;

// src/components/Itinerary/components/ItineraryViewSwitch/ItineraryViewSwitch.tsx
import { Text as Text3 } from "@headout/eevee";
var ItineraryViewSwitch = /* @__PURE__ */ __name(({
  viewMode = "timeline" /* Timeline */,
  onChangeViewMode,
  strings
}) => {
  const [activeViewMode, setActiveViewMode] = useState2(viewMode);
  useEffect(() => {
    setActiveViewMode(viewMode);
  }, [viewMode]);
  const handleChange = /* @__PURE__ */ __name((e) => {
    const mode = e.target.checked ? "map" /* Map */ : "timeline" /* Timeline */;
    setActiveViewMode(mode);
    onChangeViewMode == null ? void 0 : onChangeViewMode(mode);
  }, "handleChange");
  const checked = activeViewMode === "map" /* Map */;
  const toggleSwitchStyles = toggleSwitchContainerStylesRecipe({
    isChecked: checked
  });
  return <div
    className={toggleSwitchStyles.switchContainer}
    data-qa-marker='qaid-itinerary-view-toggle'
  >
			<Text3 textStyle='ui.label.medium' color='core.grey.800' as='span'>
				{strings.ITINERARY.TIMELINE_VIEW}
			</Text3>
			<div className={toggleSwitchStyles.root}>
				<input
    className={toggleSwitchStyles.inputElement}
    type='checkbox'
    checked={checked}
    onChange={handleChange}
  />
				<div className={toggleSwitchStyles.slider}>
					<div className={toggleSwitchStyles.iconContainer}>
						<Conditional if={checked}>
							<div className={toggleSwitchStyles.icon}>
								<ListToMap_default />
							</div>
						</Conditional>
						<Conditional if={!checked}>
							<div className={toggleSwitchStyles.icon}>
								<MapToList_default />
							</div>
						</Conditional>
					</div>
				</div>
			</div>
			<Text3 textStyle='ui.label.medium' color='core.grey.800' as='span'>
				{strings.ITINERARY.MAP_VIEW}
			</Text3>
		</div>;
}, "ItineraryViewSwitch");

// src/components/Itinerary/components/ItineraryDescriptorsCarousel/ItineraryDescriptorsCarousel.tsx
import { useRef } from "react";
import dynamic2 from "next/dynamic.js";

// src/components/Itinerary/components/ItineraryDescriptorsCarousel/styles.tsx
import { cva as cva2, sva as sva4 } from "@headout/pixie/css";
var itineraryDescriptorsCarouselContainerStylesRecipe = sva4({
  slots: ["root", "itineraryDescriptorsNoCarouselContainer"],
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      width: "[100%]",
      position: "relative",
      "& .swiper-wrapper": {
        maxWidth: "[calc(100vw - 2rem)]",
        paddingBottom: "space.1"
      }
    },
    itineraryDescriptorsNoCarouselContainer: {
      display: "flex",
      flexDirection: "row",
      width: "[100%]",
      "& .space-between": {
        justifyContent: "space-between"
      },
      "@media only screen and (min-width: 768px), print": {
        display: "grid",
        gridTemplateColumns: "[repeat(3, minmax(0, 1fr))]"
      }
    }
  }
});
var descriptorCarouselControlsStylesRecipe = cva2({
  base: {
    position: "absolute",
    top: "[40%]",
    transform: "[translateY(-40%)]",
    zIndex: 2,
    background: "[core.primary.white !important]",
    height: "[1.5rem !important]",
    width: "[1.5rem !important]",
    borderRadius: "radius.50p",
    border: "none",
    "& span": {
      marginBottom: "[0 !important]"
    }
  },
  variants: {
    type: {
      prev: {
        left: "-space.32"
      },
      next: {
        right: "-space.12"
      }
    }
  },
  defaultVariants: {
    type: "prev"
  }
});

// src/components/Itinerary/components/ItineraryDescriptorsCarousel/ItineraryDescriptorsCarousel.tsx
import { cx } from "@headout/pixie/css";
import { Button as Button2 } from "@headout/eevee";

// src/components/Itinerary/components/ItineraryDescriptorsCarousel/components/ItineraryDescriptorCard/styles.tsx
import { cva as cva3 } from "@headout/pixie/css";
var itineraryDescriptorCardStylesRecipe = cva3({
  base: {
    display: "flex",
    width: "fit-content",
    paddingRight: "space.16",
    marginRight: "space.16",
    borderRight: "[1px solid token(colors.semantic.dividers.primary)]",
    _last: {
      marginRight: 0,
      borderRight: "none"
    },
    "@media only screen and (min-width: 768px), print": {
      width: "[10.875rem]",
      marginRight: "space.16",
      paddingRight: 0,
      borderRight: "none",
      _last: {
        marginRight: "space.16"
      }
    }
  },
  variants: {
    fitContentWidth: {
      true: {
        width: "fit-content"
      }
    }
  }
});

// src/components/Itinerary/components/ItineraryDescriptorsCarousel/components/ItineraryDescriptorCard/ItineraryDescriptorCard.tsx
var ItineraryDescriptorCard = /* @__PURE__ */ __name(({
  type,
  itinerary,
  componentType,
  lang,
  strings
}) => {
  const itineraryDescriptorCardStyles = itineraryDescriptorCardStylesRecipe({
    fitContentWidth: componentType === "horizontal"
  });
  return <div className={itineraryDescriptorCardStyles}>
			<ItineraryDescriptors
    type={type}
    itinerary={itinerary}
    componentType={componentType}
    lang={lang}
    strings={strings}
  />
		</div>;
}, "ItineraryDescriptorCard");

// src/components/Itinerary/components/ItineraryDescriptorsCarousel/ItineraryDescriptorsCarousel.tsx
var Swiper = dynamic2(
  () => import(
    /* webpackChunkName: "Swiper" */
    "./components/common/CustomSwiper/index.jsx"
  ).then((m) => m.Swiper)
);
var ItineraryDescriptorsCarousel = /* @__PURE__ */ __name(({
  itinerary,
  lang,
  isMobile = false,
  strings
}) => {
  const isDesktop = !isMobile;
  const swiperRef = useRef(null);
  const { showLeftArrow, showRightArrow, onSlideChanged } = useSwiperArrows();
  const sliderOptions = {
    slidesToShow: isDesktop ? 4 : 3,
    slidesToScrollBy: 1,
    isMobile,
    swiperRef,
    onSlideChanged,
    nextPrevControls: "hide"
  };
  const descriptorTypes = getItineraryDescriptorsTypes(itinerary);
  const handlePrev = /* @__PURE__ */ __name(() => {
    var _a;
    return (_a = swiperRef.current) == null ? void 0 : _a.prevSlide();
  }, "handlePrev");
  const handleNext = /* @__PURE__ */ __name(() => {
    var _a;
    return (_a = swiperRef.current) == null ? void 0 : _a.nextSlide();
  }, "handleNext");
  const renderItineraryDescriptors = /* @__PURE__ */ __name(() => {
    return descriptorTypes.map((type) => {
      return <ItineraryDescriptorCard
        key={type}
        type={type}
        itinerary={itinerary}
        componentType={descriptorTypes.length <= 3 ? "horizontal" : "vertical"}
        lang={lang}
        strings={strings}
      />;
    });
  }, "renderItineraryDescriptors");
  const isSwiperRequired = (descriptorTypes == null ? void 0 : descriptorTypes.length) >= Number(sliderOptions.slidesToShow);
  const itineraryDescriptorsCarouselContainerStyles = itineraryDescriptorsCarouselContainerStylesRecipe();
  const descriptorCarouselPrevControlStyles = descriptorCarouselControlsStylesRecipe({
    type: "prev"
  });
  const descriptorCarouselNextControlStyles = descriptorCarouselControlsStylesRecipe({
    type: "next"
  });
  return <Conditional if={(descriptorTypes == null ? void 0 : descriptorTypes.length) > 0}>
			<div className={itineraryDescriptorsCarouselContainerStyles.root}>
				<Conditional if={isSwiperRequired}>
					<Swiper {...sliderOptions}>
						{renderItineraryDescriptors()}
					</Swiper>
				</Conditional>
				<Conditional if={!isSwiperRequired}>
					<div
    className={cx(
      itineraryDescriptorsCarouselContainerStyles.itineraryDescriptorsNoCarouselContainer,
      (descriptorTypes == null ? void 0 : descriptorTypes.length) === 3 && "space-between"
    )}
  >
						{renderItineraryDescriptors()}
					</div>
				</Conditional>
				<Conditional
    if={isSwiperRequired && showLeftArrow && isDesktop}
  >
					<Button2
    as='button'
    btnType='black'
    icon={<LeftArrow_default />}
    iconPosition='leading'
    onClick={handlePrev}
    primaryText=''
    size='small'
    state='default'
    variant='secondary'
    className={descriptorCarouselPrevControlStyles}
    style={{
      // TODO: PANDA gives error while adding so added as an inline style
      filter: "drop-shadow(0px 1.333px 5.333px rgba(0, 0, 0, 0.1)) drop-shadow(0px 0px 0.667px rgba(0, 0, 0, 0.1))"
    }}
  />
				</Conditional>
				<Conditional
    if={isSwiperRequired && showRightArrow && isDesktop}
  >
					<Button2
    as='button'
    btnType='black'
    icon={<RightArrow_default />}
    iconPosition='leading'
    onClick={handleNext}
    primaryText=''
    size='small'
    state='default'
    variant='secondary'
    className={descriptorCarouselNextControlStyles}
    style={{
      // TODO: PANDA gives error while adding so added as an inline style
      filter: "drop-shadow(0px 1.333px 5.333px rgba(0, 0, 0, 0.1)) drop-shadow(0px 0px 0.667px rgba(0, 0, 0, 0.1))"
    }}
  />
				</Conditional>
			</div>
		</Conditional>;
}, "ItineraryDescriptorsCarousel");

// src/components/Itinerary/Itinerary.tsx
import { Text as Text4 } from "@headout/eevee";

// src/components/Itinerary/hooks/useItinerary.ts
import { useMemo, useState as useState3 } from "react";
var useItinerary2 = /* @__PURE__ */ __name(({
  itineraryData = [],
  onActiveTabChange,
  isBot = false,
  trackEventFn,
  isPreviewMode = false,
  itineraryPreviewId
}) => {
  const isValidItineraryPreviewId = /* @__PURE__ */ __name((id) => {
    return itineraryData.some((item) => item.id === id);
  }, "isValidItineraryPreviewId");
  const getActiveTab = /* @__PURE__ */ __name(() => {
    var _a, _b;
    if (isPreviewMode && itineraryPreviewId && isValidItineraryPreviewId(itineraryPreviewId)) {
      return itineraryPreviewId.toString();
    }
    return (_b = (_a = itineraryData[0]) == null ? void 0 : _a.id.toString()) != null ? _b : "";
  }, "getActiveTab");
  const [activeTab, setActiveTab] = useState3(getActiveTab());
  const tabListItems = itineraryData.filter((item) => item).map(({ id, details: { routeName }, name }) => ({
    id: id.toString(),
    label: routeName || name
  }));
  const activeItineraryData = useMemo(() => {
    return itineraryData.filter((item) => item).find(({ id }) => id.toString() === activeTab);
  }, [activeTab]);
  const itineraryDescriptorTypes = useMemo(() => {
    if (activeItineraryData)
      return getItineraryDescriptorsTypes(activeItineraryData);
    return [];
  }, [activeItineraryData]);
  const startingPoints = useMemo(() => {
    if (activeItineraryData) {
      return activeItineraryData.sections.filter(
        (section) => section.type === "START_LOCATION" /* StartLocation */
      );
    }
  }, [activeItineraryData]);
  const stops = useMemo(() => {
    if (activeItineraryData) {
      return activeItineraryData.sections.filter(
        (section) => section.type === "STOP" /* Stop */
      );
    }
  }, [activeItineraryData]);
  const itinerariesToRender = (isBot ? itineraryData : [activeItineraryData]).filter((itineraryItem) => itineraryItem);
  const handleTabChange = /* @__PURE__ */ __name((tab) => {
    setActiveTab(tab.id);
    trackItineraryTabChange(tab);
    onActiveTabChange == null ? void 0 : onActiveTabChange(tab);
  }, "handleTabChange");
  const trackItineraryTabChange = /* @__PURE__ */ __name((activeItineraryTab) => {
    const newTab = itineraryData.find(
      ({ id }) => id.toString() === activeItineraryTab.id
    );
    const tabIndex = tabListItems.indexOf(activeItineraryTab);
    if (newTab) {
      const {
        id,
        name,
        details: { routeName }
      } = newTab;
      trackEventFn == null ? void 0 : trackEventFn({
        eventName: ANALYTICS_EVENTS.ITINERARY.ITINERARY_VARIANT_CLICKED,
        [ANALYTICS_PROPERTIES.ITINERARY_ID]: id,
        [ANALYTICS_PROPERTIES.ITINERARY_NAME]: routeName != null ? routeName : name,
        [ANALYTICS_PROPERTIES.RANKING]: tabIndex + 1
      });
    }
  }, "trackItineraryTabChange");
  const trackItineraryViewModeChange = /* @__PURE__ */ __name((activeView) => {
    trackEventFn == null ? void 0 : trackEventFn({
      eventName: ANALYTICS_EVENTS.ITINERARY.ITINERARY_TOGGLE_CLICKED,
      [ANALYTICS_PROPERTIES.ITINERARY_VIEW]: activeView
    });
  }, "trackItineraryViewModeChange");
  return {
    activeTab,
    setActiveTab,
    tabListItems,
    activeItineraryData,
    startingPoints,
    stops,
    itineraryDescriptorTypes,
    itinerariesToRender,
    handleTabChange,
    trackItineraryTabChange,
    trackItineraryViewModeChange
  };
}, "useItinerary");
var useItinerary_default = useItinerary2;

// src/components/Itinerary/styles.tsx
import { cva as cva4, sva as sva5 } from "@headout/pixie/css";
var spaceBlockStyles = cva4({
  base: {
    width: "[100%]"
  },
  variants: {
    gap: {
      "32": {
        height: "[2rem]"
      },
      "24": {
        height: "[1.5rem]"
      }
    }
  },
  defaultVariants: {
    gap: "32"
  }
});
var blockStylesRecipe = cva4({
  base: {
    display: "block",
    marginTop: 0
  },
  variants: {
    isVisible: {
      false: {
        display: "none"
      }
    },
    hasTabs: {
      true: {
        marginTop: "space.8"
      }
    }
  }
});
var itineraryStylesRecipe = sva5({
  slots: [
    "itinerarySectionContainer",
    "itineraryStopSwipeSheetWrapper",
    "itineraryMapSwipeSheetWrapper"
  ],
  base: {
    itinerarySectionContainer: {
      display: "flex",
      flexDirection: "column",
      width: "[100%]"
    },
    itineraryStopSwipeSheetWrapper: {
      zIndex: 101,
      position: "relative"
    },
    itineraryMapSwipeSheetWrapper: {
      zIndex: 100,
      position: "relative"
    }
  }
});
var tabRootMWebOverrideStyles = cva4({
  base: {},
  variants: {
    mwebPagePadding: {
      16: {
        marginLeft: "-space.16",
        width: "[calc(100% + 2rem)]"
      },
      24: {
        marginLeft: "-space.24",
        width: "[calc(100% + 3rem)]"
      }
    }
  },
  defaultVariants: {
    mwebPagePadding: 24
  }
});

// src/components/Itinerary/types.ts
var ESectionType = /* @__PURE__ */ ((ESectionType2) => {
  ESectionType2["StartLocation"] = "START_LOCATION";
  ESectionType2["Stop"] = "STOP";
  ESectionType2["EndLocation"] = "END_LOCATION";
  return ESectionType2;
})(ESectionType || {});
var EChildSectionType = /* @__PURE__ */ ((EChildSectionType2) => {
  EChildSectionType2["Attraction"] = "ATTRACTION";
  EChildSectionType2["Activity"] = "ACTIVITY";
  EChildSectionType2["FoodAndDrinks"] = "FOOD_DRINKS";
  EChildSectionType2["PassBy"] = "PASS_BY";
  return EChildSectionType2;
})(EChildSectionType || {});
var EInclusion = /* @__PURE__ */ ((EInclusion2) => {
  EInclusion2["AdmissionTicketIncluded"] = "ADMISSION_TICKET_INCLUDED";
  EInclusion2["FreeAdmission"] = "FREE_ADMISSION";
  EInclusion2["AdmissionTicketNotIncluded"] = "ADMISSION_TICKET_NOT_INCLUDED";
  EInclusion2["IncludedInCost"] = "INCLUDED_IN_COST";
  EInclusion2["IncludedDependingOnOptionSelected"] = "INCLUDED_DEPENDING_ON_OPTION_SELECTED";
  EInclusion2["IncludedAtAdditionalCost"] = "INCLUDED_AT_ADDITIONAL_COST";
  return EInclusion2;
})(EInclusion || {});
var ESubTypes = /* @__PURE__ */ ((ESubTypes2) => {
  ESubTypes2["Poi"] = "POI";
  ESubTypes2["Landmark"] = "LANDMARK";
  ESubTypes2["ShoppingCenter"] = "SHOPPING_CENTER";
  ESubTypes2["NeighbourhoodArea"] = "NEIGHBOURHOOD_AREA";
  ESubTypes2["SubsectionOfPoi"] = "SUBSECTION_OF_POI";
  ESubTypes2["HohoBusStop"] = "HOHO_BUS_STOP";
  ESubTypes2["SameAsMeetingPoint"] = "SAME_AS_MEETING_POINT";
  ESubTypes2["DifferentLocationButTheSameForTourGroup"] = "DIFFERENT_LOCATION_BUT_THE_SAME_FOR_A_TOUR_GROUP";
  ESubTypes2["DifferentLocationButChangesBasisSpOrTour"] = "DIFFERENT_LOCATION_BUT_CHANGES_BASIS_SP_OR_TOUR";
  ESubTypes2["Breakfast"] = "BREAKFAST";
  ESubTypes2["Lunch"] = "LUNCH";
  ESubTypes2["Snacks"] = "SNACKS";
  ESubTypes2["Dinner"] = "DINNER";
  ESubTypes2["Drinks"] = "DRINKS";
  ESubTypes2["Others"] = "OTHERS";
  ESubTypes2["StartingPointSameVendor"] = "STARTING_POINT_SAME_VENDOR";
  ESubTypes2["BoardFromStops"] = "BOARD_FROM_STOPS";
  ESubTypes2["ExperienceInvolvesPickup"] = "EXPERIENCE_INVOLVES_PICKUP";
  ESubTypes2["StartingPointVaries"] = "STARTING_POINT_VARIES";
  return ESubTypes2;
})(ESubTypes || {});
var EModeOfTravelOptions = /* @__PURE__ */ ((EModeOfTravelOptions2) => {
  EModeOfTravelOptions2["Car"] = "CAR";
  EModeOfTravelOptions2["Suv"] = "SUV";
  EModeOfTravelOptions2["Minivan"] = "MINIVAN";
  EModeOfTravelOptions2["BusCoach"] = "BUS_COACH";
  EModeOfTravelOptions2["Minibus"] = "MINIBUS";
  EModeOfTravelOptions2["Ferry"] = "FERRY";
  EModeOfTravelOptions2["Boat"] = "BOAT";
  EModeOfTravelOptions2["Speedboat"] = "SPEEDBOAT";
  EModeOfTravelOptions2["Yacht"] = "YACHT";
  EModeOfTravelOptions2["Ship"] = "SHIP";
  EModeOfTravelOptions2["Train"] = "TRAIN";
  EModeOfTravelOptions2["Walk"] = "WALK";
  return EModeOfTravelOptions2;
})(EModeOfTravelOptions || {});
var EItineraryViewMode = /* @__PURE__ */ ((EItineraryViewMode2) => {
  EItineraryViewMode2["Map"] = "map";
  EItineraryViewMode2["Timeline"] = "timeline";
  return EItineraryViewMode2;
})(EItineraryViewMode || {});
var EItineraryType = /* @__PURE__ */ ((EItineraryType2) => {
  EItineraryType2["Cruise"] = "CRUISE";
  EItineraryType2["Hoho"] = "HOHO";
  EItineraryType2["Generic"] = "GENERIC";
  return EItineraryType2;
})(EItineraryType || {});
var EPlatformName = /* @__PURE__ */ ((EPlatformName2) => {
  EPlatformName2["Mobile"] = "Mobile";
  EPlatformName2["Desktop"] = "Desktop";
  return EPlatformName2;
})(EPlatformName || {});

// src/components/Itinerary/Itinerary.tsx
var CruisesItinerary = dynamic3(
  () => import(
    /* webpackChunkName: "CruisesItinerary" */
    "./CruisesItinerary-ZHP6SQ6F.jsx"
  ).then((m) => m.CruisesItinerary)
);
var TimelineView = dynamic3(
  () => import(
    /* webpackChunkName: "TimelineView" */
    "./TimelineView-KF4ZPESS.jsx"
  ).then((m) => m.TimelineView)
);
var MapView = dynamic3(
  () => import(
    /* webpackChunkName: "MapView" */
    "./MapView-LTUIQ7TZ.jsx"
  ).then((m) => m.MapView),
  { ssr: false }
);
var Tabs = dynamic3(
  () => import(
    /* webpackChunkName: "Tabs" */
    "./components/common/Tabs/index.jsx"
  ).then(
    (m) => m.Tabs
  )
);
var ItinerarySwipeSheet = dynamic3(
  () => import(
    /* webpackChunkName: "ItinerarySwipeSheet" */
    "./ItinerarySwipeSheet-I24O7FXF.jsx"
  ).then((m) => m.ItinerarySwipeSheet)
);
var MWebMapView = dynamic3(
  () => import(
    /* webpackChunkName: "MWebMapView" */
    "./MWebMapView-AS6ZB7ZZ.jsx"
  ).then((m) => m.MWebMapView),
  { ssr: false }
);
var ItineraryComponent = /* @__PURE__ */ __name(({
  itineraryData = [],
  lang,
  onActiveTabChange,
  onToggleItinerarySwipeSheet,
  showTitle = true,
  isHohoItinerary = false,
  isCruisesItinerary = false,
  isMobile = false,
  isBot = false,
  additionalTrackingProperties,
  strings,
  trackEventFn,
  disablePathChange = false,
  isPreviewMode = false,
  itineraryPreviewId,
  usePortal = false,
  portalContainer,
  mwebPagePadding = 24
}) => {
  var _a;
  const router = useCompatibleRouter();
  const isDesktop = !isMobile;
  const {
    itineraryViewMode,
    setItineraryViewMode,
    setActiveItineraryStopId,
    setActiveStopIndex,
    setItinerarySwipeSheetDetailsConfig,
    itinerarySwipeSheetDetailsConfig,
    setAdditionalTrackingProperties
  } = useItinerary();
  const {
    activeTab,
    tabListItems,
    activeItineraryData,
    itineraryDescriptorTypes,
    itinerariesToRender,
    handleTabChange,
    trackItineraryViewModeChange
  } = useItinerary_default({
    itineraryData,
    onActiveTabChange,
    trackEventFn,
    isBot,
    isPreviewMode,
    itineraryPreviewId
  });
  useEffect2(() => {
    setItineraryViewMode("timeline" /* Timeline */);
  }, [activeItineraryData]);
  useEffect2(() => {
    onToggleItinerarySwipeSheet == null ? void 0 : onToggleItinerarySwipeSheet(itinerarySwipeSheetDetailsConfig.open);
    if (!itinerarySwipeSheetDetailsConfig.open && itineraryViewMode !== "timeline" /* Timeline */) {
      setActiveItineraryStopId(null);
      setActiveStopIndex(null);
      setItineraryViewMode("timeline" /* Timeline */);
    }
  }, [itinerarySwipeSheetDetailsConfig.open]);
  useEffect2(() => {
    if (additionalTrackingProperties) {
      setAdditionalTrackingProperties(additionalTrackingProperties);
    }
  }, []);
  useEffect2(() => {
    if (!router.isReady || isCruisesItinerary || disablePathChange) return;
    const path = router.asPath;
    if (path.includes(ITINERARY_STOP_SWIPESHEET_URL_IDENTIFIER) && !itinerarySwipeSheetDetailsConfig.open) {
      setItinerarySwipeSheetDetailsConfig(__spreadProps(__spreadValues({}, itinerarySwipeSheetDetailsConfig), {
        open: true,
        type: "stop"
      }));
    } else if (path.includes(ITINERARY_MAP_VIEW_SWIPESHEET_URL_IDENTIFIER) && !itinerarySwipeSheetDetailsConfig.open) {
      setItinerarySwipeSheetDetailsConfig(__spreadProps(__spreadValues({}, itinerarySwipeSheetDetailsConfig), {
        open: true,
        type: "map"
      }));
    } else if (!path.includes(ITINERARY_STOP_SWIPESHEET_URL_IDENTIFIER) && !path.includes(ITINERARY_MAP_VIEW_SWIPESHEET_URL_IDENTIFIER) && itinerarySwipeSheetDetailsConfig.open) {
      setItinerarySwipeSheetDetailsConfig(__spreadProps(__spreadValues({}, itinerarySwipeSheetDetailsConfig), {
        open: false,
        overlayStopSwipeSheet: false
      }));
    }
  }, [router.isReady, router.asPath]);
  const handleViewChange = /* @__PURE__ */ __name((activeView) => {
    setItineraryViewMode(activeView);
    trackItineraryViewModeChange(activeView);
  }, "handleViewChange");
  const hasMapView = (activeItineraryData == null ? void 0 : activeItineraryData.map) && (activeItineraryData == null ? void 0 : activeItineraryData.map.active);
  const handleStopSectionClick = /* @__PURE__ */ __name((sectionDetails) => {
    setActiveItineraryStopId(sectionDetails.id);
  }, "handleStopSectionClick");
  const handleCloseItinerarySwipeSheet = /* @__PURE__ */ __name(() => {
    setActiveItineraryStopId(null);
    setActiveStopIndex(null);
    if (itinerarySwipeSheetDetailsConfig.overlayStopSwipeSheet) {
      setItinerarySwipeSheetDetailsConfig(__spreadProps(__spreadValues({}, itinerarySwipeSheetDetailsConfig), {
        type: "map",
        overlayStopSwipeSheet: false
      }));
    } else {
      toggleItinerarySwipeSheet({ open: false, type: "stop" });
    }
  }, "handleCloseItinerarySwipeSheet");
  const handleCloseMapSwipeSheet = /* @__PURE__ */ __name(() => {
    setItineraryViewMode("timeline" /* Timeline */);
    toggleItinerarySwipeSheet({ open: false, type: "map" });
  }, "handleCloseMapSwipeSheet");
  const handleMapViewBannerClick = /* @__PURE__ */ __name(() => {
    toggleItinerarySwipeSheet({
      open: true,
      type: "map"
    });
    setItineraryViewMode("map" /* Map */);
  }, "handleMapViewBannerClick");
  const toggleItinerarySwipeSheet = /* @__PURE__ */ __name(({
    open,
    type
  }) => {
    setItinerarySwipeSheetDetailsConfig(__spreadValues(__spreadProps(__spreadValues({}, itinerarySwipeSheetDetailsConfig), {
      open,
      type
    }), !open ? { overlayStopSwipeSheet: false } : {}));
    if (!disablePathChange) {
      toggleItinerarySwipeSheetURLHash({
        open,
        type,
        router
      });
    }
  }, "toggleItinerarySwipeSheet");
  const itineraryStyles = itineraryStylesRecipe();
  const tabOverrideStyles = tabRootMWebOverrideStyles.raw({
    mwebPagePadding
  });
  if (isCruisesItinerary) {
    return <CruisesItinerary
      itineraryData={itineraryData}
      lang={lang}
      strings={strings}
      isBot={isBot}
      isMobile={isMobile}
      showTitle={showTitle}
      trackEventFn={trackEventFn}
      additionalTrackingProperties={additionalTrackingProperties}
      disablePathChange={disablePathChange}
    />;
  }
  return <div data-qa-marker='qaid-itinerary'>
			<Conditional if={showTitle}>
				<Text4
    textStyle='display.xs'
    color='core.grey.800'
    marginTop='space.32'
    marginBottom='space.16'
    id='itinerary-section-title'
    data-itinerary-section-title='true'
    data-qa-marker='qaid-itinerary-section-title'
    as='h6'
  >
					{isHohoItinerary ? strings.ITINERARY.ROUTES : strings.ITINERARY.TAB}
				</Text4>
			</Conditional>
			<div className={itineraryStyles.itinerarySectionContainer}>
				<Conditional if={(itineraryData == null ? void 0 : itineraryData.length) > 1}>
					<Tabs
    activeTab={activeTab}
    onChangeTab={handleTabChange}
    tabListItems={tabListItems}
    hideNavigationArrows={!isDesktop}
    tabRootOverrideStyles={isDesktop ? {} : tabOverrideStyles}
    initialTabOffset={isDesktop ? 0 : mwebPagePadding}
    markerLeftOffset={isDesktop ? 0 : mwebPagePadding}
    dataQAMarker='qaid-itinerary-route-tabs'
  />
				</Conditional>
				<Conditional
    if={!!activeItineraryData && !!((_a = Object.keys(activeItineraryData.details)) == null ? void 0 : _a.length) && !!(itineraryDescriptorTypes == null ? void 0 : itineraryDescriptorTypes.length)}
  >
					{itinerariesToRender.map((itineraryItem) => {
    const blockStyles = blockStylesRecipe({
      hasTabs: (itineraryData == null ? void 0 : itineraryData.length) > 1,
      isVisible: itineraryItem.id === (activeItineraryData == null ? void 0 : activeItineraryData.id)
    });
    return <div
      className={blockStyles}
      key={itineraryItem.id}
      data-qa-marker='qaid-itinerary-descriptors-carousel'
    >
								<ItineraryDescriptorsCarousel
      itinerary={itineraryItem}
      lang={lang}
      strings={strings}
      isMobile={isMobile}
    />
							</div>;
  })}
				</Conditional>
				<div className={spaceBlockStyles({ gap: "24" })} />
				<Conditional if={isDesktop && !!hasMapView}>
					<ItineraryViewSwitch
    viewMode={itineraryViewMode}
    onChangeViewMode={handleViewChange}
    strings={strings}
  />
					<div className={spaceBlockStyles()} />
				</Conditional>
				<Conditional if={!isDesktop && !!hasMapView}>
					<ItineraryMapViewBanner
    onClick={handleMapViewBannerClick}
    strings={strings}
  />
					<div className={spaceBlockStyles()} />
				</Conditional>
			</div>
			<Conditional
    if={!!activeItineraryData && itineraryViewMode === "timeline" /* Timeline */}
  >
				{itinerariesToRender.map((itineraryItem) => {
    const blockStyles = blockStylesRecipe({
      isVisible: itineraryItem.id === (activeItineraryData == null ? void 0 : activeItineraryData.id)
    });
    return <div className={blockStyles} key={itineraryItem.id}>
							<TimelineView
      itinerary={itineraryItem}
      variant={isDesktop && itineraryViewMode === "timeline" /* Timeline */ ? "DEFAULT" /* Default */ : "REDUCED_WIDTH" /* ReducedWidth */}
      onStopSectionClick={handleStopSectionClick}
      strings={strings}
      isMobile={isMobile}
      trackEventFn={trackEventFn}
      disablePathChange={disablePathChange}
      lang={lang}
    />
						</div>;
  })}
			</Conditional>
			<Conditional
    if={itineraryViewMode === "map" /* Map */ && !isMobile}
  >
				{activeItineraryData && <MapView
    itinerary={activeItineraryData}
    strings={strings}
    isMobile={isMobile}
    disablePathChange={disablePathChange}
  />}
			</Conditional>
			<Conditional
    if={isMobile && !!activeItineraryData && itinerarySwipeSheetDetailsConfig.open && (itinerarySwipeSheetDetailsConfig.type === "stop" || !!itinerarySwipeSheetDetailsConfig.overlayStopSwipeSheet)}
  >
				<div
    className={itineraryStyles.itineraryStopSwipeSheetWrapper}
    id='espeon-itinerary-stop-swipe-sheet-mweb'
  >
					<ItinerarySwipeSheet
    itinerary={activeItineraryData}
    visible={itinerarySwipeSheetDetailsConfig.open}
    strings={strings}
    trackEventFn={trackEventFn}
    currentLanguage={lang}
    onCloseSwipeSheet={handleCloseItinerarySwipeSheet}
    lang={lang}
    usePortal={usePortal}
    portalContainer={portalContainer}
  />
				</div>
			</Conditional>
			<Conditional
    if={isMobile && !!activeItineraryData && itinerarySwipeSheetDetailsConfig.open && (itinerarySwipeSheetDetailsConfig.type === "map" || !!itinerarySwipeSheetDetailsConfig.overlayStopSwipeSheet)}
  >
				<div
    className={itineraryStyles.itineraryMapSwipeSheetWrapper}
    id='espeon-itinerary-map-swipe-sheet-mweb'
  >
					<MWebMapView
    itinerary={activeItineraryData}
    strings={strings}
    onCloseInitBottomSheet={handleCloseMapSwipeSheet}
    usePortal={usePortal}
    portalContainer={portalContainer}
  />
				</div>
			</Conditional>
		</div>;
}, "ItineraryComponent");
var Itinerary = /* @__PURE__ */ __name((props) => {
  return <ItineraryProvider>
			<ItineraryComponent {...props} />
		</ItineraryProvider>;
}, "Itinerary");
Itinerary.displayName = "Itinerary";

// src/components/Itinerary/components/ItineraryMap/ItineraryMap.tsx
import { useCallback, useEffect as useEffect3, useRef as useRef2, useState as useState4 } from "react";
import dynamic4 from "next/dynamic.js";

// src/components/Itinerary/components/ItineraryMap/components/ResetButton/ResetButton.tsx
import { Button as Button3 } from "@headout/eevee";

// src/assets/svgIcons/Reset.tsx
var Reset = /* @__PURE__ */ __name((props) => <svg
  width={16}
  height={16}
  viewBox='0 0 16 16'
  fill='none'
  xmlns='http://www.w3.org/2000/svg'
  {...props}
>
		<path
  d='M15.333 2.667v4h-4'
  stroke='#444'
  strokeLinecap='round'
  strokeLinejoin='round'
/>
		<path
  d='M13.66 10a6 6 0 1 1-1.413-6.24l3.087 2.907'
  stroke='#444'
  strokeLinecap='round'
  strokeLinejoin='round'
/>
	</svg>, "Reset");
var Reset_default = Reset;

// src/components/Itinerary/components/ItineraryMap/components/ResetButton/styles.tsx
import { css } from "@headout/pixie/css";
var resetButtonStyles = css({
  position: "absolute !important",
  height: "[2rem]",
  width: "[2rem !important]",
  backgroundColor: "core.primary.white",
  border: "none !important",
  zIndex: 400,
  borderRadius: "radius.4",
  top: "space.12",
  right: "space.12",
  boxShadow: "[0px 4px 8px 0px #0000001f, 0px -1px 2px 0px #00000014]",
  "& span": {
    height: "[1rem]",
    width: "[1rem]"
  }
});

// src/components/Itinerary/components/ItineraryMap/components/ResetButton/ResetButton.tsx
var ResetButton = /* @__PURE__ */ __name(({ onClick }) => {
  return <Button3
    as='button'
    btnType='white'
    icon={<Reset_default />}
    iconPosition='leading'
    onClick={onClick}
    primaryText=''
    size='small'
    state='default'
    variant='primary'
    className={resetButtonStyles}
  />;
}, "ResetButton");

// src/components/Itinerary/components/ItineraryMap/utils.ts
import { renderToString } from "react-dom/server";

// src/components/Itinerary/components/ItineraryMap/constants.ts
var ICONS = {
  DEFAULT: "https://cdn-imgix-open.headout.com/itinerary/map/default-pin-v2.svg",
  START: "https://cdn-imgix-open.headout.com/itinerary/map/start-pin.svg",
  END: "https://cdn-imgix-open.headout.com/itinerary/map/end-pin.svg",
  PASS_BY: "https://cdn-imgix-open.headout.com/itinerary/map/pass-by-landmark.svg"
};
var ANALYTICS_PROPERTIES2 = {
  CLICK_TYPE: "Click Type",
  ZOOM_TYPE: "Zoom Type"
};
var ANALYTICS_EVENTS2 = {
  MAP_CLICKED: "Map Clicked",
  MAP_VIEWED: "Map Viewed",
  MAP_ZOOMED: "Map Zoomed"
};

// src/assets/svgIcons/EmptyMarker.tsx
var EmptyMarker = /* @__PURE__ */ __name((props) => <svg
  width={32}
  height={39}
  viewBox='0 0 32 39'
  fill='none'
  xmlns='http://www.w3.org/2000/svg'
  {...props}
>
		<path
  d='M16 0C7.163 0 0 7.163 0 16c0 6.422 3.784 11.96 9.244 14.508 2.031.948 3.955 2.256 5.03 4.223l1.392 2.547c.202.37.733.37.936 0l1.477-2.701c1.05-1.919 2.91-3.212 4.878-4.164C28.309 27.824 32 22.343 32 16c0-8.837-7.163-16-16-16'
  fill='#8000FF'
/>
		<path
  d='M.5 16C.5 7.44 7.44.5 16 .5S31.5 7.44 31.5 16c0 6.144-3.575 11.455-8.76 13.962-2.007.97-3.977 2.322-5.1 4.375l-1.477 2.7q-.008.014-.012.014l-.017.004a.04.04 0 0 1-.018-.004q-.003 0-.012-.013l-1.391-2.547c-1.15-2.104-3.188-3.47-5.258-4.436C4.165 27.587.5 22.22.5 16Z'
  stroke='#000'
  strokeOpacity={0.2}
/>
		<rect x={3} y={3} width={26} height={26} rx={13} fill='#F8F6FF' />
	</svg>, "EmptyMarker");
var EmptyMarker_default = EmptyMarker;

// src/components/Itinerary/components/ItineraryMap/components/NumberedMarkerIcon/NumberedMarkerIcon.tsx
import { token } from "@headout/pixie/tokens";
import { Text as Text5 } from "@headout/eevee";

// src/components/Itinerary/components/ItineraryMap/components/NumberedMarkerIcon/styles.tsx
import { sva as sva6 } from "@headout/pixie/css";
var numberedMarkerIconStylesRecipe = sva6({
  slots: ["iconWrapper", "markerText"],
  base: {
    iconWrapper: {
      position: "relative",
      width: "min-content",
      zIndex: 1,
      "& img": {
        height: "[2rem]"
      }
    },
    markerText: {
      position: "absolute",
      top: "[45%]",
      left: "[49%]",
      transform: "translate(-45%, -75%)",
      margin: 0,
      width: "max-content"
    }
  }
});

// src/components/Itinerary/components/ItineraryMap/components/NumberedMarkerIcon/NumberedMarkerIcon.tsx
var NumberedMarkerIcon = /* @__PURE__ */ __name(({
  title,
  stopNumber,
  color = "core.primary.purps"
}) => {
  const numberedMarkerIconStyles = numberedMarkerIconStylesRecipe();
  return <div className={numberedMarkerIconStyles.iconWrapper}>
			<EmptyMarker_default
    color={token(`colors.${color}`)}
    fill={token(`colors.${color}`)}
    aria-placeholder={title}
  />
			<Text5
    textStyle='ui.label.regular.heavy'
    color='core.primary.purps'
    className={numberedMarkerIconStyles.markerText}
  >
				{stopNumber}
			</Text5>
		</div>;
}, "NumberedMarkerIcon");

// src/components/Itinerary/components/ItineraryMap/utils.ts
var getIconProps = /* @__PURE__ */ __name((url, size = [45, 50], anchor = [22, 38]) => ({
  iconUrl: url,
  iconSize: size,
  iconAnchor: anchor,
  tooltipAnchor: [0, -5]
}), "getIconProps");
var iconsSetup = {
  default: getIconProps(ICONS.DEFAULT),
  start: getIconProps(ICONS.START),
  end: getIconProps(ICONS.END),
  passBy: getIconProps(ICONS.PASS_BY, [20, 20], [10, 10])
};
var getMarkerIconProps = /* @__PURE__ */ __name(({
  type,
  title,
  stopNumber,
  color,
  showStartAsStop = false
}) => {
  const { default: defaultIcon, start, end, passBy } = iconsSetup;
  const stopMarker = {
    html: renderToString(NumberedMarkerIcon({ title, stopNumber, color })),
    iconSize: [32, 38],
    iconAnchor: [16, 35],
    tooltipAnchor: [0, -15],
    className: "numbered-marker"
  };
  switch (type) {
    case "START_LOCATION" /* StartLocation */:
      return showStartAsStop ? stopMarker : start;
    case "END_LOCATION" /* EndLocation */:
      return end;
    case "PASS_BY" /* PassBy */:
    case "ATTRACTION" /* Attraction */:
      return passBy;
    case "STOP" /* Stop */:
      return stopMarker;
    default:
      return defaultIcon;
  }
}, "getMarkerIconProps");
var getChildMarkers = /* @__PURE__ */ __name((childSections, pushLocation) => {
  let childIndex = 0;
  const childMarkers = childSections.reduce((childAcc, childSection) => {
    if (!!childSection.location && !!childSection.details.name) {
      const { location, type, id, details } = childSection;
      const { name, passBy } = details;
      const { latitude = 0, longitude = 0 } = location || {};
      if (!passBy) childIndex++;
      const markerType = passBy ? "PASS_BY" /* PassBy */ : type;
      pushLocation(location);
      childAcc.push({
        id,
        element: childSection,
        position: {
          lat: latitude,
          lng: longitude
        },
        title: name,
        icon: getMarkerIconProps({
          type: markerType,
          title: name,
          stopNumber: childIndex
        }),
        autoFly: true
      });
    }
    return childAcc;
  }, []);
  return childMarkers;
}, "getChildMarkers");

// src/components/Itinerary/components/ItineraryMap/styles.tsx
import { css as css2 } from "@headout/pixie/css";
var mapContainerStyles = css2({
  position: "relative",
  height: "[100%]",
  width: "[100%]",
  // TODO: Look for an alternative to this
  "& .marker-title": {
    marginTop: "[1.5625rem !important]"
  },
  "& .leaflet-tooltip": {
    textStyle: "ui.label.small.heavy !important",
    color: "core.primary.black !important"
  },
  "& .leaflet-control-attribution": {
    textStyle: "ui.label.small !important",
    "& a": {
      textStyle: "ui.label.small !important",
      color: "[#0078A8 !important]"
    }
  }
});

// src/components/Itinerary/components/ItineraryMap/ItineraryMap.tsx
import { token as token2 } from "@headout/pixie/tokens";
import { css as css3, cx as cx2 } from "@headout/pixie/css";
var LeafletMap = dynamic4(
  () => import("./components/common/LeafletMap/index.jsx").then((m) => m.LeafletMap),
  {
    ssr: false
  }
);
var ItineraryMap = /* @__PURE__ */ __name(({
  itinerary,
  controller,
  onActiveSectionChange,
  onClickTrackEvent,
  onZoomTrackEvent,
  trackEventFn,
  zoomPadding = [60, 60],
  enableFreeTouchPropagation = false,
  onReset,
  mapChildToParent = true,
  showStartAsStop = false,
  legends = [],
  mapContainerOverrideStyles: mapContainerOverrideStylesProp,
  leafletContainerOverrideStyles,
  legendContainerOverrideStyles,
  hasRoundedCorners = false
}) => {
  const [markers, setMarkers] = useState4([]);
  const [zoomInfo, setZoomInfo] = useState4(null);
  const [currentZoom, setCurrentZoom] = useState4(0);
  const [mapPinClick, setMapPinClick] = useState4(false);
  const localController = useRef2(null);
  const mapController = controller != null ? controller : localController;
  useEffect3(() => {
    var _a;
    (_a = controller == null ? void 0 : controller.current) == null ? void 0 : _a.reset();
  }, [itinerary == null ? void 0 : itinerary.id]);
  const calculateMarkers = useCallback(() => {
    var _a, _b, _c;
    if (!(mapController == null ? void 0 : mapController.current)) return;
    let markers2 = [];
    let stopIndex = 0;
    const localZoomInfo = {};
    const currentZoom2 = (_a = mapController.current.map) == null ? void 0 : _a.getZoom();
    const childToParent = /* @__PURE__ */ new Map();
    markers2 = itinerary.sections.reduce((acc, section) => {
      if (section.details.name) {
        const {
          location,
          type,
          id,
          details,
          childSections = []
        } = section;
        const { name, passBy, sameAsStartingPoint } = details;
        if (type === "STOP" /* Stop */ && !passBy || showStartAsStop && type === "START_LOCATION" /* StartLocation */)
          stopIndex++;
        if (!isValidLocation(location) || showStartAsStop && sameAsStartingPoint)
          return acc;
        const { latitude = 0, longitude = 0 } = location;
        let markerType = passBy ? "PASS_BY" /* PassBy */ : type;
        if (showStartAsStop && type === "START_LOCATION" /* StartLocation */) {
          markerType = "STOP" /* Stop */;
        }
        const locations = [location];
        const pushLocation = /* @__PURE__ */ __name((location2) => {
          locations.push(location2);
        }, "pushLocation");
        const childMarkers = getChildMarkers(
          childSections,
          pushLocation
        );
        childSections.forEach(
          ({ id: id2 }) => childToParent.set(id2, section.id)
        );
        const bounds = mapController.current.calculateBounds(
          locations.map(({ latitude: latitude2 = 0, longitude: longitude2 = 0 }) => ({
            lat: latitude2,
            lng: longitude2
          }))
        );
        const parentPotentialZoom = mapController.current.map.getBoundsZoom(bounds, false);
        const isCenteringNeeded = parentPotentialZoom - currentZoom2 > 1;
        const finalParentZoom = isCenteringNeeded && childSections.length ? parentPotentialZoom - 1 : currentZoom2 + 1;
        localZoomInfo[id] = {
          bounds,
          zoom: finalParentZoom
        };
        acc.push({
          id,
          element: section,
          position: {
            lat: latitude,
            lng: longitude
          },
          title: name,
          icon: getMarkerIconProps({
            type: markerType,
            title: name,
            stopNumber: stopIndex,
            showStartAsStop
          }),
          autoFly: true,
          stickyTitleVisibilityLevel: finalParentZoom,
          hasPriority: true
        });
        acc.push(
          ...childMarkers.map((marker) => {
            const bounds2 = mapController.current.calculateBounds([
              {
                lat: marker.element.location.latitude,
                lng: marker.element.location.longitude
              }
            ]);
            localZoomInfo[marker.element.id] = {
              bounds: bounds2,
              zoom: finalParentZoom
            };
            return __spreadProps(__spreadValues({}, marker), {
              stickyTitleVisibilityLevel: finalParentZoom
            });
          })
        );
      }
      return acc;
    }, []);
    const zoomIntoSection = /* @__PURE__ */ __name(({
      section,
      childSection
    }) => {
      var _a2, _b2;
      const { id } = childSection != null ? childSection : section;
      if (!(localZoomInfo == null ? void 0 : localZoomInfo[id])) return;
      const { bounds, zoom } = localZoomInfo[id];
      if (childSection || !(section == null ? void 0 : section.childSections.length)) {
        (_a2 = mapController.current.map) == null ? void 0 : _a2.flyTo(bounds.getCenter(), zoom);
      } else
        (_b2 = mapController.current.map) == null ? void 0 : _b2.flyToBounds(bounds, {
          padding: zoomPadding
        });
    }, "zoomIntoSection");
    if (!zoomInfo) {
      setZoomInfo(localZoomInfo);
    }
    setMarkers(
      markers2.reverse().map((marker) => __spreadProps(__spreadValues({}, marker), {
        onClick: /* @__PURE__ */ __name(() => {
          var _a2;
          setMapPinClick(true);
          setTimeout(() => {
            setMapPinClick(false);
          }, 3e3);
          const { element, title } = marker || {};
          const { type, rank } = element != null ? element : {};
          onClickTrackEvent == null ? void 0 : onClickTrackEvent({
            type,
            stopName: title,
            stopNumber: rank
          });
          onActiveSectionChange == null ? void 0 : onActiveSectionChange(
            mapChildToParent ? (_a2 = childToParent.get(marker.element.id)) != null ? _a2 : marker.element.id : marker.element.id
          );
          const isSection = Array.isArray(
            marker.element.childSections
          );
          const sectionName = isSection ? "section" : "childSection";
          zoomIntoSection == null ? void 0 : zoomIntoSection({ [sectionName]: marker.element });
        }, "onClick")
      }))
    );
    mapController.current.zoomIntoSection = zoomIntoSection;
    (_c = (_b = mapController.current) == null ? void 0 : _b.map) == null ? void 0 : _c.invalidateSize();
  }, [itinerary, !!(mapController == null ? void 0 : mapController.current), onActiveSectionChange]);
  const handleZoomChange = /* @__PURE__ */ __name((zoom) => {
    setCurrentZoom(zoom);
    if (!mapPinClick && currentZoom !== 0) {
      onZoomTrackEvent == null ? void 0 : onZoomTrackEvent({
        zoomType: zoom > currentZoom ? "Zoom In" : "Zoom Out"
      });
    }
  }, "handleZoomChange");
  const handleFreeTouch = /* @__PURE__ */ __name((e) => {
    if (!enableFreeTouchPropagation) e.stopPropagation();
    const { className } = e.target;
    if (typeof className === "string" && className.includes("leaflet-touch")) {
      trackEventFn == null ? void 0 : trackEventFn({
        eventName: ANALYTICS_EVENTS2.MAP_CLICKED,
        [ANALYTICS_PROPERTIES2.CLICK_TYPE]: "Free Area"
      });
    }
  }, "handleFreeTouch");
  const handleReset = /* @__PURE__ */ __name(() => {
    var _a;
    (_a = mapController == null ? void 0 : mapController.current) == null ? void 0 : _a.reset();
    onReset == null ? void 0 : onReset();
  }, "handleReset");
  useEffect3(() => {
    var _a;
    (_a = controller == null ? void 0 : controller.current) == null ? void 0 : _a.reset();
  }, [markers]);
  if (!itinerary.map) return null;
  const {
    polyline,
    polylineColor,
    active: isItineraryRouteActive
  } = itinerary.map.itineraryRoute || {};
  const mapContainerOverrideStyles = css3(mapContainerOverrideStylesProp);
  return <div
    role='button'
    tabIndex={0}
    className={cx2(mapContainerStyles, mapContainerOverrideStyles)}
    onClick={handleFreeTouch}
    onTouchEnd={handleFreeTouch}
    onKeyDown={() => {
    }}
  >
			<LeafletMap
    lines={isItineraryRouteActive && polyline ? [
      {
        path: polyline,
        options: {
          color: polylineColor != null ? polylineColor : token2("colors.core.primary.purps"),
          lineJoin: "round"
        }
      }
    ] : itinerary.sections.length ? [
      {
        path: itinerary.sections.reduce((acc, { location }) => {
          if (location && isValidLocation(location)) {
            acc.push({
              lat: location.latitude,
              lng: location.longitude
            });
          }
          return acc;
        }, []),
        visible: false
      }
    ] : []}
    markers={markers}
    maxZoomLevel={18}
    showZoomControls={false}
    onMapLoad={(map, calculateBounds, reset) => {
      if (map && reset && mapController && !mapController.current) {
        mapController.current = {
          map,
          reset,
          calculateBounds
        };
        calculateMarkers();
      }
    }}
    onMapUnload={() => {
      if (mapController == null ? void 0 : mapController.current) {
        mapController.current = null;
      }
    }}
    onZoomChanged={handleZoomChange}
    legends={legends}
    legendContainerOverrideStyles={legendContainerOverrideStyles}
    mapContainerStyles={leafletContainerOverrideStyles}
    hasRoundedCorners={hasRoundedCorners}
  />
			<ResetButton onClick={handleReset} />
		</div>;
}, "ItineraryMap");

// src/components/Itinerary/utils.ts
var DEFAULT_VALUE = {
  passby: null,
  stop: null
};
var isValidLocation = /* @__PURE__ */ __name((location) => !!location && location.latitude !== 0 && location.longitude !== 0, "isValidLocation");
var sectionDataSanitizer = /* @__PURE__ */ __name((sections, itineraryType) => {
  var _a, _b;
  const isHOHO = isHOHOItinerary(itineraryType);
  const startLocations = sections.filter(
    (section) => section.type === "START_LOCATION" /* StartLocation */
  );
  const hasStartLocation = !!startLocations.length;
  const startLocationDescriptors = hasStartLocation ? {
    inclusion: startLocations[0].details.inclusion,
    duration: startLocations[0].details.timeSpent || 0,
    attractionsCount: startLocations[0].attractionsCount,
    activitiesCount: startLocations[0].activitiesCount,
    location: startLocations[0].location
  } : {};
  const startLocationGroup = hasStartLocation ? {
    passby: null,
    stop: isHOHO ? null : {
      descriptors: startLocationDescriptors,
      sectionDetails: startLocations[0],
      position: 0,
      defaultOpen: startLocations.length > 1,
      findDirections: isValidLocation(
        startLocations[0].location
      ),
      subCards: !startLocations.length ? [] : startLocations.length > 1 ? startLocations.map((section, index) => ({
        descriptors: {
          inclusion: section.details.inclusion,
          duration: section.details.timeSpent || 0,
          attractionsCount: section.attractionsCount,
          activitiesCount: section.activitiesCount,
          location: section.location
        },
        sectionDetails: __spreadProps(__spreadValues({}, section), {
          rank: index + 1
        }),
        isSubSection: false,
        position: index + 1,
        findDirections: isValidLocation(
          section.location
        )
      })) : startLocations[0].childSections.map(
        (child, index) => ({
          descriptors: {
            inclusion: child.details.inclusion,
            duration: child.details.timeSpent || 0,
            foodTypes: child.type === "FOOD_DRINKS" /* FoodAndDrinks */ ? child.details.subType : void 0,
            location: child.location
          },
          subSectionDetails: __spreadProps(__spreadValues({}, child), {
            details: __spreadProps(__spreadValues({}, child.details), {
              passBy: isHOHO || child.details.passBy
            }),
            rank: index + 1
          }),
          position: index + 1,
          isSubSection: true
        })
      )
    }
  } : DEFAULT_VALUE;
  const endLocations = sections.filter(
    (section) => section.type === "END_LOCATION" /* EndLocation */
  );
  const hasEndLocation = !!endLocations.length;
  const stopLocations = sections.filter(
    ({ type }) => type === "STOP" /* Stop */
  );
  const stopLocationProps = stopLocations.map(
    (stop, index) => {
      var _a2;
      let subCardPosition = 0;
      return {
        passby: stop.details.passBy ? {
          stops: [
            {
              id: stop.id,
              title: stop.details.name,
              image: (_a2 = stop.details.mediaUrls) == null ? void 0 : _a2[0],
              description: stop.details.description,
              link: stop.location && generateGoogleMapPlacesUrl(
                stop.location
              ),
              type: stop.type,
              subType: stop.details.subType
            }
          ]
        } : null,
        stop: stop.details.passBy ? null : {
          descriptors: isHOHO ? {
            attractionsCount: stop.attractionsCount,
            location: stop.location
          } : {
            inclusion: stop.details.inclusion,
            duration: stop.details.timeSpent || 0,
            attractionsCount: stop.attractionsCount,
            activitiesCount: stop.activitiesCount,
            location: stop.location
          },
          sectionDetails: __spreadProps(__spreadValues({}, stop), {
            location: isHOHO ? stop.location : void 0
          }),
          findDirections: isHOHO ? isValidLocation(stop.location) : false,
          position: index + startLocations.length,
          subCards: stop.childSections.map((child, index2) => {
            subCardPosition += child.details.passBy ? 0 : 1;
            return {
              descriptors: isHOHO ? {
                location: child.location
              } : {
                inclusion: child.details.inclusion,
                duration: child.details.timeSpent || 0,
                foodTypes: child.type === "FOOD_DRINKS" /* FoodAndDrinks */ ? child.details.subType : void 0,
                location: child.location
              },
              subSectionDetails: __spreadProps(__spreadValues({}, child), {
                details: __spreadProps(__spreadValues({}, child.details), {
                  passBy: isHOHO || child.details.passBy
                }),
                rank: index2 + 1
              }),
              position: subCardPosition,
              isSubSection: true
            };
          })
        }
      };
    }
  );
  const finalStops = [];
  let lastStopIndex = 0;
  stopLocationProps.forEach((prop, index) => {
    var _a2, _b2;
    if (prop.passby) {
      if (index === 0) finalStops.push(prop);
      else {
        if (finalStops[finalStops.length - 1].passby) {
          (_b2 = (_a2 = finalStops[finalStops.length - 1].passby) == null ? void 0 : _a2.stops) == null ? void 0 : _b2.push(
            prop.passby.stops[0]
          );
        } else {
          finalStops.push(prop);
        }
      }
    } else if (prop.stop) {
      lastStopIndex++;
      finalStops.push(__spreadProps(__spreadValues({}, prop), {
        stop: __spreadProps(__spreadValues({}, prop.stop), {
          position: lastStopIndex,
          isForcedStart: !hasStartLocation || isHOHO ? lastStopIndex === 1 : false,
          isForcedEnd: !hasEndLocation || isHOHO ? index + 1 === stopLocationProps.length : false
        })
      }));
    }
  });
  const endLocationDescriptors = hasEndLocation ? {
    inclusion: endLocations[0].details.inclusion,
    duration: endLocations[0].details.timeSpent || 0,
    attractionsCount: endLocations[0].attractionsCount,
    activitiesCount: endLocations[0].activitiesCount,
    location: endLocations[0].location
  } : {};
  const endLocationGroup = hasEndLocation ? {
    passby: null,
    stop: isHOHO ? null : endLocations[0].details.sameAsStartingPoint && hasStartLocation ? __spreadProps(__spreadValues({}, startLocationGroup.stop), {
      sectionDetails: __spreadProps(__spreadValues({}, startLocationGroup.stop.sectionDetails), {
        id: endLocations[0].id,
        type: "END_LOCATION" /* EndLocation */,
        details: __spreadProps(__spreadValues({}, (_b = (_a = startLocationGroup.stop) == null ? void 0 : _a.sectionDetails) == null ? void 0 : _b.details), {
          sameAsStartingPoint: true
        })
      }),
      findDirections: false,
      isForcedStart: false,
      position: 1 + stopLocations.length,
      subCards: startLocations.length > 1 ? startLocations.map(
        (section, index) => ({
          descriptors: {
            inclusion: section.details.inclusion,
            duration: section.details.timeSpent || 0,
            attractionsCount: section.attractionsCount,
            activitiesCount: section.activitiesCount,
            location: section.location
          },
          position: index + 1,
          sectionDetails: __spreadProps(__spreadValues({}, section), {
            type: "END_LOCATION" /* EndLocation */,
            details: __spreadProps(__spreadValues({}, section.details), {
              sameAsStartingPoint: true
            }),
            rank: index + 1
          }),
          isSubSection: false
        })
      ) : []
    }) : {
      descriptors: endLocationDescriptors,
      sectionDetails: endLocations[0],
      position: 1 + stopLocations.length,
      findDirections: isValidLocation(
        endLocations[0].location
      ),
      defaultOpen: endLocations.length > 1,
      subCards: !endLocations.length ? [] : endLocations.length > 1 ? endLocations.map(
        (section, index) => ({
          descriptors: {
            inclusion: section.details.inclusion,
            duration: section.details.timeSpent || 0,
            attractionsCount: section.attractionsCount,
            activitiesCount: section.activitiesCount,
            location: section.location
          },
          sectionDetails: __spreadProps(__spreadValues({}, section), {
            rank: index + 1
          }),
          isSubSection: false,
          position: index + 1,
          findDirections: isValidLocation(
            section.location
          )
        })
      ) : endLocations[0].childSections.map(
        (child, index) => ({
          descriptors: {
            inclusion: child.details.inclusion,
            duration: child.details.timeSpent || 0,
            foodTypes: child.type === "FOOD_DRINKS" /* FoodAndDrinks */ ? child.details.subType : void 0,
            location: child.location
          },
          subSectionDetails: __spreadProps(__spreadValues({}, child), {
            details: __spreadProps(__spreadValues({}, child.details), {
              passBy: isHOHO || child.details.passBy
            }),
            rank: index + 1
          }),
          position: index + 1,
          isSubSection: true
        })
      )
    }
  } : DEFAULT_VALUE;
  const finalStopsAndPassBys = [
    startLocationGroup,
    ...finalStops,
    endLocationGroup
  ].filter(({ stop, passby }) => stop || passby);
  return finalStopsAndPassBys;
}, "sectionDataSanitizer");
var generateGoogleMapUrl = /* @__PURE__ */ __name(({
  latitude,
  longitude,
  placeId
}) => {
  const baseURL = "https://www.google.com/maps/dir/?api=1";
  return `${baseURL}&destination=${latitude},${longitude}${placeId ? `&destination_place_id=${placeId}` : ""}`;
}, "generateGoogleMapUrl");
var generateGoogleMapPlacesUrl = /* @__PURE__ */ __name(({
  latitude,
  longitude,
  placeId
}) => {
  const baseURL = "https://www.google.com/maps/search/?api=1";
  return `${baseURL}&query=${latitude},${longitude}${placeId ? `&query_place_id=${placeId}` : ""}`;
}, "generateGoogleMapPlacesUrl");
var getItineraryDescriptorsTypes = /* @__PURE__ */ __name((itinerary) => {
  const { details } = itinerary;
  const detailsKeys = Object.keys(details);
  return Object.keys(ITINERARY_DESCRIPTORS_DATA).reduce(
    (result, key) => {
      var _a;
      const descriptorData = ITINERARY_DESCRIPTORS_DATA[key];
      const isSubset = isSubsetArray(
        detailsKeys,
        descriptorData.fieldIdentifier
      );
      const shouldInclude = !descriptorData.hideIfFieldsPresent || !isSubsetArray(
        detailsKeys,
        (_a = descriptorData.hideIfFieldsPresent) != null ? _a : []
      );
      if (isSubset && shouldInclude) {
        result.push(key);
      }
      return result;
    },
    []
  );
}, "getItineraryDescriptorsTypes");
var isHOHOItinerary = /* @__PURE__ */ __name((itineraryType) => {
  return itineraryType === "HOHO" /* Hoho */;
}, "isHOHOItinerary");
var isCruiseItinerary = /* @__PURE__ */ __name((itineraryType) => {
  return itineraryType === "CRUISE" /* Cruise */;
}, "isCruiseItinerary");
var isItineraryValid = /* @__PURE__ */ __name((itinerary) => {
  if (!itinerary.active || !itinerary.sections.length) return false;
  return true;
}, "isItineraryValid");
var checkIfItineraryHasSameStartAndEndPoint = /* @__PURE__ */ __name((itinerarySectionsData) => {
  var _a;
  const endLocation = itinerarySectionsData.find(({ stop }) => {
    var _a2;
    if (stop) {
      const { type } = (_a2 = (stop == null ? void 0 : stop.isSubSection) ? stop.subSectionDetails : stop.sectionDetails) != null ? _a2 : {};
      return type === "END_LOCATION" /* EndLocation */;
    }
  });
  if (!endLocation) return false;
  const sectionDetails = ((_a = endLocation == null ? void 0 : endLocation.stop) == null ? void 0 : _a.isSubSection) ? endLocation.stop.subSectionDetails : endLocation.stop.sectionDetails;
  return sectionDetails == null ? void 0 : sectionDetails.details.sameAsStartingPoint;
}, "checkIfItineraryHasSameStartAndEndPoint");
var getItineraryAdditionalTrackingPayload = /* @__PURE__ */ __name((additionalTrackingProperties) => {
  if (!additionalTrackingProperties) return {};
  return {
    [ANALYTICS_PROPERTIES.CITY]: additionalTrackingProperties.city,
    [ANALYTICS_PROPERTIES.COUNTRY]: additionalTrackingProperties.country,
    [ANALYTICS_PROPERTIES.TGID]: additionalTrackingProperties.tgid,
    [ANALYTICS_PROPERTIES.CATEGORY_ID]: additionalTrackingProperties.categoryId,
    [ANALYTICS_PROPERTIES.CATEGORY_NAME]: additionalTrackingProperties.categoryName,
    [ANALYTICS_PROPERTIES.COLLECTION_ID]: additionalTrackingProperties.collectionId,
    [ANALYTICS_PROPERTIES.COLLECTION_NAME]: additionalTrackingProperties.collectionName,
    [ANALYTICS_PROPERTIES.EXPERIENCE_NAME]: additionalTrackingProperties.experienceName,
    [ANALYTICS_PROPERTIES.TGID]: additionalTrackingProperties.tgid,
    [ANALYTICS_PROPERTIES.PAGE_TYPE]: additionalTrackingProperties.pageType
  };
}, "getItineraryAdditionalTrackingPayload");
var toggleItinerarySwipeSheetURLHash = /* @__PURE__ */ __name(({
  open,
  type,
  router
}) => {
  if (open) {
    const currentURL = new URL(router.asPath, window.location.origin);
    currentURL.hash = type === "stop" ? ITINERARY_STOP_SWIPESHEET_URL_IDENTIFIER : ITINERARY_MAP_VIEW_SWIPESHEET_URL_IDENTIFIER;
    router.push(currentURL.toString(), currentURL.toString(), {
      shallow: true,
      scroll: false
    });
  } else {
    router.back();
  }
}, "toggleItinerarySwipeSheetURLHash");
var getItineraryDuration = /* @__PURE__ */ __name(({
  duration,
  lang
}) => {
  if (!duration) return "";
  const { hours = null, minutes = null } = duration || {};
  return formatDurationToString({
    hour: hours,
    minute: minutes,
    lang
  });
}, "getItineraryDuration");
var getItineraryTiming = /* @__PURE__ */ __name(({
  firstDepartureTime,
  lastDepartureTime,
  lang
}) => {
  if (!firstDepartureTime || !lastDepartureTime) return "";
  const startTime = getIntlTime({
    time: firstDepartureTime,
    lang
  });
  const endTime = getIntlTime({
    time: lastDepartureTime,
    lang
  });
  return `${startTime} - ${endTime}`;
}, "getItineraryTiming");
var isValidMap = /* @__PURE__ */ __name((sections) => sections == null ? void 0 : sections.some(
  (section) => {
    var _a, _b;
    return ((_a = section == null ? void 0 : section.location) == null ? void 0 : _a.latitude) && ((_b = section == null ? void 0 : section.location) == null ? void 0 : _b.longitude);
  }
), "isValidMap");

// src/components/Itinerary/components/TimelineView/styles.tsx
import { cva as cva5 } from "@headout/pixie/css";
var timelineViewContainerStylesRecipe = cva5({
  base: {
    width: "[100%]"
  },
  variants: {
    variant: {
      ["REDUCED_WIDTH" /* ReducedWidth */]: {
        "@media only screen and (min-width: 768px), print": {
          maxWidth: "[16.25rem]"
        }
      },
      ["DEFAULT" /* Default */]: {}
    }
  }
});

// src/components/Itinerary/components/TimelineView/components/PassesByCard/PassesByCard.tsx
import React8 from "react";

// src/components/Itinerary/components/TimelineView/components/PassesByCard/styles.tsx
import { sva as sva7 } from "@headout/pixie/css";
var subCardHeadingContainerStylesRecipe = sva7({
  className: "subCardHeadingContainer",
  slots: ["root", "subSectionHeading", "imageWrapper"],
  base: {
    root: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: "[0.4375rem]",
      "& svg": {
        transition: "[transform 0.3s]",
        "& path": {
          transition: "[stroke 0.3s]",
          stroke: "core.grey.800"
        }
      },
      _hover: {
        "& .subCardHeadingContainer__passingBySubCardTitle": {
          color: "core.grey.900"
        },
        "& svg.arrow-link": {
          transform: "[rotate(-45deg)]",
          "& path": {
            stroke: "core.grey.900"
          }
        }
      }
    },
    subSectionHeading: {
      textStyle: "subheading.regular",
      color: "core.primary.purps",
      marginTop: "[0.25rem]"
    },
    imageWrapper: {
      width: "[1.25rem]",
      height: "[1.25rem]",
      "& img": {
        borderRadius: "radius.4"
      },
      "@media only screen and (min-width: 768px)": {
        width: "[2rem]",
        height: "[1.25rem]"
      }
    }
  },
  variants: {
    variant: {
      ["REDUCED_WIDTH" /* ReducedWidth */]: {
        imageWrapper: {
          "@media only screen and (min-width: 768px)": {
            height: "[1rem]",
            width: "[1.625rem]"
          }
        }
      },
      ["DEFAULT" /* Default */]: {}
    }
  }
});
var passesByCardStylesRecipe = sva7({
  slots: ["container", "heading"],
  base: {
    container: {
      position: "relative",
      padding: "[0.1875rem token(spacing.space.8) token(spacing.space.20) 2.25rem]",
      transition: "[all 0.3s]",
      display: "flex",
      flexDirection: "column",
      gap: "space.8",
      _before: {
        content: '""',
        position: "absolute",
        height: "[100%]",
        width: "[0.125rem]",
        top: 0,
        left: "[0.75rem]",
        transform: "[translateX(-50%)]",
        background: "core.primary.purps"
      }
    },
    heading: {
      textStyle: "ui.label.large.heavy",
      color: "core.candy.500",
      margin: 0,
      position: "relative",
      _before: {
        content: '""',
        position: "absolute",
        height: "[0.75rem]",
        width: "[0.75rem]",
        top: "[50%]",
        left: "[-1.125rem]",
        transform: "[translate(-100%, -35%)]",
        borderRadius: "[100px]",
        background: "core.primary.purps"
      }
    }
  },
  variants: {
    variant: {
      ["REDUCED_WIDTH" /* ReducedWidth */]: {
        heading: {
          textStyle: "ui.label.regular.heavy",
          color: "core.grey.700"
        },
        container: {
          padding: "[0.1875rem token(spacing.space.8) token(spacing.space.20) 2.25rem]",
          "@media only screen and (min-width: 768px)": {
            padding: "[0.1875rem token(spacing.space.8) token(spacing.space.20) 2.25rem]"
          }
        }
      },
      ["DEFAULT" /* Default */]: {}
    },
    isCruiseItinerary: {
      true: {}
    }
  },
  compoundVariants: [
    {
      variant: "REDUCED_WIDTH" /* ReducedWidth */,
      isCruiseItinerary: true,
      css: {
        container: {
          padding: "[0.1875rem token(spacing.space.8) token(spacing.space.20) token(spacing.space.40)]"
        }
      }
    }
  ]
});

// src/components/Itinerary/components/TimelineView/components/PassesByCard/components/PassingBySubCard/PassingBySubCard.tsx
import { useState as useState5 } from "react";

// src/components/Itinerary/components/TimelineView/components/SubStopCard/SubStopCard.tsx
import { useMemo as useMemo2 } from "react";
import dynamic5 from "next/dynamic.js";

// src/components/Itinerary/components/TimelineView/components/SubStopCard/styles.tsx
import { sva as sva8 } from "@headout/pixie/css";
var subStopsStylesRecipe = sva8({
  slots: [
    "container",
    "contentContainer",
    "name",
    "duration",
    "arrow",
    "iconContainer",
    "imageWrap"
  ],
  base: {
    container: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: "space.8",
      width: "[calc(100% - 1rem)]",
      backgroundColor: "core.grey.100",
      borderRadius: "radius.8",
      padding: "space.8",
      cursor: "default"
    },
    iconContainer: {
      height: "[2.1875rem]",
      width: "[3.5rem]",
      borderRadius: "radius.4",
      backgroundColor: "core.grey.700",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexShrink: 0,
      "& svg": {
        "& path": {
          stroke: "core.primary.white"
        }
      }
    },
    contentContainer: {
      display: "grid",
      gridTemplateAreas: "'name' 'duration'",
      gridTemplateRows: "[1fr auto]",
      columnGap: "space.8",
      rowGap: "space.2",
      flexGrow: 1
    },
    name: {
      display: "[-webkit-box]",
      overflow: "hidden",
      textOverflow: "ellipsis",
      gridArea: "name",
      lineHeight: "lh.20",
      lineClamp: 1
    },
    duration: {
      gridArea: "duration"
    },
    arrow: {
      gridArea: "arrow",
      alignSelf: "center",
      "& path": {
        stroke: "core.grey.800"
      }
    },
    imageWrap: {
      height: "[2.25rem]",
      width: "[3.5rem]",
      aspectRatio: 1.6,
      flexShrink: 0,
      "& img": {
        borderRadius: "radius.4"
      }
    }
  },
  variants: {
    isClickable: {
      true: {
        container: {
          cursor: "pointer"
        },
        contentContainer: {
          gridTemplateAreas: "'name arrow' 'duration arrow'",
          gridTemplateColumns: "[1fr 0.75rem]"
        }
      }
    }
  }
});

// src/components/Itinerary/components/TimelineView/components/SubStopCard/SubStopCard.tsx
import { cx as cx3 } from "@headout/pixie/css";
import { Text as Text6 } from "@headout/eevee";
var SubStopCard = /* @__PURE__ */ __name(({
  details,
  id,
  link,
  itineraryId,
  onClick,
  strings,
  lang
}) => {
  const {
    mediaUrls = [],
    name = "",
    timeFromParent = 0,
    subType = null
  } = details;
  const TypeIcon = useMemo2(
    () => subType && Object.keys(nearbyThingsIcon).includes(subType.label) ? dynamic5(nearbyThingsIcon[subType.label]) : null,
    [subType]
  );
  const walkDuration = timeFromParent ? getDurationInHmNotation({
    durationInMinutes: timeFromParent,
    lang: lang || "en"
  }) : "";
  const hasImage = !!(mediaUrls == null ? void 0 : mediaUrls.length);
  const subStopStyles = subStopsStylesRecipe({
    isClickable: !!link || !!onClick
  });
  return <div
    role={link ? "link" : "button"}
    tabIndex={0}
    className={cx3(subStopStyles.container, "passby-container")}
    key={`nearby-things-${id}`}
    {...link && { href: link, as: "a", target: "_blank" }}
    id={`itinerary-card-${itineraryId}-${id}`}
    onClick={(e) => {
      e.stopPropagation();
      onClick == null ? void 0 : onClick({ id });
    }}
    onKeyDown={() => {
    }}
  >
			{hasImage && <Image
    url={mediaUrls[0]}
    alt='passby-image'
    height={36}
    width={56}
    priority
    fetchPriority={"high" /* High */}
    fill
    aspectRatio='16:10'
    autoCrop={false}
    className={subStopStyles.imageWrap}
    placeholder={"blur" /* Blur */}
  />}
			<Conditional if={!hasImage && !!TypeIcon}>
				<div className={subStopStyles.iconContainer}>
					{TypeIcon ? <TypeIcon /> : null}
				</div>
			</Conditional>
			<div className={subStopStyles.contentContainer}>
				<Text6
    textStyle='ui.label.regular.heavy'
    color='core.grey.800'
    className={subStopStyles.name}
  >
					{name}
				</Text6>
				<Conditional if={!!walkDuration}>
					<Text6
    textStyle='ui.label.small'
    color='core.grey.700'
    className={subStopStyles.duration}
  >
						{strings.formatString(
    strings.ITINERARY.WALK_DURATION,
    walkDuration
  )}
					</Text6>
				</Conditional>
				<Conditional if={!!link}>
					<TailedArrow_default className={subStopStyles.arrow} />
				</Conditional>
			</div>
		</div>;
}, "SubStopCard");

// src/components/Itinerary/components/TimelineView/components/PassesByCard/components/PassingBySubCard/PassingBySubCard.tsx
import Link from "next/link.js";
import { cx as cx4 } from "@headout/pixie/css";
import { Text as Text7 } from "@headout/eevee";

// src/components/Itinerary/components/TimelineView/components/PassesByCard/components/PassingBySubCard/styles.tsx
import { cva as cva6, sva as sva9 } from "@headout/pixie/css";
var subCardContentContainerStylesRecipe = sva9({
  slots: [
    "root",
    "contentRoot",
    "contentChild",
    "imageSection",
    "textSection",
    "cta",
    "textContainer",
    "description"
  ],
  base: {
    root: {
      transition: "[background-color 0.3s]",
      borderRadius: "radius.8",
      padding: "space.8"
    },
    contentRoot: {
      display: "flex",
      flexDirection: "row",
      gap: "space.16",
      marginTop: "space.16"
    },
    contentChild: {
      display: "flex",
      flexDirection: "column",
      gap: "space.12"
    },
    imageSection: {
      width: "[16rem]",
      height: "[10rem]",
      "& img": {
        borderRadius: "radius.8"
      }
    },
    textSection: {
      maxWidth: "max-content"
    },
    cta: {
      display: "flex",
      alignItems: "center",
      gap: "space.4",
      width: "max-content",
      color: "core.purps.700",
      textStyle: "ui.label.regular.heavy",
      textAnchor: "middle",
      transition: "[color 0.3s]",
      "& svg": {
        height: "[0.75rem]",
        width: "[0.75rem]",
        transform: "[translateY(1px)]",
        transition: "[all 0.3s]",
        "& path": {
          stroke: "core.purps.700"
        }
      },
      _hover: {
        color: "core.purps.800",
        "& svg": {
          transform: "[rotate(-45deg)]",
          "& path": {
            stroke: "core.purps.800"
          }
        }
      }
    },
    textContainer: {
      display: "flex",
      flexDirection: "column",
      gap: "space.6",
      "& h5.sub-card-name": {
        textStyle: "ui.label.large.heavy",
        margin: 0
      }
    },
    description: {
      textStyle: "para.regular",
      display: "[-webkit-box]",
      lineClamp: 5,
      overflow: "hidden",
      color: "core.grey.700"
    }
  },
  variants: {
    hasImage: {
      true: {
        textSection: {
          maxWidth: "[23.3125rem]"
        }
      }
    },
    isOpen: {
      true: {
        root: {
          padding: "[token(spacing.space.8) 0]",
          width: "max-content",
          transform: "[translateX(-0.5rem)]"
        }
      }
    },
    variant: {
      ["REDUCED_WIDTH" /* ReducedWidth */]: {
        root: {
          cursor: "pointer",
          _hover: {
            backgroundColor: "core.grey.100"
          }
        }
      },
      ["DEFAULT" /* Default */]: {}
    }
  },
  compoundVariants: [
    {
      variant: "REDUCED_WIDTH" /* ReducedWidth */,
      isOpen: true,
      css: {
        root: {
          backgroundColor: "transparent"
        }
      }
    }
  ]
});
var spaceBlockStyles2 = cva6({
  base: {
    height: "[1rem]",
    width: "[100%]"
  }
});

// src/components/Itinerary/components/TimelineView/components/PassesByCard/components/PassingBySubCard/PassingBySubCard.tsx
var PassingBySubCard = /* @__PURE__ */ __name(({
  title,
  image,
  description,
  link,
  variant,
  id,
  itineraryId,
  onClick,
  isMobile = false,
  strings
}) => {
  const [isOpen, setIsOpen] = useState5(false);
  const isDesktop = !isMobile;
  const isReducedWidthVariant = variant === "REDUCED_WIDTH" /* ReducedWidth */;
  const hasContent = image || description;
  const isLink = !hasContent && link;
  const subCardHeadingStyles = subCardHeadingContainerStylesRecipe({
    variant
  });
  const subCardContentContainerStyles = subCardContentContainerStylesRecipe({
    hasImage: !!image,
    isOpen,
    variant
  });
  const handleClick = /* @__PURE__ */ __name(() => {
    if (isDesktop) {
      if (!isLink) setIsOpen(!isOpen);
    }
    onClick == null ? void 0 : onClick({ id });
  }, "handleClick");
  return <div
    role={isLink ? "link" : "button"}
    tabIndex={0}
    className={subCardContentContainerStyles.root}
    {...isLink && { href: link, as: "a", target: "_blank" }}
    id={`itinerary-card-${itineraryId}-${id}`}
    onClick={() => id && (onClick == null ? void 0 : onClick({ id }))}
    onKeyDown={() => {
    }}
  >
			<div
    role={"button"}
    tabIndex={0}
    className={subCardHeadingStyles.root}
    onClick={handleClick}
    onKeyDown={() => {
    }}
  >
				<Image
    className={subCardHeadingStyles.imageWrapper}
    url={image}
    alt='stop-image'
    height={isDesktop ? isReducedWidthVariant ? 16 : 20 : 20}
    width={isDesktop ? isReducedWidthVariant ? 26 : 32 : 20}
    priority
    fetchPriority={"high" /* High */}
    fill
    aspectRatio='16:10'
    autoCrop={false}
    placeholder={"blur" /* Blur */}
  />
				<Text7
    textStyle={isReducedWidthVariant ? "ui.label.regular" : "ui.label.large"}
    marginX={0}
    marginY={0}
  >
					{title}
				</Text7>
				<Conditional if={!!isLink}>
					<TailedArrow_default className='arrow-link' />
				</Conditional>
				<Conditional if={!!hasContent}>
					<>
						<Conditional if={!isOpen}>
							<Plus_default />
						</Conditional>
						<Conditional if={isOpen}>
							<Minus_default />
						</Conditional>
					</>
				</Conditional>
			</div>
			<Conditional if={isOpen && !isReducedWidthVariant}>
				<div className={subCardContentContainerStyles.contentRoot}>
					<Conditional if={!!image}>
						<div
    className={subCardContentContainerStyles.contentChild}
  >
							<Image
    className={subCardContentContainerStyles.imageSection}
    url={image}
    alt='stop-image'
    height={160}
    width={256}
    priority
    fetchPriority={"high" /* High */}
    fill
    aspectRatio='16:10'
    autoCrop={false}
    placeholder={"blur" /* Blur */}
  />
							<Conditional if={!description && !!link}>
								<Link
    className={subCardContentContainerStyles.cta}
    href={link}
  >
									CTA copy <TailedArrow_default />
								</Link>
							</Conditional>
						</div>
					</Conditional>
					<Conditional if={!!description}>
						<div
    className={cx4(
      subCardContentContainerStyles.contentChild,
      subCardContentContainerStyles.textSection
    )}
  >
							<div
    className={subCardContentContainerStyles.textContainer}
  >
								<div
    className={subCardContentContainerStyles.description}
    dangerouslySetInnerHTML={{
      __html: description
    }}
  />
							</div>
						</div>
					</Conditional>
				</div>
			</Conditional>
			<Conditional if={isOpen && isReducedWidthVariant}>
				<div className={spaceBlockStyles2()} />
				<SubStopCard
    id={id}
    details={{
      name: title,
      mediaUrls: image ? [image] : [],
      sameAsStartingPoint: false
    }}
    itineraryId={itineraryId}
    strings={strings}
  />
			</Conditional>
		</div>;
}, "PassingBySubCard");

// src/assets/svgIcons/Eye.tsx
var EyeSVG = /* @__PURE__ */ __name(() => {
  return <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
			<path
    d='M0.5 6C0.5 6 2.5 2 6 2C9.5 2 11.5 6 11.5 6C11.5 6 9.5 10 6 10C2.5 10 0.5 6 0.5 6Z'
    stroke='white'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
			<path
    d='M6 7.5C6.82843 7.5 7.5 6.82843 7.5 6C7.5 5.17157 6.82843 4.5 6 4.5C5.17157 4.5 4.5 5.17157 4.5 6C4.5 6.82843 5.17157 7.5 6 7.5Z'
    stroke='white'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
		</svg>;
}, "EyeSVG");
var Eye_default = EyeSVG;

// src/components/Itinerary/components/TimelineView/components/PassesByCard/components/MobilePassesByCard/styles.tsx
import { sva as sva10 } from "@headout/pixie/css";
var mobilePassesByCardContainerStylesRecipe = sva10({
  slots: ["root", "rankTagContainer", "headingContainer"],
  base: {
    root: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "[100%]"
    },
    rankTagContainer: {
      position: "absolute",
      left: "[0.05rem]",
      display: "flex",
      backgroundColor: "core.primary.purps",
      borderRadius: "radius.4",
      height: "[1.5rem]",
      width: "[1.5rem]",
      alignItems: "center",
      justifyContent: "center",
      "& svg": {
        height: "[0.75rem]",
        width: "[0.75rem]"
      }
    },
    headingContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "[100%]",
      "& svg": {
        height: "[1.25rem]",
        width: "[1.25rem]",
        "& path": {
          stroke: "core.grey.800"
        }
      }
    }
  }
});

// src/components/Itinerary/components/TimelineView/components/PassesByCard/components/MobilePassesByCard/MobilePassesByCard.tsx
import { Text as Text8 } from "@headout/eevee";
var MobilePassesByCard = /* @__PURE__ */ __name(({
  title,
  image,
  description,
  link,
  id,
  onClick
}) => {
  const isLink = !image && !description;
  const handleContainerClick = /* @__PURE__ */ __name(() => {
    onClick == null ? void 0 : onClick({ id });
  }, "handleContainerClick");
  const mobilePassesByCardContainerStyles = mobilePassesByCardContainerStylesRecipe();
  return <div
    role={isLink ? "link" : "button"}
    tabIndex={0}
    className={mobilePassesByCardContainerStyles.root}
    onClick={handleContainerClick}
    {...isLink && {
      href: link,
      as: "a",
      target: "_blank",
      rel: "noreferrer"
    }}
    onKeyDown={() => {
    }}
  >
			<div className={mobilePassesByCardContainerStyles.headingContainer}>
				<Text8
    textStyle='heading.small'
    color='core.grey.800'
    marginX={0}
    marginY={0}
  >
					{title}
				</Text8>
				<div>
					<Conditional if={!isLink}>
						<Plus_default />
					</Conditional>
				</div>
			</div>
			<div className={mobilePassesByCardContainerStyles.rankTagContainer}>
				<Eye_default />
			</div>
		</div>;
}, "MobilePassesByCard");

// src/components/Itinerary/components/TimelineView/components/PassesByCard/PassesByCard.tsx
import { Text as Text9 } from "@headout/eevee";
var PassesByCard = /* @__PURE__ */ __name(({
  stops = [],
  variant,
  isCruiseItinerary: isCruiseItinerary2,
  itineraryId,
  onStopSectionClick,
  strings,
  isMobile = false
}) => {
  const isDesktop = !isMobile;
  const passesByCardStyles = passesByCardStylesRecipe({
    variant,
    isCruiseItinerary: isCruiseItinerary2
  });
  return <div
    className={passesByCardStyles.container}
    data-qa-marker='qaid-itinerary-pass-by-card'
  >
			<Conditional if={!(isCruiseItinerary2 && !isDesktop)}>
				<Text9 as='h4' className={passesByCardStyles.heading}>
					{strings.ITINERARY.PASSES_BY_SECTION_HEADING}
				</Text9>
			</Conditional>
			{stops.map((stop, index) => <React8.Fragment key={`stop-${index}`}>
					<Conditional if={!(isCruiseItinerary2 && !isDesktop)}>
						<PassingBySubCard
    {...stop}
    key={`passing-by-${index}`}
    variant={variant}
    itineraryId={itineraryId}
    onClick={onStopSectionClick}
    strings={strings}
    isMobile={isMobile}
  />
					</Conditional>
					<Conditional if={!isDesktop && !!isCruiseItinerary2}>
						<MobilePassesByCard
    {...stop}
    key={`passing-by-${index}`}
    onClick={onStopSectionClick}
    itineraryId={itineraryId}
  />
					</Conditional>
				</React8.Fragment>)}
		</div>;
}, "PassesByCard");

// src/components/Itinerary/components/TimelineView/components/StopCard/StopCard.tsx
import { useEffect as useEffect4, useRef as useRef4, useState as useState6 } from "react";
import dynamic8 from "next/dynamic.js";

// src/components/Itinerary/components/TimelineView/components/StopCard/styles.tsx
import { css as css4, sva as sva11 } from "@headout/pixie/css";
var stopCardStylesRecipe = sva11({
  slots: [
    "rankContainer",
    "rankText",
    "descriptionRoot",
    "descriptionText",
    "descriptionReadMore",
    "descriptionStopCta",
    "descriptionContainer",
    "descriptionImage",
    "subStopsHeading",
    "subCardsContainer",
    "container",
    "contentContainer",
    "clickableContainer"
  ],
  base: {
    rankContainer: {
      left: 0,
      top: "[0.2rem]",
      height: "[1.5rem]",
      width: "[1.5rem]",
      borderRadius: "radius.4",
      backgroundColor: "core.primary.purps",
      zIndex: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "absolute",
      "& svg": {
        "& path": {
          stroke: "core.primary.white"
        }
      }
    },
    rankText: {
      textStyle: "subheading.large",
      textAnchor: "middle",
      color: "core.primary.white",
      transform: "[translateY(-1px)]",
      position: "relative",
      margin: 0
    },
    descriptionRoot: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "space.6",
      width: "[100%]",
      "@media only screen and (min-width: 768px), print": {
        marginTop: "space.4"
      }
    },
    descriptionText: {
      zIndex: 1,
      display: "[-webkit-box]",
      overflow: "hidden",
      textStyle: "para.regular",
      color: "core.grey.700",
      transition: "[color 0.3s]",
      lineClamp: 15,
      "& *": {
        color: "core.grey.700",
        textStyle: "para.regular",
        listStyle: "inside"
      }
    },
    descriptionReadMore: {
      background: "none",
      border: "none",
      outline: "none",
      padding: 0,
      textStyle: "ui.label.regular",
      textDecoration: "underline",
      color: "core.grey.800",
      transition: "[opacity 0.3s]",
      cursor: "pointer",
      visibility: "visible",
      opacity: 1,
      zIndex: 1
    },
    descriptionStopCta: {
      background: "none",
      border: "none",
      outline: "none",
      padding: 0,
      textStyle: "ui.label.medium",
      textDecoration: "underline",
      color: "core.grey.800",
      transition: "[opacity 0.3s]",
      marginTop: "space.10",
      cursor: "pointer",
      flexDirection: "row",
      alignItems: "center",
      textAnchor: "middle",
      visibility: "visible",
      opacity: 1,
      zIndex: 1,
      display: "flex",
      "& svg": {
        marginLeft: "space.8",
        height: "[0.75rem]",
        width: "[0.75rem]",
        "& path": {
          stroke: "core.grey.800"
        }
      }
    },
    descriptionContainer: {
      display: "none",
      transition: "[height 0.3s]",
      position: "relative",
      overflow: "hidden",
      flexDirection: "row",
      justifyContent: "flex-start",
      height: "auto",
      gap: "space.16",
      padding: 0
    },
    descriptionImage: {
      minWidth: "[23.625rem]",
      maxWidth: "[23.625rem]",
      aspectRatio: 1.6,
      display: "none",
      "& img": {
        borderRadius: "radius.4"
      }
    },
    subStopsHeading: {
      textStyle: "subheading.large",
      color: "core.grey.800",
      margin: "[0 0 token(spacing.space.8)]",
      paddingLeft: "space.20"
    },
    subCardsContainer: {
      display: "flex",
      flexDirection: "column",
      position: "relative"
    },
    container: {
      position: "relative",
      cursor: "pointer",
      padding: "[0.1875rem token(spacing.space.8) token(spacing.space.20) 2.25rem]",
      transition: "[all 0.3s]",
      display: "flex",
      flexDirection: "column",
      gap: "space.12",
      outline: "none !important",
      _before: {
        content: '""',
        position: "absolute",
        height: "[100%]",
        width: "[2px]",
        top: 0,
        left: "space.12",
        transform: "[translateX(-50%)]",
        background: "core.primary.purps"
      }
    },
    contentContainer: {
      display: "flex",
      flexDirection: "column",
      gap: "space.10",
      width: "[100%]"
    },
    clickableContainer: {
      display: "flex",
      flexDirection: "column",
      gap: "space.8",
      cursor: "auto",
      position: "relative"
    }
  },
  variants: {
    isStart: {
      true: {
        container: {
          _before: {
            height: "[calc(100% - 1.2rem)]",
            top: "[1.2rem]"
          }
        }
      }
    },
    isEnd: {
      true: {
        rankContainer: {
          backgroundColor: "core.candy.600"
        },
        rankText: {
          transform: "[translateY(0)]",
          height: "[1rem]",
          width: "[1rem]",
          color: "core.candy.600",
          _after: {
            content: '""',
            position: "absolute",
            height: "[1rem]",
            width: "[1rem]",
            borderRadius: "[50px]",
            backgroundColor: "core.primary.white",
            left: 0,
            top: 0
          }
        },
        container: {
          _before: {
            top: 0,
            height: "[1.2rem]"
          }
        }
      }
    },
    variant: {
      ["REDUCED_WIDTH" /* ReducedWidth */]: {
        rankContainer: {
          left: "[0.1rem]",
          top: "[0.3rem]",
          height: "[1.25rem]",
          width: "[1.25rem]",
          borderRadius: "radius.4",
          "@media only screen and (min-width: 768px), print": {
            borderRadius: "radius.2",
            top: "[0.4rem]",
            height: "[1rem]",
            width: "[1rem]",
            left: "[0.25rem]"
          }
        },
        rankText: {
          textStyle: "subheading.small"
        },
        container: {
          padding: "[0.1875rem token(spacing.space.8) token(spacing.space.20) 2.125rem]",
          "@media only screen and (min-width: 768px), print": {
            padding: "[0.1875rem token(spacing.space.8) token(spacing.space.20) 1.75rem]",
            gap: "space.16"
          }
        },
        contentContainer: {
          gap: "space.16",
          _hover: {
            cursor: "pointer"
          }
        }
      },
      ["DEFAULT" /* Default */]: {}
    },
    isActive: {
      true: {}
    },
    isOpen: {
      true: {
        descriptionImage: {
          display: "block"
        }
      },
      false: {
        descriptionText: {
          lineClamp: 2
        }
      }
    },
    isSubCard: {
      true: {
        container: {
          padding: "[token(spacing.space.10) token(spacing.space.8) token(spacing.space.10) 0]",
          _before: {
            display: "none"
          }
        }
      },
      false: {
        descriptionContainer: {
          display: "flex"
        }
      }
    },
    hasImage: {
      true: {}
    },
    isClickable: {
      true: {
        container: {
          WebkitTapHighlightColor: "transparent",
          _active: {
            outline: "none"
          },
          _focus: {
            outline: "none"
          }
        },
        clickableContainer: {
          cursor: "pointer"
        }
      }
    }
  },
  compoundVariants: [
    {
      isEnd: true,
      variant: "REDUCED_WIDTH" /* ReducedWidth */,
      css: {
        rankText: {
          height: "[0.625rem]",
          width: "[0.625rem]",
          _after: {
            height: "[0.625rem]",
            width: "[0.625rem]"
          }
        }
      }
    },
    {
      isActive: true,
      variant: "REDUCED_WIDTH" /* ReducedWidth */,
      css: {
        rankContainer: {
          boxShadow: "[0 0 0 4px rgba(136, 0, 255, 0.2)]"
        }
      }
    },
    {
      isOpen: true,
      hasImage: true,
      css: {
        descriptionContainer: {
          marginTop: "space.8"
        }
      }
    },
    {
      isOpen: true,
      isSubCard: true,
      css: {
        descriptionContainer: {
          display: "flex"
        }
      }
    },
    {
      isOpen: false,
      isSubCard: true,
      css: {
        descriptionContainer: {
          display: "none"
        }
      }
    }
  ]
});
var toggleContainerOverrideStyles = css4.raw({
  top: 0,
  right: "[-0.1875rem]"
});
var headingContainerStylesRecipe = sva11({
  slots: [
    "root",
    "stopName",
    "stopTitle",
    "stopHeadingContainer",
    "stopNameContainer",
    "toggleIconContainer",
    "chevronRightIcon"
  ],
  base: {
    root: {
      display: "flex",
      flexDirection: "row",
      gap: "space.12",
      alignItems: "center",
      position: "relative"
    },
    stopName: {
      textStyle: "heading.regular",
      color: "core.grey.800"
    }
  },
  variants: {
    variant: {
      ["REDUCED_WIDTH" /* ReducedWidth */]: {
        root: {
          justifyContent: "space-between"
        },
        stopTitle: {
          textStyle: "ui.label.small.heavy",
          letterSpacing: "[0.8px]",
          color: "core.grey.800",
          margin: 0,
          "@media only screen and (min-width: 768px), print": {
            textStyle: "ui.label.extraSmall"
          }
        },
        stopHeadingContainer: {
          display: "flex",
          flexDirection: "column",
          gap: "space.4"
        },
        stopNameContainer: {
          display: "flex",
          gap: "space.6",
          alignItems: "center"
        },
        stopName: {
          textStyle: "heading.regular",
          margin: 0,
          "@media only screen and (min-width: 768px), print": {
            textStyle: "ui.label.medium.heavy"
          }
        },
        toggleIconContainer: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          "& svg": {
            "& path": {
              stroke: "core.grey.800"
            }
          }
        },
        chevronRightIcon: {
          "& svg": {
            "& path": {
              strokeWidth: 1
            }
          }
        }
      },
      ["DEFAULT" /* Default */]: {}
    },
    isSubCard: {
      true: {
        stopName: {
          textStyle: "ui.label.medium.heavy"
        }
      }
    },
    isClickable: {
      true: {
        root: {
          cursor: "pointer"
        }
      }
    }
  }
});

// src/components/Itinerary/components/TimelineView/components/StopCard/components/MultiplePoints/styles.tsx
import { sva as sva12 } from "@headout/pixie/css";
var multiPointsStylesRecipe = sva12({
  slots: ["root", "cta"],
  base: {
    root: {
      display: "grid",
      gridTemplateColumns: "[repeat(3, 1fr)]",
      gap: "space.12",
      marginTop: "space.4"
    },
    cta: {
      gap: "space.6",
      backgroundColor: "core.grey.100",
      border: "none",
      padding: "space.12",
      borderRadius: "radius.6",
      color: "core.grey.800"
    }
  },
  variants: {
    variant: {
      ["REDUCED_WIDTH" /* ReducedWidth */]: {
        root: {
          gridTemplateColumns: "[repeat(1, 1fr)]",
          gap: "space.8"
        }
      },
      ["DEFAULT" /* Default */]: {}
    },
    showMorePoints: {
      true: {
        root: {
          gridTemplateColumns: "[repeat(3, 1fr) 4rem]"
        }
      }
    }
  }
});

// src/components/Itinerary/components/TimelineView/components/StopCard/components/SinglePoint/styles.tsx
import { sva as sva13 } from "@headout/pixie/css";
var singlePointContainerStylesRecipe = sva13({
  slots: [
    "root",
    "showMoreCount",
    "heading",
    "headingSection",
    "numberedImageContainer",
    "indexText",
    "imageWrap"
  ],
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      gap: "space.6",
      backgroundColor: "core.grey.100",
      border: "none",
      padding: "space.12",
      borderRadius: "radius.6",
      cursor: "pointer"
    },
    heading: {
      flexShrink: 1,
      display: "[-webkit-box]",
      lineClamp: 1,
      overflow: "hidden"
    },
    headingSection: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: "space.6",
      height: "[1.25rem]",
      overflow: "hidden"
    },
    numberedImageContainer: {
      position: "relative",
      height: "[1.25rem]",
      borderRadius: "radius.4",
      overflow: "hidden",
      minWidth: "[2rem]",
      width: "[2rem]",
      _after: {
        content: "''",
        background: "[#03829db2]",
        position: "absolute",
        height: "[100%]",
        width: "[0.6875rem]",
        right: "[0.9375rem]",
        top: 0,
        clipPath: "[polygon(100% 0, 45% 100%, 100% 100%)]"
      }
    },
    indexText: {
      position: "absolute",
      textAlign: "center",
      textAnchor: "middle",
      height: "[1.25rem]",
      width: "[0.9375rem]",
      top: 0,
      right: 0,
      background: "[#03829db2]"
    },
    imageWrap: {
      height: "[1.25rem]",
      minWidth: "[2rem]",
      width: "[2rem]",
      "& img": {
        minWidth: "[2rem]",
        width: "[2rem]",
        borderRadius: "radius.2"
      }
    }
  },
  variants: {
    showMoreSection: {
      true: {
        root: {
          justifyContent: "center",
          alignItems: "center"
        },
        showMoreCount: {
          textStyle: "ui.label.regular.heavy",
          color: "core.grey.800"
        }
      }
    },
    hasImage: {
      true: {
        root: {
          padding: "space.6"
        }
      }
    },
    variant: {
      ["REDUCED_WIDTH" /* ReducedWidth */]: {
        imageWrap: {
          height: "[1.875rem]",
          width: "[3rem]",
          "& img": {
            minWidth: "[3rem]",
            width: "[3rem]",
            borderRadius: "radius.2"
          }
        }
      },
      ["DEFAULT" /* Default */]: {}
    }
  }
});

// src/components/Itinerary/components/TimelineView/components/StopCard/components/SinglePoint/SinglePoint.tsx
import { Text as Text10 } from "@headout/eevee";
var SinglePoint = /* @__PURE__ */ __name(({
  title,
  image,
  index,
  timeForNextSection,
  onClick,
  id,
  variant = "DEFAULT" /* Default */,
  itineraryId,
  strings
}) => {
  const isReducedWidthVariant = variant === "REDUCED_WIDTH" /* ReducedWidth */;
  const singlePointContainerStyles = singlePointContainerStylesRecipe({
    hasImage: !!image,
    showMoreSection: false,
    variant
  });
  return <>
			<Conditional if={isReducedWidthVariant}>
				<SubStopCard
    id={Number(id)}
    details={{
      name: title,
      mediaUrls: image ? [image] : [],
      timeFromParent: timeForNextSection,
      sameAsStartingPoint: false
    }}
    rank={index}
    itineraryId={itineraryId}
    onClick={() => onClick(index)}
    strings={strings}
  />
			</Conditional>
			<Conditional if={!isReducedWidthVariant}>
				<button
    className={singlePointContainerStyles.root}
    onClick={() => onClick(index)}
    id={`itinerary-card-${itineraryId}-${id}`}
  >
					<div className={singlePointContainerStyles.headingSection}>
						<Conditional if={!!image}>
							<div
    className={singlePointContainerStyles.numberedImageContainer}
  >
								<Image
    url={image}
    alt='stop-image'
    height={isReducedWidthVariant ? 30 : 20}
    width={isReducedWidthVariant ? 48 : 32}
    priority
    fetchPriority={"high" /* High */}
    fill
    aspectRatio='16:10'
    autoCrop={false}
    placeholder={"blur" /* Blur */}
    className={singlePointContainerStyles.imageWrap}
  />
								<Text10
    textStyle='subheading.regular'
    color='core.primary.white'
    className={singlePointContainerStyles.indexText}
  >
									{index}
								</Text10>
							</div>
						</Conditional>
						<Text10
    textStyle='heading.small'
    color='core.grey.800'
    className={singlePointContainerStyles.heading}
  >
							{title}
						</Text10>
					</div>
				</button>
			</Conditional>
		</>;
}, "SinglePoint");

// src/components/Itinerary/components/TimelineView/components/StopCard/components/MultiplePoints/MultiplePoints.tsx
import { Button as Button4, Text as Text11 } from "@headout/eevee";
var MultiplePoints = /* @__PURE__ */ __name(({
  points,
  isStartPoint = false,
  onItemClick,
  variant = "DEFAULT" /* Default */,
  itineraryId,
  strings
}) => {
  const showMorePoints = points.length > 3;
  const multiPointsStyles = multiPointsStylesRecipe({
    showMorePoints,
    variant
  });
  return <div className={multiPointsStyles.root}>
			{points.slice(0, Math.min(points.length, 3)).map((point, index) => <SinglePoint
    {...point}
    index={index}
    key={`single-map-point-${isStartPoint ? "start" : "stop"}-${index}`}
    id={`single-map-point-${isStartPoint ? "start" : "stop"}-${index}`}
    onClick={onItemClick}
    variant={variant}
    itineraryId={itineraryId}
    strings={strings}
  />)}
			<Conditional if={showMorePoints}>
				<Button4
    as='button'
    btnType='white'
    primaryText={strings.formatString(
      strings.ITINERARY.MORE,
      points.length - 3
    )}
    className={multiPointsStyles.cta}
  >
					<Text11
    textStyle='ui.label.regular.heavy'
    color='core.grey.800'
    onClick={() => onItemClick(3)}
  >
						{strings.formatString(
    strings.ITINERARY.MORE,
    points.length - 3
  )}
						more
					</Text11>
				</Button4>
			</Conditional>
		</div>;
}, "MultiplePoints");

// src/components/Itinerary/components/TimelineView/components/StopCard/components/NextDestinationTravel/NextDestinationTravel.tsx
import { useMemo as useMemo3 } from "react";
import dynamic6 from "next/dynamic.js";

// src/components/Itinerary/components/TimelineView/components/StopCard/components/NextDestinationTravel/styles.tsx
import { sva as sva14 } from "@headout/pixie/css";
var nextDestinationStylesRecipe = sva14({
  slots: ["container", "durationAndDistanceContainer", "dividerContainer"],
  base: {
    container: {
      padding: "[token(spacing.space.4) token(spacing.space.8)]",
      borderRadius: "radius.20",
      border: "[1px solid token(colors.core.grey.300)]",
      backgroundColor: "core.primary.white",
      overflow: "hidden",
      position: "absolute",
      top: "[50%]",
      left: "space.24",
      transform: "[translateY(-50%)]",
      display: "flex",
      flexDirection: "row",
      gap: "space.4",
      alignItems: "center",
      "& svg": {
        height: "[16px]",
        width: "[16px]",
        "& path": {
          stroke: "core.grey.800"
        }
      }
    },
    durationAndDistanceContainer: {
      display: "flex",
      flexDirection: "row",
      gap: "space.10",
      "& p": {
        position: "relative",
        margin: 0,
        "&:not(:last-child)": {
          _after: {
            content: "''",
            position: "absolute",
            height: "[2px]",
            width: "[2px]",
            borderRadius: "[50px]",
            backgroundColor: "core.grey.400",
            top: "[50%]",
            right: "[-5px]",
            transform: "[translate(50%, -50%)]"
          }
        }
      }
    },
    dividerContainer: {
      position: "relative",
      display: "flex",
      flexDirection: "row",
      height: "[1.25rem]",
      marginTop: "space.12",
      _before: {
        content: "''",
        position: "absolute",
        top: "[50%]",
        left: 0,
        height: 0,
        width: "[100%]",
        borderTop: "[1px dashed token(colors.core.grey.300)]",
        transform: "[translateY(0.5px)]"
      }
    }
  }
});

// src/components/Itinerary/components/TimelineView/components/StopCard/components/NextDestinationTravel/NextDestinationTravel.tsx
import { Text as Text12 } from "@headout/eevee";
var NextDestinationTravel = /* @__PURE__ */ __name(({
  distanceForNextSection = 0,
  timeForNextSection = 0,
  modeOfTravel,
  lang
}) => {
  const formattedDuration = timeForNextSection ? getDurationInHmNotation({
    durationInMinutes: timeForNextSection,
    lang
  }) : "";
  const hasContent = !!(distanceForNextSection || formattedDuration || (modeOfTravel == null ? void 0 : modeOfTravel.localisedLabel));
  const nextDestinationStyles = nextDestinationStylesRecipe();
  const Icon = useMemo3(
    () => modeOfTravel && Object.values(EModeOfTravelOptions).includes(modeOfTravel.label) ? dynamic6(motIcons[modeOfTravel.label]) : null,
    [modeOfTravel]
  );
  return <div className={nextDestinationStyles.dividerContainer}>
			<div className={nextDestinationStyles.container}>
				{Icon ? <Icon /> : null}
				<Conditional if={hasContent}>
					<div
    className={nextDestinationStyles.durationAndDistanceContainer}
  >
						<Conditional if={!!distanceForNextSection}>
							<Text12
    textStyle='ui.label.extraSmall'
    color='core.grey.800'
  >
								{distanceForNextSection} kms
							</Text12>
						</Conditional>
						<Conditional if={!!formattedDuration}>
							<Text12
    textStyle='ui.label.extraSmall'
    color='core.grey.800'
  >
								{formattedDuration}
							</Text12>
						</Conditional>
						<Conditional
    if={!distanceForNextSection && !formattedDuration && !!(modeOfTravel == null ? void 0 : modeOfTravel.localisedLabel)}
  >
							<Text12
    textStyle='ui.label.extraSmall'
    color='core.grey.800'
  >
								{modeOfTravel == null ? void 0 : modeOfTravel.localisedLabel}
							</Text12>
						</Conditional>
					</div>
				</Conditional>
			</div>
		</div>;
}, "NextDestinationTravel");

// src/components/Itinerary/components/TimelineView/components/StopCard/components/NearbyThingsToDo/NearbyThingsToDo.tsx
import { useRef as useRef3 } from "react";
import dynamic7 from "next/dynamic.js";

// src/components/Itinerary/components/TimelineView/components/StopCard/components/NearbyThingsToDo/styles.tsx
import { sva as sva15 } from "@headout/pixie/css";
var nearbyThingsToDoStylesRecipe = sva15({
  slots: [
    "carouselContainer",
    "headingContainer",
    "passbyHeading",
    "nearbyCardsContainer",
    "mobileNearbyCards",
    "mobileNearbyMoreCardsContainer",
    "mobileNearbyMoreCardsCountText",
    "mobileNearbyMoreCardsLabelText"
  ],
  base: {
    carouselContainer: {
      width: "[100%]",
      height: "[100%]",
      maxWidth: "[calc(100vw - 2rem)]",
      "& .custom-swiper-slide": {
        paddingRight: "space.8"
      },
      "@media only screen and (min-width: 768px), print": {
        maxWidth: "unset"
      }
    },
    headingContainer: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "space.10"
    },
    passbyHeading: {
      margin: 0
    },
    nearbyCardsContainer: {
      display: "flex",
      flexDirection: "column",
      gap: "space.8"
    },
    mobileNearbyCards: {
      display: "flex",
      width: "[100%]",
      flexDirection: "row",
      gap: "space.4",
      "& .passby-container": {
        flexShrink: 1
      }
    },
    mobileNearbyMoreCardsContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "radius.8",
      backgroundColor: "core.grey.100",
      height: "[3.25rem]",
      padding: "[0 0.4375rem]"
    },
    mobileNearbyMoreCardsCountText: {
      textAlign: "center",
      margin: 0
    },
    mobileNearbyMoreCardsLabelText: {
      textAlign: "center",
      margin: 0,
      whiteSpace: "nowrap"
    }
  }
});

// src/components/Itinerary/components/TimelineView/components/StopCard/components/NearbyThingsToDo/NearbyThingsToDo.tsx
import { Text as Text13 } from "@headout/eevee";
var SwiperWrapper = dynamic7(
  () => import(
    /* webpackChunkName: "SwiperWrapper" */
    "./components/common/CustomSwiper/index.jsx"
  ).then((m) => m.Swiper)
);
var NearbyThingsToDo = /* @__PURE__ */ __name(({
  passBys = [],
  variant = "DEFAULT" /* Default */,
  itineraryId,
  onClick,
  isMobile = false,
  strings
}) => {
  const swiperRef = useRef3(null);
  const isDesktop = !isMobile;
  const { showLeftArrow, showRightArrow, onSlideChanged } = useSwiperArrows();
  const swiperParams = {
    swiperRef,
    loop: false,
    slidesToShow: 3,
    nextPrevControls: "hide",
    isMobile,
    onSlideChanged
  };
  const handlePrev = /* @__PURE__ */ __name(() => {
    var _a;
    (_a = swiperRef.current) == null ? void 0 : _a.prevSlide();
  }, "handlePrev");
  const handleNext = /* @__PURE__ */ __name(() => {
    var _a;
    (_a = swiperRef.current) == null ? void 0 : _a.nextSlide();
  }, "handleNext");
  const isReducedWidthVariant = variant === "REDUCED_WIDTH" /* ReducedWidth */;
  const showSwiperArrows = (passBys == null ? void 0 : passBys.length) > swiperParams.slidesToShow;
  const nearbyThingsToDoStyles = nearbyThingsToDoStylesRecipe();
  return <div>
			<div className={nearbyThingsToDoStyles.headingContainer}>
				<Text13
    textStyle='subheading.regular'
    color='core.grey.700'
    className={nearbyThingsToDoStyles.passbyHeading}
  >
					{strings.ITINERARY.SUB_SECTION_HEADING.NEARBY_THINGS_TO_DO}
				</Text13>
				<Conditional if={showSwiperArrows}>
					<NavigationButtons
    showLeftArrow={showLeftArrow}
    showRightArrow={showRightArrow}
    nextSlide={handleNext}
    prevSlide={handlePrev}
  />
				</Conditional>
			</div>
			<Conditional if={!isReducedWidthVariant}>
				<div className={nearbyThingsToDoStyles.carouselContainer}>
					<SwiperWrapper {...swiperParams}>
						{passBys == null ? void 0 : passBys.map((passBy, index) => <SubStopCard
    key={index}
    {...passBy}
    itineraryId={itineraryId}
    strings={strings}
  />)}
					</SwiperWrapper>
				</div>
			</Conditional>
			<Conditional if={isReducedWidthVariant && isDesktop}>
				<div className={nearbyThingsToDoStyles.nearbyCardsContainer}>
					{passBys.map((passBy, index) => <SubStopCard
    key={index}
    {...passBy}
    itineraryId={itineraryId}
    onClick={onClick}
    strings={strings}
  />)}
				</div>
			</Conditional>
			<Conditional if={isReducedWidthVariant && !isDesktop}>
				<div className={nearbyThingsToDoStyles.mobileNearbyCards}>
					{passBys == null ? void 0 : passBys.slice(0, 1).map((passBy) => <SubStopCard
    key={passBy.id}
    {...passBy}
    itineraryId={itineraryId}
    strings={strings}
  />)}
					<Conditional if={(passBys == null ? void 0 : passBys.length) > 1}>
						<div
    className={nearbyThingsToDoStyles.mobileNearbyMoreCardsContainer}
  >
							<Text13
    textStyle='ui.label.regular.heavy'
    color='core.grey.700'
    className={nearbyThingsToDoStyles.mobileNearbyMoreCardsCountText}
  >
								+{(passBys == null ? void 0 : passBys.length) - 1}
							</Text13>
							<Text13
    textStyle='ui.label.small'
    color='core.grey.700'
    className={nearbyThingsToDoStyles.mobileNearbyMoreCardsLabelText}
  >
								more things
							</Text13>
						</div>
					</Conditional>
				</div>
			</Conditional>
		</div>;
}, "NearbyThingsToDo");

// src/components/Itinerary/components/TimelineView/components/StopCard/utils.ts
var getSubStopsAndPassBys = /* @__PURE__ */ __name((subCards) => {
  const subStops = subCards.filter(
    ({ subSectionDetails, isSubSection }) => isSubSection ? subSectionDetails && !subSectionDetails.details.passBy : true
  );
  const passBys = subCards.filter(
    ({ subSectionDetails }) => subSectionDetails && subSectionDetails.details.passBy
  ).map(({ subSectionDetails }) => subSectionDetails);
  return { subStops, passBys };
}, "getSubStopsAndPassBys");

// src/components/Itinerary/components/TimelineView/components/StopCard/hooks/useStopCard.ts
import { useMemo as useMemo4 } from "react";

// src/components/Itinerary/components/TimelineView/components/StopCard/constants.ts
var MAX_LEN_DESCRIPTION_STOP_CARD = 114;

// src/components/Itinerary/components/TimelineView/components/StopCard/hooks/useStopCard.ts
var useStopCard = /* @__PURE__ */ __name(({
  subCards,
  isStart,
  isEnd,
  setMultiPointDefaultOpen,
  onStopSectionClick,
  isDesktop,
  variant,
  isHOHOItinerary: isHOHOItinerary2,
  itineraryId,
  itineraryName,
  setIsOpen,
  endPointIsNotSameAsStart,
  isSubSection,
  subSectionDetails,
  sectionDetails,
  isSubCard,
  isForcedEnd,
  trackEventFn,
  additionalTrackingProperties,
  isMobile = false,
  isOpen = false
}) => {
  const { details } = isSubSection ? subSectionDetails : sectionDetails;
  const {
    mediaUrls,
    description,
    timeForNextSection,
    modeOfTravel,
    distanceForNextSection
  } = details;
  const hasImage = !!(mediaUrls == null ? void 0 : mediaUrls.length);
  const isReducedVariant = variant === "REDUCED_WIDTH" /* ReducedWidth */;
  const { subStops, passBys } = useMemo4(
    () => getSubStopsAndPassBys(subCards),
    []
  );
  const multiPoints = {
    itineraryId,
    points: isStart || isEnd ? subCards.filter(
      ({ sectionDetails: sectionDetails2 }) => (sectionDetails2 == null ? void 0 : sectionDetails2.type) !== "STOP" /* Stop */
    ).map(({ sectionDetails: sectionDetails2 }) => {
      var _a, _b;
      return {
        image: (_b = (_a = sectionDetails2 == null ? void 0 : sectionDetails2.details) == null ? void 0 : _a.mediaUrls) == null ? void 0 : _b[0],
        title: sectionDetails2 == null ? void 0 : sectionDetails2.details.name,
        timeForNextSection: sectionDetails2 == null ? void 0 : sectionDetails2.details.timeForNextSection
      };
    }) : [],
    isStartPoint: isStart,
    onItemClick: /* @__PURE__ */ __name((index) => {
      if (variant === "DEFAULT" /* Default */) {
        if (index < 3) {
          setMultiPointDefaultOpen(index);
        }
        setIsOpen(true);
      } else {
        if (index < 3) {
          onStopSectionClick == null ? void 0 : onStopSectionClick(subCards[index].sectionDetails);
        }
      }
    }, "onItemClick")
  };
  const hasMultiPoints = multiPoints.points.length > 1;
  const allowOpen = useMemo4(() => {
    if (!isReducedVariant) {
      if (!endPointIsNotSameAsStart && isEnd) return false;
      if ((isStart || isEnd) && hasMultiPoints) return false;
      if (isSubCard && !hasImage && !description) return false;
      if (!isSubCard && !isSubSection && !hasImage && (!description || description.length - 7 < MAX_LEN_DESCRIPTION_STOP_CARD))
        return false;
      return true;
    } else {
      if (isDesktop) {
        return !isStart && !isEnd && !isHOHOItinerary2 && (!!(subStops == null ? void 0 : subStops.length) || !!(passBys == null ? void 0 : passBys.length)) || (isStart || isEnd) && !hasMultiPoints && !!((passBys == null ? void 0 : passBys.length) || (subStops == null ? void 0 : subStops.length));
      } else {
        return !(isEnd && !endPointIsNotSameAsStart);
      }
    }
  }, []);
  const shouldShowNextDestinationTravel = useMemo4(() => {
    if (!(isEnd || isForcedEnd) && !isSubCard) {
      if (isHOHOItinerary2) {
        return timeForNextSection && (modeOfTravel || distanceForNextSection);
      } else {
        return timeForNextSection || modeOfTravel || distanceForNextSection;
      }
    }
  }, []);
  const shouldShowNearbyThingsToDo = useMemo4(() => {
    if (isReducedVariant) {
      return !!(passBys.length && endPointIsNotSameAsStart && isOpen && !isHOHOItinerary2);
    } else {
      const baseCondition = isHOHOItinerary2 ? isOpen : true;
      return !!(baseCondition && passBys.length && endPointIsNotSameAsStart);
    }
  }, [isReducedVariant, isOpen]);
  const shouldShowMultiplePoints = useMemo4(() => {
    return !!(!isMobile && hasMultiPoints && (!isOpen || isReducedVariant) && endPointIsNotSameAsStart);
  }, [
    hasMultiPoints,
    isOpen,
    isReducedVariant,
    endPointIsNotSameAsStart,
    isMobile
  ]);
  const isStopSectionClickable = isDesktop && !hasMultiPoints || !isDesktop && allowOpen;
  const handleStopSectionClick = /* @__PURE__ */ __name(() => {
    if (isStopSectionClickable) {
      onStopSectionClick == null ? void 0 : onStopSectionClick(
        isSubSection ? subSectionDetails : sectionDetails
      );
    } else {
      trackItineraryCardDeadClicks();
    }
  }, "handleStopSectionClick");
  const handleSubStopSectionClick = /* @__PURE__ */ __name((sectionDetails2) => {
    if (isHOHOItinerary2 && isReducedVariant) {
      onStopSectionClick == null ? void 0 : onStopSectionClick(sectionDetails2);
    } else {
      trackItineraryCardDeadClicks();
    }
  }, "handleSubStopSectionClick");
  const trackItineraryCardDeadClicks = /* @__PURE__ */ __name(() => {
    trackEventFn == null ? void 0 : trackEventFn(__spreadValues({
      eventName: ANALYTICS_EVENTS.ITINERARY.ITINERARY_CARD_DEADCLICK,
      [ANALYTICS_PROPERTIES.ITINERARY_ID]: itineraryId,
      [ANALYTICS_PROPERTIES.ITINERARY_NAME]: itineraryName,
      [ANALYTICS_PROPERTIES.PLATFORM_NAME]: isMobile ? "Mobile" : "Desktop"
    }, getItineraryAdditionalTrackingPayload(
      additionalTrackingProperties
    )));
  }, "trackItineraryCardDeadClicks");
  return {
    subStops,
    passBys,
    multiPoints,
    allowOpen,
    hasMultiPoints,
    shouldShowNextDestinationTravel,
    shouldShowNearbyThingsToDo,
    shouldShowMultiplePoints,
    isStopSectionClickable,
    handleStopSectionClick,
    handleSubStopSectionClick,
    trackItineraryCardDeadClicks
  };
}, "useStopCard");
var useStopCard_default = useStopCard;

// src/components/Itinerary/components/TimelineView/components/SubStopSection/styles.tsx
import { css as css5 } from "@headout/pixie/css";
var subStopsContainerStyles = css5({
  display: "flex",
  flexDirection: "column",
  gap: "space.8"
});

// src/components/Itinerary/components/TimelineView/components/SubStopSection/SubStopSection.tsx
var SubStopSection = /* @__PURE__ */ __name(({
  itineraryId,
  subStops,
  passBys,
  variant,
  hasMultiPoints = false,
  isOpen = false,
  isSubCard = false,
  handleSubStopSectionClick,
  isHOHOItinerary: isHOHOItinerary2 = false,
  strings,
  isMobile
}) => {
  const isReducedVariant = variant === "REDUCED_WIDTH" /* ReducedWidth */;
  const isDesktop = !isMobile;
  return <>
			<Conditional
    if={!!(subStops == null ? void 0 : subStops.length) && isReducedVariant && !isSubCard && isOpen && !hasMultiPoints}
  >
				{subStops == null ? void 0 : subStops.map(({ subSectionDetails, sectionDetails }) => {
    var _a;
    if (!subSectionDetails && !sectionDetails) return;
    const { details, id, rank } = subSectionDetails || sectionDetails;
    return <SubStopCard
      key={`subStop-card-${(_a = subSectionDetails || sectionDetails) == null ? void 0 : _a.id}`}
      id={id}
      details={details}
      rank={rank}
      itineraryId={itineraryId}
      strings={strings}
      onClick={handleSubStopSectionClick}
    />;
  })}
			</Conditional>
			<Conditional
    if={!!((passBys == null ? void 0 : passBys.length) || (subStops == null ? void 0 : subStops.length)) && isReducedVariant && !isSubCard && !hasMultiPoints && !!isHOHOItinerary2 && isDesktop}
  >
				<div className={subStopsContainerStyles}>
					{subStops == null ? void 0 : subStops.map(({ subSectionDetails, sectionDetails }) => {
    var _a;
    if (!subSectionDetails && !sectionDetails) return;
    const { details, id, rank } = subSectionDetails || sectionDetails;
    return <SubStopCard
      key={`subStop-card-${(_a = subSectionDetails || sectionDetails) == null ? void 0 : _a.id}`}
      id={id}
      details={details}
      rank={rank}
      itineraryId={itineraryId}
      strings={strings}
      onClick={handleSubStopSectionClick}
    />;
  })}
					{passBys == null ? void 0 : passBys.map((passBy) => {
    const { id, details, rank } = passBy;
    return <SubStopCard
      key={`subStop-card-${passBy.id}`}
      id={id}
      details={details}
      rank={rank}
      itineraryId={itineraryId}
      strings={strings}
      onClick={handleSubStopSectionClick}
    />;
  })}
				</div>
			</Conditional>
		</>;
}, "SubStopSection");

// src/components/Itinerary/components/TimelineView/components/StopCard/StopCard.tsx
import { Text as Text14 } from "@headout/eevee";
var DefaultHeadingContainer = dynamic8(
  () => import(
    /* webpackChunkName: "DefaultHeadingContainer" */
    "./DefaultHeadingContainer-GOGWGBCQ.jsx"
  ).then((m) => m.DefaultHeadingContainer)
);
var ReducedWidthHeadingContainer = dynamic8(
  () => import(
    /* webpackChunkName: "ReducedWidthHeadingContainer" */
    "./ReducedWidthHeadingContainer-KRFV6S37.jsx"
  ).then((m) => m.ReducedWidthHeadingContainer)
);
var Descriptors = dynamic8(
  () => import(
    /* webpackChunkName: "Descriptors" */
    "./Descriptors-ARKO72EI.jsx"
  ).then((m) => m.Descriptors)
);
var StopCard = /* @__PURE__ */ __name(({
  descriptors,
  defaultOpen = false,
  subCards = [],
  isSubCard = false,
  position,
  sectionDetails,
  subSectionDetails,
  isSubSection = false,
  isForcedStart = false,
  isForcedEnd = false,
  variant = "DEFAULT" /* Default */,
  onStopSectionClick,
  isActive = false,
  isHOHOItinerary: isHOHOItinerary2,
  itineraryId,
  itineraryName,
  findDirections = false,
  hasMultipleSubStops = false,
  strings,
  isMobile = false,
  trackEventFn,
  lang = "en"
}) => {
  const ref = useRef4(null);
  const isDesktop = !isMobile;
  const [isOpen, setIsOpen] = useState6(
    isDesktop ? defaultOpen || isActive : false
  );
  const [multiPointDefaultOpen, setMultiPointDefaultOpen] = useState6(-1);
  const { id, type, details } = isSubSection ? subSectionDetails : sectionDetails;
  const {
    name,
    mediaUrls,
    description,
    timeForNextSection,
    modeOfTravel,
    distanceForNextSection,
    subType
  } = details;
  const hasImage = !!(mediaUrls == null ? void 0 : mediaUrls.length);
  const showSubCardImage = hasImage && isOpen;
  const isStart = type === "START_LOCATION" /* StartLocation */;
  const isEnd = type === "END_LOCATION" /* EndLocation */;
  const endPointIsNotSameAsStart = !(sectionDetails == null ? void 0 : sectionDetails.details.sameAsStartingPoint);
  const isReducedVariant = variant === "REDUCED_WIDTH" /* ReducedWidth */;
  const { additionalTrackingProperties } = useItinerary();
  const {
    subStops,
    passBys,
    allowOpen,
    isStopSectionClickable,
    multiPoints,
    hasMultiPoints,
    shouldShowNextDestinationTravel,
    shouldShowNearbyThingsToDo,
    shouldShowMultiplePoints,
    handleStopSectionClick,
    handleSubStopSectionClick,
    trackItineraryCardDeadClicks
  } = useStopCard_default({
    itineraryId,
    setIsOpen,
    setMultiPointDefaultOpen,
    subCards,
    variant,
    endPointIsNotSameAsStart,
    hasImage,
    isDesktop,
    isHOHOItinerary: isHOHOItinerary2,
    isStart,
    isEnd,
    isSubSection,
    isSubCard,
    isForcedEnd,
    onStopSectionClick,
    sectionDetails,
    subSectionDetails,
    additionalTrackingProperties,
    itineraryName,
    trackEventFn,
    isMobile,
    isOpen
  });
  useEffect4(() => {
    var _a;
    if (defaultOpen) {
      (_a = ref.current) == null ? void 0 : _a.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "center"
      });
    }
  }, []);
  useEffect4(() => {
    if (isReducedVariant && isDesktop)
      setIsOpen(hasMultiPoints || isActive);
  }, [isActive]);
  const handleClickableContainerClick = /* @__PURE__ */ __name(() => {
    if (allowOpen) {
      setMultiPointDefaultOpen(-1);
      if (isDesktop) setIsOpen(!isOpen);
      trackEventFn == null ? void 0 : trackEventFn(__spreadValues({
        eventName: isSubCard ? ANALYTICS_EVENTS.ITINERARY.SUB_STOP_CLICKED : ANALYTICS_EVENTS.ITINERARY.STOP_CLICKED,
        [ANALYTICS_PROPERTIES.ACTION]: !isOpen ? "Expanded" : "Collapsed",
        [ANALYTICS_PROPERTIES.STOP_NAME]: name,
        [ANALYTICS_PROPERTIES.STOP_NUMBER]: position,
        [ANALYTICS_PROPERTIES.ITINERARY_ID]: itineraryId,
        [ANALYTICS_PROPERTIES.ITINERARY_NAME]: itineraryName,
        [ANALYTICS_PROPERTIES.PLATFORM_NAME]: isMobile ? "Mobile" : "Desktop"
      }, getItineraryAdditionalTrackingPayload(
        additionalTrackingProperties
      )));
    } else {
      trackItineraryCardDeadClicks();
    }
  }, "handleClickableContainerClick");
  const handleDescriptorClick = /* @__PURE__ */ __name((descriptorType) => {
    if (descriptorType === "location" /* Location */) {
      trackEventFn == null ? void 0 : trackEventFn(__spreadValues({
        eventName: ANALYTICS_EVENTS.ITINERARY.GET_DIRECTIONS_CLICKED,
        [ANALYTICS_PROPERTIES.ITINERARY_ID]: itineraryId,
        [ANALYTICS_PROPERTIES.ITINERARY_NAME]: itineraryName,
        [ANALYTICS_PROPERTIES.STOP_NAME]: name,
        [ANALYTICS_PROPERTIES.STOP_NUMBER]: position,
        [ANALYTICS_PROPERTIES.PLATFORM_NAME]: isMobile ? "Mobile" : "Desktop"
      }, getItineraryAdditionalTrackingPayload(
        additionalTrackingProperties
      )));
    }
  }, "handleDescriptorClick");
  const subSectionHeading = (subType == null ? void 0 : subType.label) === "POI" /* Poi */ || (subType == null ? void 0 : subType.label) === "LANDMARK" /* Landmark */ ? strings.ITINERARY.SUB_SECTION_HEADING.HIGHLIGHTS : (subType == null ? void 0 : subType.label) === "HOHO_BUS_STOP" /* HohoBusStop */ ? strings.ITINERARY.SUB_SECTION_HEADING.NEARBY_THINGS_TO_DO : strings.ITINERARY.SUB_SECTION_HEADING.THINGS_TO_DO;
  const subCardsHeadingContainerStyles = subCardHeadingContainerStylesRecipe({
    variant: "DEFAULT" /* Default */
  });
  const stopCardStyles = stopCardStylesRecipe({
    isActive: isOpen,
    hasImage,
    isClickable: allowOpen,
    isEnd: isEnd || isForcedEnd,
    isStart: isStart || isForcedStart,
    isOpen,
    isSubCard,
    variant
  });
  const commonHeadingProps = {
    name,
    strings,
    variant,
    allowOpen,
    hasMultiPoints,
    hasMultipleSubStops,
    isOpen,
    isStart,
    isEnd,
    isSubCard,
    multiPoints,
    position,
    isMobile
  };
  return <div
    role={"button"}
    tabIndex={0}
    className={stopCardStyles.container}
    key={id}
    ref={ref}
    onClick={handleStopSectionClick}
    id={`itinerary-card-${itineraryId}-${id}`}
    onKeyDown={() => {
    }}
    data-qa-marker='qaid-itinerary-stop-card'
  >
			<div
    tabIndex={0}
    role={"button"}
    className={stopCardStyles.contentContainer}
    onClick={handleStopSectionClick}
    onKeyDown={() => {
    }}
  >
				<Conditional if={!isSubCard && position !== null}>
					<div className={stopCardStyles.rankContainer}>
						<Conditional if={!!position}>
							<Text14 className={stopCardStyles.rankText}>
								{position}
							</Text14>
						</Conditional>
						<Conditional if={position === 0}>
							<TailedArrow_default />
						</Conditional>
					</div>
				</Conditional>
				<div
    className={stopCardStyles.clickableContainer}
    role={"button"}
    tabIndex={0}
    onClick={handleClickableContainerClick}
    onKeyDown={() => {
    }}
  >
					<Conditional if={!isReducedVariant}>
						<DefaultHeadingContainer
    {...commonHeadingProps}
    toggleContainerOverrideStyles={isSubCard ? toggleContainerOverrideStyles : {}}
  />
					</Conditional>
					<Conditional if={isReducedVariant}>
						<ReducedWidthHeadingContainer
    {...commonHeadingProps}
    endPointIsNotSameAsStart={endPointIsNotSameAsStart}
    isStopSectionClickable={isStopSectionClickable}
  />
					</Conditional>
					<Conditional if={!hasMultiPoints}>
						<Conditional if={endPointIsNotSameAsStart}>
							<Descriptors
    {...descriptors}
    variant={variant}
    strings={strings}
    lang={lang}
    descriptorSize={isReducedVariant ? "small" /* Small */ : "large" /* Large */}
    showLocationDescriptor={findDirections}
    onClick={handleDescriptorClick}
  />
						</Conditional>
						<Conditional
    if={(showSubCardImage || !!description) && endPointIsNotSameAsStart && !isReducedVariant}
  >
							<div
    className={stopCardStyles.descriptionContainer}
  >
								<Conditional if={showSubCardImage}>
									{hasImage && <>
											<Image
    url={mediaUrls[0]}
    alt='stop-image'
    height={236}
    width={378}
    fill
    aspectRatio='16:10'
    autoCrop={false}
    className={stopCardStyles.descriptionImage}
    placeholder={"blur" /* Blur */}
    data-qa-marker='qaid-itinerary-stop-card-image'
  />
										</>}
								</Conditional>
								<Conditional if={!!description}>
									<div
    className={stopCardStyles.descriptionRoot}
  >
										<div
    className={stopCardStyles.descriptionText}
    dangerouslySetInnerHTML={{
      __html: description
    }}
  />
									</div>
								</Conditional>
							</div>
						</Conditional>
					</Conditional>
				</div>
				<SubStopSection
    handleSubStopSectionClick={handleSubStopSectionClick}
    subStops={subStops}
    passBys={passBys}
    itineraryId={itineraryId}
    variant={variant}
    isSubCard={isSubCard}
    isOpen={isOpen}
    hasMultiPoints={hasMultiPoints}
    strings={strings}
    isHOHOItinerary={isHOHOItinerary2}
    isMobile={isMobile}
  />
				<Conditional
    if={!!subStops.length && !isSubCard && (isStart || isEnd ? isOpen && hasMultiPoints : true) && !isReducedVariant}
  >
					<div className={stopCardStyles.subCardsContainer}>
						<Conditional if={!(isStart || isEnd)}>
							<div
    className={subCardsHeadingContainerStyles.root}
  >
								<div
    className={subCardsHeadingContainerStyles.subSectionHeading}
  >
									{subSectionHeading}
								</div>
							</div>
						</Conditional>
						{subStops.map((subStopProps, index) => <StopCard
    {...subStopProps}
    key={index}
    isSubCard
    defaultOpen={(isStart || isEnd) && multiPointDefaultOpen === index}
    itineraryId={itineraryId}
    onStopSectionClick={onStopSectionClick}
    strings={strings}
    hasMultipleSubStops={subStops.length > 1}
    itineraryName={itineraryName}
  />)}
					</div>
				</Conditional>
				<Conditional if={shouldShowMultiplePoints}>
					<MultiplePoints
    {...multiPoints}
    variant={variant}
    strings={strings}
  />
				</Conditional>
				<Conditional if={shouldShowNearbyThingsToDo}>
					<NearbyThingsToDo
    passBys={passBys}
    variant={variant}
    itineraryId={itineraryId}
    onClick={onStopSectionClick}
    strings={strings}
    isMobile={isMobile}
  />
				</Conditional>
			</div>
			<Conditional if={!!shouldShowNextDestinationTravel}>
				<NextDestinationTravel
    timeForNextSection={timeForNextSection}
    modeOfTravel={modeOfTravel}
    distanceForNextSection={distanceForNextSection}
    strings={strings}
    lang={lang}
  />
			</Conditional>
		</div>;
}, "StopCard");

// src/components/Itinerary/components/TimelineView/TimelineView.tsx
var TimelineView2 = /* @__PURE__ */ __name(({
  itinerary,
  variant = "DEFAULT" /* Default */,
  onStopSectionClick,
  isMobile,
  trackEventFn,
  strings,
  disablePathChange = false,
  lang
}) => {
  const router = useCompatibleRouter();
  const isDesktop = !isMobile;
  const timelineContainerRef = useRef5(null);
  const [eventRecorded, setEventRecorded] = useState7(false);
  const isOnScreen = useOnScreen({
    ref: timelineContainerRef
  });
  const {
    activeItineraryStopId,
    setActiveItineraryStopId,
    setActiveStopIndex,
    itinerarySwipeSheetDetailsConfig,
    setItinerarySwipeSheetDetailsConfig
  } = useItinerary();
  const stopCardProps = useMemo5(
    () => sectionDataSanitizer(
      itinerary.sections,
      itinerary.type
    ),
    [itinerary]
  );
  useEffect5(() => {
    if (eventRecorded || !isOnScreen) return;
    trackEventFn == null ? void 0 : trackEventFn({
      eventName: ANALYTICS_EVENTS.ITINERARY.TIMELINE_VIEWED,
      variant
    });
    setEventRecorded(true);
  }, [eventRecorded, isOnScreen]);
  const handleStopSectionClick = /* @__PURE__ */ __name((sectionDetails, stopIndex) => {
    setActiveItineraryStopId(sectionDetails.id);
    if (stopIndex !== void 0) setActiveStopIndex(stopIndex);
    onStopSectionClick == null ? void 0 : onStopSectionClick(sectionDetails);
    if (!isDesktop) {
      toggleItinerarySwipeSheet({ open: true, type: "stop" });
    }
  }, "handleStopSectionClick");
  const toggleItinerarySwipeSheet = /* @__PURE__ */ __name(({
    open,
    type
  }) => {
    setItinerarySwipeSheetDetailsConfig(__spreadValues(__spreadProps(__spreadValues({}, itinerarySwipeSheetDetailsConfig), {
      open,
      type
    }), !open ? { overlayStopSwipeSheet: false } : {}));
    if (!disablePathChange) {
      toggleItinerarySwipeSheetURLHash({ open, type, router });
    }
  }, "toggleItinerarySwipeSheet");
  const isReducedWidthVariant = variant === "REDUCED_WIDTH" /* ReducedWidth */;
  const isHOHOItinerary2 = isHOHOItinerary(itinerary.type);
  const isCruiseItinerary2 = isCruiseItinerary(itinerary.type);
  const timelineViewContainerStyles = timelineViewContainerStylesRecipe({
    variant
  });
  return <div
    className={timelineViewContainerStyles}
    ref={timelineContainerRef}
    data-qa-marker='qaid-itinerary-timeline-view'
  >
			{stopCardProps.map(
    ({ stop, passby }, stopIndex) => {
      var _a, _b, _c, _d;
      return passby ? <PassesByCard
        {...passby}
        key={`passby-card-${(_b = (_a = passby.stops) == null ? void 0 : _a[0]) == null ? void 0 : _b.id}`}
        variant={variant}
        itineraryId={itinerary.id}
        isCruiseItinerary={isCruiseItinerary2}
        onStopSectionClick={(sectionDetails) => handleStopSectionClick(sectionDetails, stopIndex)}
        strings={strings}
        isMobile={isMobile}
      /> : <StopCard
        {...stop}
        key={`stop-card-${(_c = stop.sectionDetails) == null ? void 0 : _c.id}`}
        variant={variant}
        onStopSectionClick={(sectionDetails) => handleStopSectionClick(sectionDetails, stopIndex)}
        isActive={isReducedWidthVariant && ((_d = stop.sectionDetails) == null ? void 0 : _d.id) === activeItineraryStopId}
        isHOHOItinerary={isHOHOItinerary2}
        itineraryId={itinerary.id}
        itineraryName={itinerary.details.routeName || itinerary.name}
        strings={strings}
        isMobile={isMobile}
        trackEventFn={trackEventFn}
        lang={lang}
      />;
    }
  )}
		</div>;
}, "TimelineView");

// src/assets/svgIcons/Ticket.tsx
var Ticket = /* @__PURE__ */ __name((props) => <svg
  width='16'
  height='16'
  viewBox='0 0 16 16'
  fill='none'
  xmlns='http://www.w3.org/2000/svg'
  {...props}
>
		<path
  d='M11.4199 10L14.3299 4.91L12.7999 4C12.5061 4.16422 12.1826 4.26863 11.8483 4.30723C11.5139 4.34582 11.1751 4.31783 10.8516 4.22487C10.5281 4.1319 10.2262 3.9758 9.96331 3.76558C9.70042 3.55535 9.48175 3.29516 9.31992 3C9.13071 2.65175 9.0214 2.26575 8.99992 1.87V1.82L7.47992 1L4.57992 6.1L1.66992 11.14L3.18992 12C3.55242 11.812 3.95189 11.7061 4.35992 11.69C4.69484 11.678 5.02885 11.7321 5.34285 11.8492C5.65684 11.9664 5.94466 12.1443 6.18985 12.3728C6.43504 12.6012 6.63279 12.8758 6.77179 13.1807C6.91079 13.4857 6.98831 13.8151 6.99992 14.15C6.99992 14.15 6.99992 14.15 6.99992 14.15L8.52992 15.03L11.4199 10Z'
  stroke='#444444'
  strokeLinecap='round'
  strokeLinejoin='round'
/>
		<path
  d='M12.3996 8.23005L5.59961 4.30005'
  stroke='#444444'
  strokeLinecap='round'
  strokeLinejoin='round'
/>
	</svg>, "Ticket");
var Ticket_default = Ticket;

// src/assets/svgIcons/CheckCircle.tsx
var CheckCircle = /* @__PURE__ */ __name((props) => <svg
  width='14'
  height='14'
  viewBox='0 0 14 14'
  fill='none'
  xmlns='http://www.w3.org/2000/svg'
  {...props}
>
		<path
  d='M9.9031 5.02067L6.27463 8.979L4.62533 7.17976M13.3337 6.99984C13.3337 10.4976 10.4981 13.3332 7.00033 13.3332C3.50252 13.3332 0.666992 10.4976 0.666992 6.99984C0.666992 3.50203 3.50252 0.666504 7.00033 0.666504C10.4981 0.666504 13.3337 3.50203 13.3337 6.99984Z'
  stroke='#444444'
  strokeLinecap='round'
  strokeLinejoin='round'
/>
	</svg>, "CheckCircle");
var CheckCircle_default = CheckCircle;

// src/assets/svgIcons/CrossCircle.tsx
var CrossCircle = /* @__PURE__ */ __name((props) => <svg
  width={12}
  height={12}
  viewBox='0 0 12 12'
  fill='none'
  xmlns='http://www.w3.org/2000/svg'
  {...props}
>
		<path
  d='M8.24988 3.75L3.74988 8.25M3.74988 3.75L8.24988 8.25M11.2499 6C11.2499 8.89949 8.89937 11.25 5.99988 11.25C3.10038 11.25 0.749878 8.89949 0.749878 6C0.749878 3.10051 3.10038 0.75 5.99988 0.75C8.89937 0.75 11.2499 3.10051 11.2499 6Z'
  stroke='#444444'
  strokeWidth={0.75}
  strokeLinecap='round'
  strokeLinejoin='round'
/>
	</svg>, "CrossCircle");
var CrossCircle_default = CrossCircle;

// src/assets/svgIcons/LocationMarker.tsx
import { token as token3 } from "@headout/pixie/tokens";
var LocationMarker = /* @__PURE__ */ __name((_a) => {
  var _b = _a, {
    strokeColor = "core.candy.600"
  } = _b, props = __objRest(_b, [
    "strokeColor"
  ]);
  return <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
			<path
    d='M10.5 5C10.5 8.5 6 11.5 6 11.5C6 11.5 1.5 8.5 1.5 5C1.5 3.80653 1.97411 2.66193 2.81802 1.81802C3.66193 0.974106 4.80653 0.5 6 0.5C7.19347 0.5 8.33807 0.974106 9.18198 1.81802C10.0259 2.66193 10.5 3.80653 10.5 5Z'
    stroke={token3(`colors.${strokeColor}`)}
    strokeWidth='0.75'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
			<path
    d='M6 6.5C6.82843 6.5 7.5 5.82843 7.5 5C7.5 4.17157 6.82843 3.5 6 3.5C5.17157 3.5 4.5 4.17157 4.5 5C4.5 5.82843 5.17157 6.5 6 6.5Z'
    stroke={token3(`colors.${strokeColor}`)}
    strokeWidth='0.75'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
		</svg>;
}, "LocationMarker");
var LocationMarker_default = LocationMarker;

// src/components/Itinerary/components/TimelineView/components/StopCard/components/Descriptors/Descriptors.tsx
var Descriptors2 = /* @__PURE__ */ __name(({
  inclusion,
  duration = 0,
  attractionsCount = 0,
  activitiesCount = 0,
  foodTypes,
  location,
  variant = "DEFAULT" /* Default */,
  descriptorSize = "large" /* Large */,
  strings,
  showLocationDescriptor = true,
  descriptorTextStyles = {},
  descriptorContainerStyles = {},
  descriptorItemContainerStyles = {},
  onClick,
  lang
}) => {
  const getInclusionIcon = /* @__PURE__ */ __name((label) => {
    if (!label) return null;
    switch (label) {
      case "FREE_ADMISSION" /* FreeAdmission */:
        return <Ticket_default />;
      case "ADMISSION_TICKET_INCLUDED" /* AdmissionTicketIncluded */:
        return <CheckCircle_default />;
      case "ADMISSION_TICKET_NOT_INCLUDED" /* AdmissionTicketNotIncluded */:
        return <CrossCircle_default />;
      default:
        return <Ticket_default />;
    }
  }, "getInclusionIcon");
  if (!inclusion && !duration && !activitiesCount && !attractionsCount && !foodTypes && !location)
    return null;
  const walkDuration = duration ? getDurationInHmNotation({
    durationInMinutes: duration,
    lang
  }) : "";
  const containerStyles = containerStylesRecipe.raw({
    variant
  });
  const descriptorItemContainerOverrideStyles = descriptorItemOverrideStylesRecipe.raw({
    variant
  });
  const locationUrl = location ? generateGoogleMapPlacesUrl(location) : "";
  const commonDescriptorProps = {
    descriptorTextStyles,
    descriptorItemContainerStyles: css6.raw(
      descriptorItemContainerOverrideStyles,
      descriptorItemContainerStyles
    ),
    size: descriptorSize,
    onClick
  };
  return <div className={css6(containerStyles, descriptorContainerStyles)}>
			<Conditional if={!!location && showLocationDescriptor}>
				<Descriptor
    icon={<LocationMarker_default height={12} width={12} />}
    text={strings.ITINERARY.GET_DIRECTION}
    color='core.candy.600'
    bold
    url={locationUrl}
    descriptorType={"location" /* Location */}
    dataQAMarker='qaid-itinerary-stop-card-location-descriptor'
    {...commonDescriptorProps}
  />
			</Conditional>
			<Conditional if={!!walkDuration}>
				<Descriptor
    icon={<ClockDescriptor_default />}
    text={walkDuration}
    descriptorType={"duration" /* Duration */}
    dataQAMarker='qaid-itinerary-stop-card-duration-descriptor'
    {...commonDescriptorProps}
  />
			</Conditional>
			<Conditional if={!!attractionsCount}>
				<Descriptor
    icon={<AttractionDescriptor_default />}
    text={strings.formatString(
      strings.ITINERARY.DESCRIPTORS.ATTRACTIONS_COUNT,
      attractionsCount.toString()
    )}
    descriptorType={"attractions" /* Attractions */}
    dataQAMarker='qaid-itinerary-stop-card-attractions-count-descriptor'
    {...commonDescriptorProps}
  />
			</Conditional>
			<Conditional if={!!activitiesCount}>
				<Descriptor
    icon={<Activities_default />}
    text={strings.formatString(
      strings.ITINERARY.DESCRIPTORS.ACTIVITIES_COUNT,
      activitiesCount.toString()
    )}
    descriptorType={"activities" /* Activities */}
    dataQAMarker='qaid-itinerary-stop-card-activities-count-descriptor'
    {...commonDescriptorProps}
  />
			</Conditional>
			<Conditional if={!!foodTypes}>
				<Descriptor
    icon={(foodTypes == null ? void 0 : foodTypes.label) === "DRINKS" /* Drinks */ ? <Beverage_default /> : <FoodDrinkDescriptor_default />}
    text={foodTypes == null ? void 0 : foodTypes.localisedLabel}
    descriptorType={"foodAndDrinks" /* FoodAndDrinks */}
    dataQAMarker='qaid-itinerary-stop-card-food-and-drinks-descriptor'
    {...commonDescriptorProps}
  />
			</Conditional>
			<Conditional if={!!inclusion}>
				<Descriptor
    icon={getInclusionIcon(inclusion == null ? void 0 : inclusion.label)}
    text={inclusion == null ? void 0 : inclusion.localisedLabel}
    descriptorType={"inclusion" /* Inclusion */}
    dataQAMarker='qaid-itinerary-stop-card-inclusion-descriptor'
    {...commonDescriptorProps}
  />
			</Conditional>
		</div>;
}, "Descriptors");

// src/components/Itinerary/components/TimelineView/components/StopCard/components/Descriptors/components/Descriptor/styles.tsx
var descriptorContainerStylesRecipe = sva16({
  slots: ["container", "text", "iconContainer"],
  base: {
    container: {
      display: "flex",
      alignItems: "center",
      gap: "space.6",
      "& svg": {
        height: "[0.75rem]",
        width: "[0.75rem]",
        marginTop: "space.1",
        "& path": {
          stroke: "var(--color)"
        }
      }
    },
    text: {
      textStyle: "ui.label.regular",
      color: "var(--color)",
      margin: 0
    },
    iconContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  },
  variants: {
    size: {
      ["small" /* Small */]: {
        container: {
          "& svg": {
            height: "[0.75rem]",
            width: "[0.75rem]"
          }
        },
        text: {
          textStyle: "ui.label.small"
        }
      },
      ["large" /* Large */]: {}
    },
    bold: {
      true: {}
    },
    isLocation: {
      true: {
        container: {
          gap: "space.4"
        }
      }
    }
  },
  compoundVariants: [
    {
      bold: true,
      size: "small" /* Small */,
      css: {
        text: {
          textStyle: "ui.label.underline.small.heavy"
        }
      }
    },
    {
      bold: true,
      size: "large" /* Large */,
      css: {
        text: {
          textStyle: "ui.label.underline.regular.heavy"
        }
      }
    }
  ]
});

// src/components/Itinerary/components/TimelineView/components/StopCard/components/Descriptors/components/Descriptor/Descriptor.tsx
import Link2 from "next/link.js";
var Descriptor = /* @__PURE__ */ __name(({
  icon,
  text,
  size = "large" /* Large */,
  color = "core.grey.800",
  bold = false,
  url,
  descriptorTextStyles = {},
  descriptorItemContainerStyles = {},
  onClick,
  descriptorType,
  dataQAMarker
}) => {
  const descriptorContainerStyles = descriptorContainerStylesRecipe.raw({
    size,
    bold,
    isLocation: descriptorType === "location" /* Location */
  });
  const dynamicStyles = {
    "--color": token4(`colors.${color}`)
  };
  const Content = /* @__PURE__ */ __name(() => {
    return <>
				<div className={css7(descriptorContainerStyles.iconContainer)}>
					{icon}
				</div>
				<Text15
      className={css7(
        descriptorContainerStyles.text,
        descriptorTextStyles
      )}
      style={dynamicStyles}
    >
					{text}
				</Text15>
			</>;
  }, "Content");
  const handleClick = /* @__PURE__ */ __name(() => {
    onClick == null ? void 0 : onClick(descriptorType);
  }, "handleClick");
  return <>
			<Conditional if={!!url}>
				<Link2
    href={url}
    onClick={(e) => {
      e.stopPropagation();
      onClick == null ? void 0 : onClick(descriptorType);
    }}
    className={css7(
      descriptorContainerStyles.container,
      descriptorItemContainerStyles
    )}
    style={dynamicStyles}
    target='_blank'
    data-qa-marker={dataQAMarker}
  >
					<Content />
				</Link2>
			</Conditional>
			<Conditional if={!url}>
				<div
    role={onClick ? "button" : "none"}
    className={css7(
      descriptorContainerStyles.container,
      descriptorItemContainerStyles
    )}
    style={dynamicStyles}
    onClick={handleClick}
    onKeyDown={() => null}
    tabIndex={0}
    data-qa-marker={dataQAMarker}
  >
					<Content />
				</div>
			</Conditional>
		</>;
}, "Descriptor");

export {
  useItinerary,
  ANALYTICS_PROPERTIES,
  ANALYTICS_EVENTS,
  nearbyThingsIcon,
  MEDIA_CAROUSEL_IMAGE_LIMIT,
  ITINERARY_STOP_SWIPESHEET_URL_IDENTIFIER,
  ITINERARY_MAP_VIEW_SWIPESHEET_URL_IDENTIFIER,
  sectionDataSanitizer,
  generateGoogleMapUrl,
  generateGoogleMapPlacesUrl,
  isHOHOItinerary,
  isCruiseItinerary,
  isItineraryValid,
  checkIfItineraryHasSameStartAndEndPoint,
  getItineraryAdditionalTrackingPayload,
  toggleItinerarySwipeSheetURLHash,
  getItineraryDuration,
  getItineraryTiming,
  isValidMap,
  headingContainerStylesRecipe,
  ETimelineViewComponentVariant,
  EDescriptorSize,
  EDescriptorType,
  Descriptor,
  Descriptors2 as Descriptors,
  TimelineView2 as TimelineView,
  ItineraryDescriptorsCarousel,
  useItinerary_default,
  blockStylesRecipe,
  ESectionType,
  EChildSectionType,
  EInclusion,
  ESubTypes,
  EModeOfTravelOptions,
  EItineraryViewMode,
  EItineraryType,
  EPlatformName,
  ICONS,
  ANALYTICS_PROPERTIES2,
  ANALYTICS_EVENTS2,
  NumberedMarkerIcon,
  ItineraryMap,
  Itinerary
};
